/*! VelocityJS.org (1.5.0). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
!function(e){"use strict";function t(e){var t=e.length,o=r.type(e);return"function"!==o&&!r.isWindow(e)&&(!(1!==e.nodeType||!t)||("array"===o||0===t||"number"==typeof t&&t>0&&t-1 in e))}if(!e.jQuery){var r=function(e,t){return new r.fn.init(e,t)};r.isWindow=function(e){return e&&e===e.window},r.type=function(e){return e?"object"==typeof e||"function"==typeof e?i[a.call(e)]||"object":typeof e:e+""},r.isArray=Array.isArray||function(e){return"array"===r.type(e)},r.isPlainObject=function(e){var t;if(!e||"object"!==r.type(e)||e.nodeType||r.isWindow(e))return!1;try{if(e.constructor&&!n.call(e,"constructor")&&!n.call(e.constructor.prototype,"isPrototypeOf"))return!1}catch(e){return!1}for(t in e);return void 0===t||n.call(e,t)},r.each=function(e,r,o){var i=0,n=e.length,a=t(e);if(o){if(a)for(;i<n&&!1!==r.apply(e[i],o);i++);else for(i in e)if(e.hasOwnProperty(i)&&!1===r.apply(e[i],o))break}else if(a)for(;i<n&&!1!==r.call(e[i],i,e[i]);i++);else for(i in e)if(e.hasOwnProperty(i)&&!1===r.call(e[i],i,e[i]))break;return e},r.data=function(e,t,i){if(void 0===i){var n=e[r.expando],a=n&&o[n];if(void 0===t)return a;if(a&&t in a)return a[t]}else if(void 0!==t){var s=e[r.expando]||(e[r.expando]=++r.uuid);return o[s]=o[s]||{},o[s][t]=i,i}},r.removeData=function(e,t){var i=e[r.expando],n=i&&o[i];n&&(t?r.each(t,function(e,t){delete n[t]}):delete o[i])},r.extend=function(){var e,t,o,i,n,a,s=arguments[0]||{},l=1,u=arguments.length,c=!1;for("boolean"==typeof s&&(c=s,s=arguments[l]||{},l++),"object"!=typeof s&&"function"!==r.type(s)&&(s={}),l===u&&(s=this,l--);l<u;l++)if(n=arguments[l])for(i in n)n.hasOwnProperty(i)&&(e=s[i],o=n[i],s!==o&&(c&&o&&(r.isPlainObject(o)||(t=r.isArray(o)))?(t?(t=!1,a=e&&r.isArray(e)?e:[]):a=e&&r.isPlainObject(e)?e:{},s[i]=r.extend(c,a,o)):void 0!==o&&(s[i]=o)));return s},r.queue=function(e,o,i){if(e){o=(o||"fx")+"queue";var n=r.data(e,o);return i?(!n||r.isArray(i)?n=r.data(e,o,function(e,r){var o=r||[];return e&&(t(Object(e))?function(e,t){for(var r=+t.length,o=0,i=e.length;o<r;)e[i++]=t[o++];if(r!==r)for(;void 0!==t[o];)e[i++]=t[o++];e.length=i}(o,"string"==typeof e?[e]:e):[].push.call(o,e)),o}(i)):n.push(i),n):n||[]}},r.dequeue=function(e,t){r.each(e.nodeType?[e]:e,function(e,o){t=t||"fx";var i=r.queue(o,t),n=i.shift();"inprogress"===n&&(n=i.shift()),n&&("fx"===t&&i.unshift("inprogress"),n.call(o,function(){r.dequeue(o,t)}))})},r.fn=r.prototype={init:function(e){if(e.nodeType)return this[0]=e,this;throw new Error("Not a DOM node.")},offset:function(){var t=this[0].getBoundingClientRect?this[0].getBoundingClientRect():{top:0,left:0};return{top:t.top+(e.pageYOffset||document.scrollTop||0)-(document.clientTop||0),left:t.left+(e.pageXOffset||document.scrollLeft||0)-(document.clientLeft||0)}},position:function(){var e=this[0],t=function(e){for(var t=e.offsetParent;t&&"html"!==t.nodeName.toLowerCase()&&t.style&&"static"===t.style.position;)t=t.offsetParent;return t||document}(e),o=this.offset(),i=/^(?:body|html)$/i.test(t.nodeName)?{top:0,left:0}:r(t).offset();return o.top-=parseFloat(e.style.marginTop)||0,o.left-=parseFloat(e.style.marginLeft)||0,t.style&&(i.top+=parseFloat(t.style.borderTopWidth)||0,i.left+=parseFloat(t.style.borderLeftWidth)||0),{top:o.top-i.top,left:o.left-i.left}}};var o={};r.expando="velocity"+(new Date).getTime(),r.uuid=0;for(var i={},n=i.hasOwnProperty,a=i.toString,s="Boolean Number String Function Array Date RegExp Object Error".split(" "),l=0;l<s.length;l++)i["[object "+s[l]+"]"]=s[l].toLowerCase();r.fn.init.prototype=r.fn,e.Velocity={Utilities:r}}}(window),function(e){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e():"function"==typeof define&&define.amd?define(e):e()}(function(){"use strict";return function(e,t,r,o){/* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
function i(e){for(var t=-1,r=e?e.length:0,o=[];++t<r;){var i=e[t];i&&o.push(i)}return o}function n(e){return b.isWrapped(e)?e=y.call(e):b.isNode(e)&&(e=[e]),e}function a(e){var t=m.data(e,"velocity");return null===t?o:t}function s(e,t){var r=a(e);r&&r.delayTimer&&!r.delayPaused&&(r.delayRemaining=r.delay-t+r.delayBegin,r.delayPaused=!0,clearTimeout(r.delayTimer.setTimeout))}function l(e,t){var r=a(e);r&&r.delayTimer&&r.delayPaused&&(r.delayPaused=!1,r.delayTimer.setTimeout=setTimeout(r.delayTimer.next,r.delayRemaining))}function u(e){return function(t){return Math.round(t*e)*(1/e)}}/* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
function c(e,r,o,i){function n(e,t){return 1-3*t+3*e}function a(e,t){return 3*t-6*e}function s(e){return 3*e}function l(e,t,r){return((n(t,r)*e+a(t,r))*e+s(t))*e}function u(e,t,r){return 3*n(t,r)*e*e+2*a(t,r)*e+s(t)}function c(t,r){for(var i=0;i<h;++i){var n=u(r,e,o);if(0===n)return r;r-=(l(r,e,o)-t)/n}return r}function p(){for(var t=0;t<w;++t)P[t]=l(t*b,e,o)}function d(t,r,i){var n,a,s=0;do{a=r+(i-r)/2,n=l(a,e,o)-t,n>0?i=a:r=a}while(Math.abs(n)>v&&++s<y);return a}function f(t){for(var r=0,i=1,n=w-1;i!==n&&P[i]<=t;++i)r+=b;--i;var a=(t-P[i])/(P[i+1]-P[i]),s=r+a*b,l=u(s,e,o);return l>=g?c(t,s):0===l?s:d(t,r,r+b)}function m(){C=!0,e===r&&o===i||p()}var h=4,g=.001,v=1e-7,y=10,w=11,b=1/(w-1),x="Float32Array"in t;if(4!==arguments.length)return!1;for(var S=0;S<4;++S)if("number"!=typeof arguments[S]||isNaN(arguments[S])||!isFinite(arguments[S]))return!1;e=Math.min(e,1),o=Math.min(o,1),e=Math.max(e,0),o=Math.max(o,0);var P=x?new Float32Array(w):new Array(w),C=!1,I=function(t){return C||m(),e===r&&o===i?t:0===t?0:1===t?1:l(f(t),r,i)};I.getControlPoints=function(){return[{x:e,y:r},{x:o,y:i}]};var T="generateBezier("+[e,r,o,i]+")";return I.toString=function(){return T},I}function p(e,t){var r=e;return b.isString(e)?C.Easings[e]||(r=!1):r=b.isArray(e)&&1===e.length?u.apply(null,e):b.isArray(e)&&2===e.length?I.apply(null,e.concat([t])):!(!b.isArray(e)||4!==e.length)&&c.apply(null,e),!1===r&&(r=C.Easings[C.defaults.easing]?C.defaults.easing:P),r}function d(e){if(e){var t=C.timestamp&&!0!==e?e:v.now(),r=C.State.calls.length;r>1e4&&(C.State.calls=i(C.State.calls),r=C.State.calls.length);for(var n=0;n<r;n++)if(C.State.calls[n]){var s=C.State.calls[n],l=s[0],u=s[2],c=s[3],p=!!c,g=null,y=s[5],w=s[6];if(c||(c=C.State.calls[n][3]=t-16),y){if(!0!==y.resume)continue;c=s[3]=Math.round(t-w-16),s[5]=null}w=s[6]=t-c;for(var x=Math.min(w/u.duration,1),S=0,P=l.length;S<P;S++){var I=l[S],k=I.element;if(a(k)){var A=!1;if(u.display!==o&&null!==u.display&&"none"!==u.display){if("flex"===u.display){var $=["-webkit-box","-moz-box","-ms-flexbox","-webkit-flex"];m.each($,function(e,t){T.setPropertyValue(k,"display",t)})}T.setPropertyValue(k,"display",u.display)}u.visibility!==o&&"hidden"!==u.visibility&&T.setPropertyValue(k,"visibility",u.visibility);for(var N in I)if(I.hasOwnProperty(N)&&"element"!==N){var E,j=I[N],z=b.isString(j.easing)?C.Easings[j.easing]:j.easing;if(b.isString(j.pattern)){var F=1===x?function(e,t,r){var o=j.endValue[t];return r?Math.round(o):o}:function(e,t,r){var o=j.startValue[t],i=j.endValue[t]-o,n=o+i*z(x,u,i);return r?Math.round(n):n};E=j.pattern.replace(/{(\d+)(!)?}/g,F)}else if(1===x)E=j.endValue;else{var O=j.endValue-j.startValue;E=j.startValue+O*z(x,u,O)}if(!p&&E===j.currentValue)continue;if(j.currentValue=E,"tween"===N)g=E;else{var W;if(T.Hooks.registered[N]){W=T.Hooks.getRoot(N);var L=a(k).rootPropertyValueCache[W];L&&(j.rootPropertyValue=L)}var R=T.setPropertyValue(k,N,j.currentValue+(h<9&&0===parseFloat(E)?"":j.unitType),j.rootPropertyValue,j.scrollData);T.Hooks.registered[N]&&(T.Normalizations.registered[W]?a(k).rootPropertyValueCache[W]=T.Normalizations.registered[W]("extract",null,R[1]):a(k).rootPropertyValueCache[W]=R[1]),"transform"===R[0]&&(A=!0)}}u.mobileHA&&a(k).transformCache.translate3d===o&&(a(k).transformCache.translate3d="(0px, 0px, 0px)",A=!0),A&&T.flushTransformCache(k)}}u.display!==o&&"none"!==u.display&&(C.State.calls[n][2].display=!1),u.visibility!==o&&"hidden"!==u.visibility&&(C.State.calls[n][2].visibility=!1),u.progress&&u.progress.call(s[1],s[1],x,Math.max(0,c+u.duration-t),c,g),1===x&&f(n)}}C.State.isTicking&&V(d)}function f(e,t){if(!C.State.calls[e])return!1;for(var r=C.State.calls[e][0],i=C.State.calls[e][1],n=C.State.calls[e][2],s=C.State.calls[e][4],l=!1,u=0,c=r.length;u<c;u++){var p=r[u].element;t||n.loop||("none"===n.display&&T.setPropertyValue(p,"display",n.display),"hidden"===n.visibility&&T.setPropertyValue(p,"visibility",n.visibility));var d=a(p);if(!0!==n.loop&&(m.queue(p)[1]===o||!/\.velocityQueueEntryFlag/i.test(m.queue(p)[1]))&&d){d.isAnimating=!1,d.rootPropertyValueCache={};var f=!1;m.each(T.Lists.transforms3D,function(e,t){var r=/^scale/.test(t)?1:0,i=d.transformCache[t];d.transformCache[t]!==o&&new RegExp("^\\("+r+"[^.]").test(i)&&(f=!0,delete d.transformCache[t])}),n.mobileHA&&(f=!0,delete d.transformCache.translate3d),f&&T.flushTransformCache(p),T.Values.removeClass(p,"velocity-animating")}if(!t&&n.complete&&!n.loop&&u===c-1)try{n.complete.call(i,i)}catch(e){setTimeout(function(){throw e},1)}s&&!0!==n.loop&&s(i),d&&!0===n.loop&&!t&&(m.each(d.tweensContainer,function(e,t){if(/^rotate/.test(e)&&(parseFloat(t.startValue)-parseFloat(t.endValue))%360==0){var r=t.startValue;t.startValue=t.endValue,t.endValue=r}/^backgroundPosition/.test(e)&&100===parseFloat(t.endValue)&&"%"===t.unitType&&(t.endValue=0,t.startValue=100)}),C(p,"reverse",{loop:!0,delay:n.delay})),!1!==n.queue&&m.dequeue(p,n.queue)}C.State.calls[e]=!1;for(var h=0,g=C.State.calls.length;h<g;h++)if(!1!==C.State.calls[h]){l=!0;break}!1===l&&(C.State.isTicking=!1,delete C.State.calls,C.State.calls=[])}var m,h=function(){if(r.documentMode)return r.documentMode;for(var e=7;e>4;e--){var t=r.createElement("div");if(t.innerHTML="\x3c!--[if IE "+e+"]><span></span><![endif]--\x3e",t.getElementsByTagName("span").length)return t=null,e}return o}(),g=function(){var e=0;return t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||function(t){var r,o=(new Date).getTime();/* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
return r=Math.max(0,16-(o-e)),e=o+r,setTimeout(function(){t(o+r)},r)}}(),v=function(){var e=t.performance||{};if("function"!=typeof e.now){var r=e.timing&&e.timing.navigationStart?e.timing.navigationStart:(new Date).getTime();e.now=function(){return(new Date).getTime()-r}}return e}(),y=function(){var e=Array.prototype.slice;try{return e.call(r.documentElement),e}catch(t){return function(t,r){var o=this.length;if("number"!=typeof t&&(t=0),"number"!=typeof r&&(r=o),this.slice)return e.call(this,t,r);var i,n=[],a=t>=0?t:Math.max(0,o+t),s=r<0?o+r:Math.min(r,o),l=s-a;if(l>0)if(n=new Array(l),this.charAt)for(i=0;i<l;i++)n[i]=this.charAt(a+i);else for(i=0;i<l;i++)n[i]=this[a+i];return n}}}(),w=function(){return Array.prototype.includes?function(e,t){return e.includes(t)}:Array.prototype.indexOf?function(e,t){return e.indexOf(t)>=0}:function(e,t){for(var r=0;r<e.length;r++)if(e[r]===t)return!0;return!1}},b={isNumber:function(e){return"number"==typeof e},isString:function(e){return"string"==typeof e},isArray:Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)},isFunction:function(e){return"[object Function]"===Object.prototype.toString.call(e)},isNode:function(e){return e&&e.nodeType},isWrapped:function(e){return e&&e!==t&&b.isNumber(e.length)&&!b.isString(e)&&!b.isFunction(e)&&!b.isNode(e)&&(0===e.length||b.isNode(e[0]))},isSVG:function(e){return t.SVGElement&&e instanceof t.SVGElement},isEmptyObject:function(e){for(var t in e)if(e.hasOwnProperty(t))return!1;return!0}},x=!1;if(e.fn&&e.fn.jquery?(m=e,x=!0):m=t.Velocity.Utilities,h<=8&&!x)throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");if(h<=7)return void(jQuery.fn.velocity=jQuery.fn.animate);var S=400,P="swing",C={State:{isMobile:/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),isAndroid:/Android/i.test(navigator.userAgent),isGingerbread:/Android 2\.3\.[3-7]/i.test(navigator.userAgent),isChrome:t.chrome,isFirefox:/Firefox/i.test(navigator.userAgent),prefixElement:r.createElement("div"),prefixMatches:{},scrollAnchor:null,scrollPropertyLeft:null,scrollPropertyTop:null,isTicking:!1,calls:[],delayedElements:{count:0}},CSS:{},Utilities:m,Redirects:{},Easings:{},Promise:t.Promise,defaults:{queue:"",duration:S,easing:P,begin:o,complete:o,progress:o,display:o,visibility:o,loop:!1,delay:!1,mobileHA:!0,_cacheValues:!0,promiseRejectEmpty:!0},init:function(e){m.data(e,"velocity",{isSVG:b.isSVG(e),isAnimating:!1,computedStyle:null,tweensContainer:null,rootPropertyValueCache:{},transformCache:{}})},hook:null,mock:!1,version:{major:1,minor:5,patch:0},debug:!1,timestamp:!0,pauseAll:function(e){var t=(new Date).getTime();m.each(C.State.calls,function(t,r){if(r){if(e!==o&&(r[2].queue!==e||!1===r[2].queue))return!0;r[5]={resume:!1}}}),m.each(C.State.delayedElements,function(e,r){r&&s(r,t)})},resumeAll:function(e){var t=(new Date).getTime();m.each(C.State.calls,function(t,r){if(r){if(e!==o&&(r[2].queue!==e||!1===r[2].queue))return!0;r[5]&&(r[5].resume=!0)}}),m.each(C.State.delayedElements,function(e,r){r&&l(r,t)})}};t.pageYOffset!==o?(C.State.scrollAnchor=t,C.State.scrollPropertyLeft="pageXOffset",C.State.scrollPropertyTop="pageYOffset"):(C.State.scrollAnchor=r.documentElement||r.body.parentNode||r.body,C.State.scrollPropertyLeft="scrollLeft",C.State.scrollPropertyTop="scrollTop");/* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
/* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
		 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
var I=function(){function e(e){return-e.tension*e.x-e.friction*e.v}function t(t,r,o){var i={x:t.x+o.dx*r,v:t.v+o.dv*r,tension:t.tension,friction:t.friction};return{dx:i.v,dv:e(i)}}function r(r,o){var i={dx:r.v,dv:e(r)},n=t(r,.5*o,i),a=t(r,.5*o,n),s=t(r,o,a),l=1/6*(i.dx+2*(n.dx+a.dx)+s.dx),u=1/6*(i.dv+2*(n.dv+a.dv)+s.dv);return r.x=r.x+l*o,r.v=r.v+u*o,r}return function e(t,o,i){var n,a,s,l={x:-1,v:0,tension:null,friction:null},u=[0],c=0;for(t=parseFloat(t)||500,o=parseFloat(o)||20,i=i||null,l.tension=t,l.friction=o,n=null!==i,n?(c=e(t,o),a=c/i*.016):a=.016;;)if(s=r(s||l,a),u.push(1+s.x),c+=16,!(Math.abs(s.x)>1e-4&&Math.abs(s.v)>1e-4))break;return n?function(e){return u[e*(u.length-1)|0]}:c}}();C.Easings={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},spring:function(e){return 1-Math.cos(4.5*e*Math.PI)*Math.exp(6*-e)}},m.each([["ease",[.25,.1,.25,1]],["ease-in",[.42,0,1,1]],["ease-out",[0,0,.58,1]],["ease-in-out",[.42,0,.58,1]],["easeInSine",[.47,0,.745,.715]],["easeOutSine",[.39,.575,.565,1]],["easeInOutSine",[.445,.05,.55,.95]],["easeInQuad",[.55,.085,.68,.53]],["easeOutQuad",[.25,.46,.45,.94]],["easeInOutQuad",[.455,.03,.515,.955]],["easeInCubic",[.55,.055,.675,.19]],["easeOutCubic",[.215,.61,.355,1]],["easeInOutCubic",[.645,.045,.355,1]],["easeInQuart",[.895,.03,.685,.22]],["easeOutQuart",[.165,.84,.44,1]],["easeInOutQuart",[.77,0,.175,1]],["easeInQuint",[.755,.05,.855,.06]],["easeOutQuint",[.23,1,.32,1]],["easeInOutQuint",[.86,0,.07,1]],["easeInExpo",[.95,.05,.795,.035]],["easeOutExpo",[.19,1,.22,1]],["easeInOutExpo",[1,0,0,1]],["easeInCirc",[.6,.04,.98,.335]],["easeOutCirc",[.075,.82,.165,1]],["easeInOutCirc",[.785,.135,.15,.86]]],function(e,t){C.Easings[t[0]]=c.apply(null,t[1])});var T=C.CSS={RegEx:{isHex:/^#([A-f\d]{3}){1,2}$/i,valueUnwrap:/^[A-z]+\((.*)\)$/i,wrappedValueAlreadyExtracted:/[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,valueSplit:/([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi},Lists:{colors:["fill","stroke","stopColor","color","backgroundColor","borderColor","borderTopColor","borderRightColor","borderBottomColor","borderLeftColor","outlineColor"],transformsBase:["translateX","translateY","scale","scaleX","scaleY","skewX","skewY","rotateZ"],transforms3D:["transformPerspective","translateZ","scaleZ","rotateX","rotateY"],units:["%","em","ex","ch","rem","vw","vh","vmin","vmax","cm","mm","Q","in","pc","pt","px","deg","grad","rad","turn","s","ms"],colorNames:{aliceblue:"240,248,255",antiquewhite:"250,235,215",aquamarine:"127,255,212",aqua:"0,255,255",azure:"240,255,255",beige:"245,245,220",bisque:"255,228,196",black:"0,0,0",blanchedalmond:"255,235,205",blueviolet:"138,43,226",blue:"0,0,255",brown:"165,42,42",burlywood:"222,184,135",cadetblue:"95,158,160",chartreuse:"127,255,0",chocolate:"210,105,30",coral:"255,127,80",cornflowerblue:"100,149,237",cornsilk:"255,248,220",crimson:"220,20,60",cyan:"0,255,255",darkblue:"0,0,139",darkcyan:"0,139,139",darkgoldenrod:"184,134,11",darkgray:"169,169,169",darkgrey:"169,169,169",darkgreen:"0,100,0",darkkhaki:"189,183,107",darkmagenta:"139,0,139",darkolivegreen:"85,107,47",darkorange:"255,140,0",darkorchid:"153,50,204",darkred:"139,0,0",darksalmon:"233,150,122",darkseagreen:"143,188,143",darkslateblue:"72,61,139",darkslategray:"47,79,79",darkturquoise:"0,206,209",darkviolet:"148,0,211",deeppink:"255,20,147",deepskyblue:"0,191,255",dimgray:"105,105,105",dimgrey:"105,105,105",dodgerblue:"30,144,255",firebrick:"178,34,34",floralwhite:"255,250,240",forestgreen:"34,139,34",fuchsia:"255,0,255",gainsboro:"220,220,220",ghostwhite:"248,248,255",gold:"255,215,0",goldenrod:"218,165,32",gray:"128,128,128",grey:"128,128,128",greenyellow:"173,255,47",green:"0,128,0",honeydew:"240,255,240",hotpink:"255,105,180",indianred:"205,92,92",indigo:"75,0,130",ivory:"255,255,240",khaki:"240,230,140",lavenderblush:"255,240,245",lavender:"230,230,250",lawngreen:"124,252,0",lemonchiffon:"255,250,205",lightblue:"173,216,230",lightcoral:"240,128,128",lightcyan:"224,255,255",lightgoldenrodyellow:"250,250,210",lightgray:"211,211,211",lightgrey:"211,211,211",lightgreen:"144,238,144",lightpink:"255,182,193",lightsalmon:"255,160,122",lightseagreen:"32,178,170",lightskyblue:"135,206,250",lightslategray:"119,136,153",lightsteelblue:"176,196,222",lightyellow:"255,255,224",limegreen:"50,205,50",lime:"0,255,0",linen:"250,240,230",magenta:"255,0,255",maroon:"128,0,0",mediumaquamarine:"102,205,170",mediumblue:"0,0,205",mediumorchid:"186,85,211",mediumpurple:"147,112,219",mediumseagreen:"60,179,113",mediumslateblue:"123,104,238",mediumspringgreen:"0,250,154",mediumturquoise:"72,209,204",mediumvioletred:"199,21,133",midnightblue:"25,25,112",mintcream:"245,255,250",mistyrose:"255,228,225",moccasin:"255,228,181",navajowhite:"255,222,173",navy:"0,0,128",oldlace:"253,245,230",olivedrab:"107,142,35",olive:"128,128,0",orangered:"255,69,0",orange:"255,165,0",orchid:"218,112,214",palegoldenrod:"238,232,170",palegreen:"152,251,152",paleturquoise:"175,238,238",palevioletred:"219,112,147",papayawhip:"255,239,213",peachpuff:"255,218,185",peru:"205,133,63",pink:"255,192,203",plum:"221,160,221",powderblue:"176,224,230",purple:"128,0,128",red:"255,0,0",rosybrown:"188,143,143",royalblue:"65,105,225",saddlebrown:"139,69,19",salmon:"250,128,114",sandybrown:"244,164,96",seagreen:"46,139,87",seashell:"255,245,238",sienna:"160,82,45",silver:"192,192,192",skyblue:"135,206,235",slateblue:"106,90,205",slategray:"112,128,144",snow:"255,250,250",springgreen:"0,255,127",steelblue:"70,130,180",tan:"210,180,140",teal:"0,128,128",thistle:"216,191,216",tomato:"255,99,71",turquoise:"64,224,208",violet:"238,130,238",wheat:"245,222,179",whitesmoke:"245,245,245",white:"255,255,255",yellowgreen:"154,205,50",yellow:"255,255,0"}},Hooks:{templates:{textShadow:["Color X Y Blur","black 0px 0px 0px"],boxShadow:["Color X Y Blur Spread","black 0px 0px 0px 0px"],clip:["Top Right Bottom Left","0px 0px 0px 0px"],backgroundPosition:["X Y","0% 0%"],transformOrigin:["X Y Z","50% 50% 0px"],perspectiveOrigin:["X Y","50% 50%"]},registered:{},register:function(){for(var e=0;e<T.Lists.colors.length;e++){var t="color"===T.Lists.colors[e]?"0 0 0 1":"255 255 255 1";T.Hooks.templates[T.Lists.colors[e]]=["Red Green Blue Alpha",t]}var r,o,i;if(h)for(r in T.Hooks.templates)if(T.Hooks.templates.hasOwnProperty(r)){o=T.Hooks.templates[r],i=o[0].split(" ");var n=o[1].match(T.RegEx.valueSplit);"Color"===i[0]&&(i.push(i.shift()),n.push(n.shift()),T.Hooks.templates[r]=[i.join(" "),n.join(" ")])}for(r in T.Hooks.templates)if(T.Hooks.templates.hasOwnProperty(r)){o=T.Hooks.templates[r],i=o[0].split(" ");for(var a in i)if(i.hasOwnProperty(a)){var s=r+i[a],l=a;T.Hooks.registered[s]=[r,l]}}},getRoot:function(e){var t=T.Hooks.registered[e];return t?t[0]:e},getUnit:function(e,t){var r=(e.substr(t||0,5).match(/^[a-z%]+/)||[])[0]||"";return r&&w(T.Lists.units,r)?r:""},fixColors:function(e){return e.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g,function(e,t,r){return T.Lists.colorNames.hasOwnProperty(r)?(t||"rgba(")+T.Lists.colorNames[r]+(t?"":",1)"):t+r})},cleanRootPropertyValue:function(e,t){return T.RegEx.valueUnwrap.test(t)&&(t=t.match(T.RegEx.valueUnwrap)[1]),T.Values.isCSSNullValue(t)&&(t=T.Hooks.templates[e][1]),t},extractValue:function(e,t){var r=T.Hooks.registered[e];if(r){var o=r[0],i=r[1];return t=T.Hooks.cleanRootPropertyValue(o,t),t.toString().match(T.RegEx.valueSplit)[i]}return t},injectValue:function(e,t,r){var o=T.Hooks.registered[e];if(o){var i,n=o[0],a=o[1];return r=T.Hooks.cleanRootPropertyValue(n,r),i=r.toString().match(T.RegEx.valueSplit),i[a]=t,i.join(" ")}return r}},Normalizations:{registered:{clip:function(e,t,r){switch(e){case"name":return"clip";case"extract":var o;return T.RegEx.wrappedValueAlreadyExtracted.test(r)?o=r:(o=r.toString().match(T.RegEx.valueUnwrap),o=o?o[1].replace(/,(\s+)?/g," "):r),o;case"inject":return"rect("+r+")"}},blur:function(e,t,r){switch(e){case"name":return C.State.isFirefox?"filter":"-webkit-filter";case"extract":var o=parseFloat(r);if(!o&&0!==o){var i=r.toString().match(/blur\(([0-9]+[A-z]+)\)/i);o=i?i[1]:0}return o;case"inject":return parseFloat(r)?"blur("+r+")":"none"}},opacity:function(e,t,r){if(h<=8)switch(e){case"name":return"filter";case"extract":var o=r.toString().match(/alpha\(opacity=(.*)\)/i);return r=o?o[1]/100:1;case"inject":return t.style.zoom=1,parseFloat(r)>=1?"":"alpha(opacity="+parseInt(100*parseFloat(r),10)+")"}else switch(e){case"name":return"opacity";case"extract":case"inject":return r}}},register:function(){function e(e,t,r){if("border-box"===T.getPropertyValue(t,"boxSizing").toString().toLowerCase()===(r||!1)){var o,i,n=0,a="width"===e?["Left","Right"]:["Top","Bottom"],s=["padding"+a[0],"padding"+a[1],"border"+a[0]+"Width","border"+a[1]+"Width"];for(o=0;o<s.length;o++)i=parseFloat(T.getPropertyValue(t,s[o])),isNaN(i)||(n+=i);return r?-n:n}return 0}function t(t,r){return function(o,i,n){switch(o){case"name":return t;case"extract":return parseFloat(n)+e(t,i,r);case"inject":return parseFloat(n)-e(t,i,r)+"px"}}}h&&!(h>9)||C.State.isGingerbread||(T.Lists.transformsBase=T.Lists.transformsBase.concat(T.Lists.transforms3D));for(var r=0;r<T.Lists.transformsBase.length;r++)!function(){var e=T.Lists.transformsBase[r];T.Normalizations.registered[e]=function(t,r,i){switch(t){case"name":return"transform";case"extract":return a(r)===o||a(r).transformCache[e]===o?/^scale/i.test(e)?1:0:a(r).transformCache[e].replace(/[()]/g,"");case"inject":var n=!1;switch(e.substr(0,e.length-1)){case"translate":n=!/(%|px|em|rem|vw|vh|\d)$/i.test(i);break;case"scal":case"scale":C.State.isAndroid&&a(r).transformCache[e]===o&&i<1&&(i=1),n=!/(\d)$/i.test(i);break;case"skew":case"rotate":n=!/(deg|\d)$/i.test(i)}return n||(a(r).transformCache[e]="("+i+")"),a(r).transformCache[e]}}}();for(var i=0;i<T.Lists.colors.length;i++)!function(){var e=T.Lists.colors[i];T.Normalizations.registered[e]=function(t,r,i){switch(t){case"name":return e;case"extract":var n;if(T.RegEx.wrappedValueAlreadyExtracted.test(i))n=i;else{var a,s={black:"rgb(0, 0, 0)",blue:"rgb(0, 0, 255)",gray:"rgb(128, 128, 128)",green:"rgb(0, 128, 0)",red:"rgb(255, 0, 0)",white:"rgb(255, 255, 255)"};/^[A-z]+$/i.test(i)?a=s[i]!==o?s[i]:s.black:T.RegEx.isHex.test(i)?a="rgb("+T.Values.hexToRgb(i).join(" ")+")":/^rgba?\(/i.test(i)||(a=s.black),n=(a||i).toString().match(T.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g," ")}return(!h||h>8)&&3===n.split(" ").length&&(n+=" 1"),n;case"inject":return/^rgb/.test(i)?i:(h<=8?4===i.split(" ").length&&(i=i.split(/\s+/).slice(0,3).join(" ")):3===i.split(" ").length&&(i+=" 1"),(h<=8?"rgb":"rgba")+"("+i.replace(/\s+/g,",").replace(/\.(\d)+(?=,)/g,"")+")")}}}();T.Normalizations.registered.innerWidth=t("width",!0),T.Normalizations.registered.innerHeight=t("height",!0),T.Normalizations.registered.outerWidth=t("width"),T.Normalizations.registered.outerHeight=t("height")}},Names:{camelCase:function(e){return e.replace(/-(\w)/g,function(e,t){return t.toUpperCase()})},SVGAttribute:function(e){var t="width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";return(h||C.State.isAndroid&&!C.State.isChrome)&&(t+="|transform"),new RegExp("^("+t+")$","i").test(e)},prefixCheck:function(e){if(C.State.prefixMatches[e])return[C.State.prefixMatches[e],!0];for(var t=["","Webkit","Moz","ms","O"],r=0,o=t.length;r<o;r++){var i;if(i=0===r?e:t[r]+e.replace(/^\w/,function(e){return e.toUpperCase()}),b.isString(C.State.prefixElement.style[i]))return C.State.prefixMatches[e]=i,[i,!0]}return[e,!1]}},Values:{/* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
hexToRgb:function(e){var t,r=/^#?([a-f\d])([a-f\d])([a-f\d])$/i,o=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;return e=e.replace(r,function(e,t,r,o){return t+t+r+r+o+o}),t=o.exec(e),t?[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]:[0,0,0]},isCSSNullValue:function(e){return!e||/^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(e)},getUnitType:function(e){return/^(rotate|skew)/i.test(e)?"deg":/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(e)?"":"px"},getDisplayType:function(e){var t=e&&e.tagName.toString().toLowerCase();return/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(t)?"inline":/^(li)$/i.test(t)?"list-item":/^(tr)$/i.test(t)?"table-row":/^(table)$/i.test(t)?"table":/^(tbody)$/i.test(t)?"table-row-group":"block"},addClass:function(e,t){if(e)if(e.classList)e.classList.add(t);else if(b.isString(e.className))e.className+=(e.className.length?" ":"")+t;else{var r=e.getAttribute(h<=7?"className":"class")||"";e.setAttribute("class",r+(r?" ":"")+t)}},removeClass:function(e,t){if(e)if(e.classList)e.classList.remove(t);else if(b.isString(e.className))e.className=e.className.toString().replace(new RegExp("(^|\\s)"+t.split(" ").join("|")+"(\\s|$)","gi")," ");else{var r=e.getAttribute(h<=7?"className":"class")||"";e.setAttribute("class",r.replace(new RegExp("(^|s)"+t.split(" ").join("|")+"(s|$)","gi")," "))}}},getPropertyValue:function(e,r,i,n){function s(e,r){var i=0;if(h<=8)i=m.css(e,r);else{var l=!1;/^(width|height)$/.test(r)&&0===T.getPropertyValue(e,"display")&&(l=!0,T.setPropertyValue(e,"display",T.Values.getDisplayType(e)));var u=function(){l&&T.setPropertyValue(e,"display","none")};if(!n){if("height"===r&&"border-box"!==T.getPropertyValue(e,"boxSizing").toString().toLowerCase()){var c=e.offsetHeight-(parseFloat(T.getPropertyValue(e,"borderTopWidth"))||0)-(parseFloat(T.getPropertyValue(e,"borderBottomWidth"))||0)-(parseFloat(T.getPropertyValue(e,"paddingTop"))||0)-(parseFloat(T.getPropertyValue(e,"paddingBottom"))||0);return u(),c}if("width"===r&&"border-box"!==T.getPropertyValue(e,"boxSizing").toString().toLowerCase()){var p=e.offsetWidth-(parseFloat(T.getPropertyValue(e,"borderLeftWidth"))||0)-(parseFloat(T.getPropertyValue(e,"borderRightWidth"))||0)-(parseFloat(T.getPropertyValue(e,"paddingLeft"))||0)-(parseFloat(T.getPropertyValue(e,"paddingRight"))||0);return u(),p}}var d;d=a(e)===o?t.getComputedStyle(e,null):a(e).computedStyle?a(e).computedStyle:a(e).computedStyle=t.getComputedStyle(e,null),"borderColor"===r&&(r="borderTopColor"),i=9===h&&"filter"===r?d.getPropertyValue(r):d[r],""!==i&&null!==i||(i=e.style[r]),u()}if("auto"===i&&/^(top|right|bottom|left)$/i.test(r)){var f=s(e,"position");("fixed"===f||"absolute"===f&&/top|left/i.test(r))&&(i=m(e).position()[r]+"px")}return i}var l;if(T.Hooks.registered[r]){var u=r,c=T.Hooks.getRoot(u);i===o&&(i=T.getPropertyValue(e,T.Names.prefixCheck(c)[0])),T.Normalizations.registered[c]&&(i=T.Normalizations.registered[c]("extract",e,i)),l=T.Hooks.extractValue(u,i)}else if(T.Normalizations.registered[r]){var p,d;p=T.Normalizations.registered[r]("name",e),"transform"!==p&&(d=s(e,T.Names.prefixCheck(p)[0]),T.Values.isCSSNullValue(d)&&T.Hooks.templates[r]&&(d=T.Hooks.templates[r][1])),l=T.Normalizations.registered[r]("extract",e,d)}if(!/^[\d-]/.test(l)){var f=a(e);if(f&&f.isSVG&&T.Names.SVGAttribute(r))if(/^(height|width)$/i.test(r))try{l=e.getBBox()[r]}catch(e){l=0}else l=e.getAttribute(r);else l=s(e,T.Names.prefixCheck(r)[0])}return T.Values.isCSSNullValue(l)&&(l=0),C.debug>=2&&console.log("Get "+r+": "+l),l},setPropertyValue:function(e,r,o,i,n){var s=r;if("scroll"===r)n.container?n.container["scroll"+n.direction]=o:"Left"===n.direction?t.scrollTo(o,n.alternateValue):t.scrollTo(n.alternateValue,o);else if(T.Normalizations.registered[r]&&"transform"===T.Normalizations.registered[r]("name",e))T.Normalizations.registered[r]("inject",e,o),s="transform",o=a(e).transformCache[r];else{if(T.Hooks.registered[r]){var l=r,u=T.Hooks.getRoot(r);i=i||T.getPropertyValue(e,u),o=T.Hooks.injectValue(l,o,i),r=u}if(T.Normalizations.registered[r]&&(o=T.Normalizations.registered[r]("inject",e,o),r=T.Normalizations.registered[r]("name",e)),s=T.Names.prefixCheck(r)[0],h<=8)try{e.style[s]=o}catch(e){C.debug&&console.log("Browser does not support ["+o+"] for ["+s+"]")}else{var c=a(e);c&&c.isSVG&&T.Names.SVGAttribute(r)?e.setAttribute(r,o):e.style[s]=o}C.debug>=2&&console.log("Set "+r+" ("+s+"): "+o)}return[s,o]},flushTransformCache:function(e){var t="",r=a(e);if((h||C.State.isAndroid&&!C.State.isChrome)&&r&&r.isSVG){var o=function(t){return parseFloat(T.getPropertyValue(e,t))},i={translate:[o("translateX"),o("translateY")],skewX:[o("skewX")],skewY:[o("skewY")],scale:1!==o("scale")?[o("scale"),o("scale")]:[o("scaleX"),o("scaleY")],rotate:[o("rotateZ"),0,0]};m.each(a(e).transformCache,function(e){/^translate/i.test(e)?e="translate":/^scale/i.test(e)?e="scale":/^rotate/i.test(e)&&(e="rotate"),i[e]&&(t+=e+"("+i[e].join(" ")+") ",delete i[e])})}else{var n,s;m.each(a(e).transformCache,function(r){if(n=a(e).transformCache[r],"transformPerspective"===r)return s=n,!0;9===h&&"rotateZ"===r&&(r="rotate"),t+=r+n+" "}),s&&(t="perspective"+s+" "+t)}T.setPropertyValue(e,"transform",t)}};T.Hooks.register(),T.Normalizations.register(),C.hook=function(e,t,r){var i;return e=n(e),m.each(e,function(e,n){if(a(n)===o&&C.init(n),r===o)i===o&&(i=T.getPropertyValue(n,t));else{var s=T.setPropertyValue(n,t,r);"transform"===s[0]&&C.CSS.flushTransformCache(n),i=s}}),i};var k=function(){function e(){return c?I.promise||null:h}function i(e,i){function n(n){var c,f;if(l.begin&&0===A)try{l.begin.call(v,v)}catch(e){setTimeout(function(){throw e},1)}if("scroll"===E){var h,g,S,P=/^x$/i.test(l.axis)?"Left":"Top",k=parseFloat(l.offset)||0;l.container?b.isWrapped(l.container)||b.isNode(l.container)?(l.container=l.container[0]||l.container,h=l.container["scroll"+P],S=h+m(e).position()[P.toLowerCase()]+k):l.container=null:(h=C.State.scrollAnchor[C.State["scrollProperty"+P]],g=C.State.scrollAnchor[C.State["scrollProperty"+("Left"===P?"Top":"Left")]],S=m(e).offset()[P.toLowerCase()]+k),u={scroll:{rootPropertyValue:!1,startValue:h,currentValue:h,endValue:S,unitType:"",easing:l.easing,scrollData:{container:l.container,direction:P,alternateValue:g}},element:e},C.debug&&console.log("tweensContainer (scroll): ",u.scroll,e)}else if("reverse"===E){if(!(c=a(e)))return;if(!c.tweensContainer)return void m.dequeue(e,l.queue);"none"===c.opts.display&&(c.opts.display="auto"),"hidden"===c.opts.visibility&&(c.opts.visibility="visible"),c.opts.loop=!1,c.opts.begin=null,c.opts.complete=null,x.easing||delete l.easing,x.duration||delete l.duration,l=m.extend({},c.opts,l),f=m.extend(!0,{},c?c.tweensContainer:null);for(var $ in f)if(f.hasOwnProperty($)&&"element"!==$){var N=f[$].startValue;f[$].startValue=f[$].currentValue=f[$].endValue,f[$].endValue=N,b.isEmptyObject(x)||(f[$].easing=l.easing),C.debug&&console.log("reverse tweensContainer ("+$+"): "+JSON.stringify(f[$]),e)}u=f}else if("start"===E){c=a(e),c&&c.tweensContainer&&!0===c.isAnimating&&(f=c.tweensContainer);var j=function(i,n){var a,p=T.Hooks.getRoot(i),d=!1,h=n[0],g=n[1],v=n[2];if(!(c&&c.isSVG||"tween"===p||!1!==T.Names.prefixCheck(p)[1]||T.Normalizations.registered[p]!==o))return void(C.debug&&console.log("Skipping ["+p+"] due to a lack of browser support."));(l.display!==o&&null!==l.display&&"none"!==l.display||l.visibility!==o&&"hidden"!==l.visibility)&&/opacity|filter/.test(i)&&!v&&0!==h&&(v=0),l._cacheValues&&f&&f[i]?(v===o&&(v=f[i].endValue+f[i].unitType),d=c.rootPropertyValueCache[p]):T.Hooks.registered[i]?v===o?(d=T.getPropertyValue(e,p),v=T.getPropertyValue(e,i,d)):d=T.Hooks.templates[p][1]:v===o&&(v=T.getPropertyValue(e,i));var y,w,x,S=!1,P=function(e,t){var r,o;return o=(t||"0").toString().toLowerCase().replace(/[%A-z]+$/,function(e){return r=e,""}),r||(r=T.Values.getUnitType(e)),[o,r]};if(v!==h&&b.isString(v)&&b.isString(h)){a="";var I=0,k=0,V=[],A=[],$=0,N=0,E=0;for(v=T.Hooks.fixColors(v),h=T.Hooks.fixColors(h);I<v.length&&k<h.length;){var j=v[I],z=h[k];if(/[\d\.-]/.test(j)&&/[\d\.-]/.test(z)){for(var F=j,O=z,W=".",R=".";++I<v.length;){if((j=v[I])===W)W="..";else if(!/\d/.test(j))break;F+=j}for(;++k<h.length;){if((z=h[k])===R)R="..";else if(!/\d/.test(z))break;O+=z}var H=T.Hooks.getUnit(v,I),M=T.Hooks.getUnit(h,k);if(I+=H.length,k+=M.length,H===M)F===O?a+=F+H:(a+="{"+V.length+(N?"!":"")+"}"+H,V.push(parseFloat(F)),A.push(parseFloat(O)));else{var D=parseFloat(F),q=parseFloat(O);a+=($<5?"calc":"")+"("+(D?"{"+V.length+(N?"!":"")+"}":"0")+H+" + "+(q?"{"+(V.length+(D?1:0))+(N?"!":"")+"}":"0")+M+")",D&&(V.push(D),A.push(0)),q&&(V.push(0),A.push(q))}}else{if(j!==z){$=0;break}a+=j,I++,k++,0===$&&"c"===j||1===$&&"a"===j||2===$&&"l"===j||3===$&&"c"===j||$>=4&&"("===j?$++:($&&$<5||$>=4&&")"===j&&--$<5)&&($=0),0===N&&"r"===j||1===N&&"g"===j||2===N&&"b"===j||3===N&&"a"===j||N>=3&&"("===j?(3===N&&"a"===j&&(E=1),N++):E&&","===j?++E>3&&(N=E=0):(E&&N<(E?5:4)||N>=(E?4:3)&&")"===j&&--N<(E?5:4))&&(N=E=0)}}I===v.length&&k===h.length||(C.debug&&console.error('Trying to pattern match mis-matched strings ["'+h+'", "'+v+'"]'),a=o),a&&(V.length?(C.debug&&console.log('Pattern found "'+a+'" -> ',V,A,"["+v+","+h+"]"),v=V,h=A,w=x=""):a=o)}a||(y=P(i,v),v=y[0],x=y[1],y=P(i,h),h=y[0].replace(/^([+-\/*])=/,function(e,t){return S=t,""}),w=y[1],v=parseFloat(v)||0,h=parseFloat(h)||0,"%"===w&&(/^(fontSize|lineHeight)$/.test(i)?(h/=100,w="em"):/^scale/.test(i)?(h/=100,w=""):/(Red|Green|Blue)$/i.test(i)&&(h=h/100*255,w="")));if(/[\/*]/.test(S))w=x;else if(x!==w&&0!==v)if(0===h)w=x;else{s=s||function(){var o={myParent:e.parentNode||r.body,position:T.getPropertyValue(e,"position"),fontSize:T.getPropertyValue(e,"fontSize")},i=o.position===L.lastPosition&&o.myParent===L.lastParent,n=o.fontSize===L.lastFontSize;L.lastParent=o.myParent,L.lastPosition=o.position,L.lastFontSize=o.fontSize;var a={};if(n&&i)a.emToPx=L.lastEmToPx,a.percentToPxWidth=L.lastPercentToPxWidth,a.percentToPxHeight=L.lastPercentToPxHeight;else{var s=c&&c.isSVG?r.createElementNS("http://www.w3.org/2000/svg","rect"):r.createElement("div");C.init(s),o.myParent.appendChild(s),m.each(["overflow","overflowX","overflowY"],function(e,t){C.CSS.setPropertyValue(s,t,"hidden")}),C.CSS.setPropertyValue(s,"position",o.position),C.CSS.setPropertyValue(s,"fontSize",o.fontSize),C.CSS.setPropertyValue(s,"boxSizing","content-box"),m.each(["minWidth","maxWidth","width","minHeight","maxHeight","height"],function(e,t){C.CSS.setPropertyValue(s,t,"100%")}),C.CSS.setPropertyValue(s,"paddingLeft","100em"),a.percentToPxWidth=L.lastPercentToPxWidth=(parseFloat(T.getPropertyValue(s,"width",null,!0))||1)/100,a.percentToPxHeight=L.lastPercentToPxHeight=(parseFloat(T.getPropertyValue(s,"height",null,!0))||1)/100,a.emToPx=L.lastEmToPx=(parseFloat(T.getPropertyValue(s,"paddingLeft"))||1)/100,o.myParent.removeChild(s)}return null===L.remToPx&&(L.remToPx=parseFloat(T.getPropertyValue(r.body,"fontSize"))||16),null===L.vwToPx&&(L.vwToPx=parseFloat(t.innerWidth)/100,L.vhToPx=parseFloat(t.innerHeight)/100),a.remToPx=L.remToPx,a.vwToPx=L.vwToPx,a.vhToPx=L.vhToPx,C.debug>=1&&console.log("Unit ratios: "+JSON.stringify(a),e),a}();var B=/margin|padding|left|right|width|text|word|letter/i.test(i)||/X$/.test(i)||"x"===i?"x":"y";switch(x){case"%":v*="x"===B?s.percentToPxWidth:s.percentToPxHeight;break;case"px":break;default:v*=s[x+"ToPx"]}switch(w){case"%":v*=1/("x"===B?s.percentToPxWidth:s.percentToPxHeight);break;case"px":break;default:v*=1/s[w+"ToPx"]}}switch(S){case"+":h=v+h;break;case"-":h=v-h;break;case"*":h*=v;break;case"/":h=v/h}u[i]={rootPropertyValue:d,startValue:v,currentValue:v,endValue:h,unitType:w,easing:g},a&&(u[i].pattern=a),C.debug&&console.log("tweensContainer ("+i+"): "+JSON.stringify(u[i]),e)};for(var z in y)if(y.hasOwnProperty(z)){var F=T.Names.camelCase(z),O=function(t,r){var o,n,a;return b.isFunction(t)&&(t=t.call(e,i,V)),b.isArray(t)?(o=t[0],!b.isArray(t[1])&&/^[\d-]/.test(t[1])||b.isFunction(t[1])||T.RegEx.isHex.test(t[1])?a=t[1]:b.isString(t[1])&&!T.RegEx.isHex.test(t[1])&&C.Easings[t[1]]||b.isArray(t[1])?(n=r?t[1]:p(t[1],l.duration),a=t[2]):a=t[1]||t[2]):o=t,r||(n=n||l.easing),b.isFunction(o)&&(o=o.call(e,i,V)),b.isFunction(a)&&(a=a.call(e,i,V)),[o||0,n,a]}(y[z]);if(w(T.Lists.colors,F)){var W=O[0],H=O[1],M=O[2];if(T.RegEx.isHex.test(W)){for(var D=["Red","Green","Blue"],q=T.Values.hexToRgb(W),B=M?T.Values.hexToRgb(M):o,X=0;X<D.length;X++){var U=[q[X]];H&&U.push(H),B!==o&&U.push(B[X]),j(F+D[X],U)}continue}}j(F,O)}u.element=e}u.element&&(T.Values.addClass(e,"velocity-animating"),R.push(u),c=a(e),c&&(""===l.queue&&(c.tweensContainer=u,c.opts=l),c.isAnimating=!0),A===V-1?(C.State.calls.push([R,v,l,null,I.resolver,null,0]),!1===C.State.isTicking&&(C.State.isTicking=!0,d())):A++)}var s,l=m.extend({},C.defaults,x),u={};switch(a(e)===o&&C.init(e),parseFloat(l.delay)&&!1!==l.queue&&m.queue(e,l.queue,function(t){C.velocityQueueEntryFlag=!0;var r=C.State.delayedElements.count++;C.State.delayedElements[r]=e;var o=function(e){return function(){C.State.delayedElements[e]=!1,t()}}(r);a(e).delayBegin=(new Date).getTime(),a(e).delay=parseFloat(l.delay),a(e).delayTimer={setTimeout:setTimeout(t,parseFloat(l.delay)),next:o}}),l.duration.toString().toLowerCase()){case"fast":l.duration=200;break;case"normal":l.duration=S;break;case"slow":l.duration=600;break;default:l.duration=parseFloat(l.duration)||1}if(!1!==C.mock&&(!0===C.mock?l.duration=l.delay=1:(l.duration*=parseFloat(C.mock)||1,l.delay*=parseFloat(C.mock)||1)),l.easing=p(l.easing,l.duration),l.begin&&!b.isFunction(l.begin)&&(l.begin=null),l.progress&&!b.isFunction(l.progress)&&(l.progress=null),l.complete&&!b.isFunction(l.complete)&&(l.complete=null),l.display!==o&&null!==l.display&&(l.display=l.display.toString().toLowerCase(),"auto"===l.display&&(l.display=C.CSS.Values.getDisplayType(e))),l.visibility!==o&&null!==l.visibility&&(l.visibility=l.visibility.toString().toLowerCase()),l.mobileHA=l.mobileHA&&C.State.isMobile&&!C.State.isGingerbread,!1===l.queue)if(l.delay){var c=C.State.delayedElements.count++;C.State.delayedElements[c]=e;var f=function(e){return function(){C.State.delayedElements[e]=!1,n()}}(c);a(e).delayBegin=(new Date).getTime(),a(e).delay=parseFloat(l.delay),a(e).delayTimer={setTimeout:setTimeout(n,parseFloat(l.delay)),next:f}}else n();else m.queue(e,l.queue,function(e,t){if(!0===t)return I.promise&&I.resolver(v),!0;C.velocityQueueEntryFlag=!0,n(e)});""!==l.queue&&"fx"!==l.queue||"inprogress"===m.queue(e)[0]||m.dequeue(e)}var u,c,h,g,v,y,x,P=arguments[0]&&(arguments[0].p||m.isPlainObject(arguments[0].properties)&&!arguments[0].properties.names||b.isString(arguments[0].properties));b.isWrapped(this)?(c=!1,g=0,v=this,h=this):(c=!0,g=1,v=P?arguments[0].elements||arguments[0].e:arguments[0]);var I={promise:null,resolver:null,rejecter:null};if(c&&C.Promise&&(I.promise=new C.Promise(function(e,t){I.resolver=e,I.rejecter=t})),P?(y=arguments[0].properties||arguments[0].p,x=arguments[0].options||arguments[0].o):(y=arguments[g],x=arguments[g+1]),!(v=n(v)))return void(I.promise&&(y&&x&&!1===x.promiseRejectEmpty?I.resolver():I.rejecter()));var V=v.length,A=0;if(!/^(stop|finish|finishAll|pause|resume)$/i.test(y)&&!m.isPlainObject(x)){var $=g+1;x={};for(var N=$;N<arguments.length;N++)b.isArray(arguments[N])||!/^(fast|normal|slow)$/i.test(arguments[N])&&!/^\d/.test(arguments[N])?b.isString(arguments[N])||b.isArray(arguments[N])?x.easing=arguments[N]:b.isFunction(arguments[N])&&(x.complete=arguments[N]):x.duration=arguments[N]}var E;switch(y){case"scroll":E="scroll";break;case"reverse":E="reverse";break;case"pause":var j=(new Date).getTime();return m.each(v,function(e,t){s(t,j)}),m.each(C.State.calls,function(e,t){var r=!1;t&&m.each(t[1],function(e,i){var n=x===o?"":x;return!0!==n&&t[2].queue!==n&&(x!==o||!1!==t[2].queue)||(m.each(v,function(e,o){if(o===i)return t[5]={resume:!1},r=!0,!1}),!r&&void 0)})}),e();case"resume":return m.each(v,function(e,t){l(t,j)}),m.each(C.State.calls,function(e,t){var r=!1;t&&m.each(t[1],function(e,i){var n=x===o?"":x;return!0!==n&&t[2].queue!==n&&(x!==o||!1!==t[2].queue)||(!t[5]||(m.each(v,function(e,o){if(o===i)return t[5].resume=!0,r=!0,!1}),!r&&void 0))})}),e();case"finish":case"finishAll":case"stop":m.each(v,function(e,t){a(t)&&a(t).delayTimer&&(clearTimeout(a(t).delayTimer.setTimeout),a(t).delayTimer.next&&a(t).delayTimer.next(),delete a(t).delayTimer),"finishAll"!==y||!0!==x&&!b.isString(x)||(m.each(m.queue(t,b.isString(x)?x:""),function(e,t){b.isFunction(t)&&t()}),m.queue(t,b.isString(x)?x:"",[]))});var z=[];return m.each(C.State.calls,function(e,t){t&&m.each(t[1],function(r,i){var n=x===o?"":x;if(!0!==n&&t[2].queue!==n&&(x!==o||!1!==t[2].queue))return!0;m.each(v,function(r,o){if(o===i)if((!0===x||b.isString(x))&&(m.each(m.queue(o,b.isString(x)?x:""),function(e,t){b.isFunction(t)&&t(null,!0)}),m.queue(o,b.isString(x)?x:"",[])),"stop"===y){var s=a(o);s&&s.tweensContainer&&!1!==n&&m.each(s.tweensContainer,function(e,t){t.endValue=t.currentValue}),z.push(e)}else"finish"!==y&&"finishAll"!==y||(t[2].duration=1)})})}),"stop"===y&&(m.each(z,function(e,t){f(t,!0)}),I.promise&&I.resolver(v)),e();default:if(!m.isPlainObject(y)||b.isEmptyObject(y)){if(b.isString(y)&&C.Redirects[y]){u=m.extend({},x);var F=u.duration,O=u.delay||0;return!0===u.backwards&&(v=m.extend(!0,[],v).reverse()),m.each(v,function(e,t){parseFloat(u.stagger)?u.delay=O+parseFloat(u.stagger)*e:b.isFunction(u.stagger)&&(u.delay=O+u.stagger.call(t,e,V)),u.drag&&(u.duration=parseFloat(F)||(/^(callout|transition)/.test(y)?1e3:S),u.duration=Math.max(u.duration*(u.backwards?1-e/V:(e+1)/V),.75*u.duration,200)),C.Redirects[y].call(t,t,u||{},e,V,v,I.promise?I:o)}),e()}var W="Velocity: First argument ("+y+") was not a property map, a known action, or a registered redirect. Aborting.";return I.promise?I.rejecter(new Error(W)):t.console&&console.log(W),e()}E="start"}var L={lastParent:null,lastPosition:null,lastFontSize:null,lastPercentToPxWidth:null,lastPercentToPxHeight:null,lastEmToPx:null,remToPx:null,vwToPx:null,vhToPx:null},R=[];m.each(v,function(e,t){b.isNode(t)&&i(t,e)}),u=m.extend({},C.defaults,x),u.loop=parseInt(u.loop,10);var H=2*u.loop-1;if(u.loop)for(var M=0;M<H;M++){var D={delay:u.delay,progress:u.progress};M===H-1&&(D.display=u.display,D.visibility=u.visibility,D.complete=u.complete),k(v,"reverse",D)}return e()};C=m.extend(k,C),C.animate=k;var V=t.requestAnimationFrame||g;if(!C.State.isMobile&&r.hidden!==o){var A=function(){r.hidden?(V=function(e){return setTimeout(function(){e(!0)},16)},d()):V=t.requestAnimationFrame||g};A(),r.addEventListener("visibilitychange",A)}return e.Velocity=C,e!==t&&(e.fn.velocity=k,e.fn.velocity.defaults=C.defaults),m.each(["Down","Up"],function(e,t){C.Redirects["slide"+t]=function(e,r,i,n,a,s){var l=m.extend({},r),u=l.begin,c=l.complete,p={},d={height:"",marginTop:"",marginBottom:"",paddingTop:"",paddingBottom:""};l.display===o&&(l.display="Down"===t?"inline"===C.CSS.Values.getDisplayType(e)?"inline-block":"block":"none"),l.begin=function(){0===i&&u&&u.call(a,a);for(var r in d)if(d.hasOwnProperty(r)){p[r]=e.style[r];var o=T.getPropertyValue(e,r);d[r]="Down"===t?[o,0]:[0,o]}p.overflow=e.style.overflow,e.style.overflow="hidden"},l.complete=function(){for(var t in p)p.hasOwnProperty(t)&&(e.style[t]=p[t]);i===n-1&&(c&&c.call(a,a),s&&s.resolver(a))},C(e,d,l)}}),m.each(["In","Out"],function(e,t){C.Redirects["fade"+t]=function(e,r,i,n,a,s){var l=m.extend({},r),u=l.complete,c={opacity:"In"===t?1:0};0!==i&&(l.begin=null),l.complete=i!==n-1?null:function(){u&&u.call(a,a),s&&s.resolver(a)},l.display===o&&(l.display="In"===t?"auto":"none"),C(this,c,l)}}),C}(window.jQuery||window.Zepto||window,window,window?window.document:void 0)}),function(e){"use strict";e.fn.fitVids=function(t){var r={customSelector:null,ignore:null};if(!document.getElementById("fit-vids-style")){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("div");i.innerHTML='<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>',o.appendChild(i.childNodes[1])}return t&&e.extend(r,t),this.each(function(){var t=['iframe[src*="player.vimeo.com"]','iframe[src*="youtube.com"]','iframe[src*="youtube-nocookie.com"]','iframe[src*="kickstarter.com"][src*="video.html"]',"object","embed"];r.customSelector&&t.push(r.customSelector);var o=".fitvidsignore";r.ignore&&(o=o+", "+r.ignore);var i=e(this).find(t.join(","));i=i.not("object object"),i=i.not(o),i.each(function(){var t=e(this);if(!(t.parents(o).length>0||"embed"===this.tagName.toLowerCase()&&t.parent("object").length||t.parent(".fluid-width-video-wrapper").length)){t.css("height")||t.css("width")||!isNaN(t.attr("height"))&&!isNaN(t.attr("width"))||(t.attr("height",9),t.attr("width",16));var r="object"===this.tagName.toLowerCase()||t.attr("height")&&!isNaN(parseInt(t.attr("height"),10))?parseInt(t.attr("height"),10):t.height(),i=isNaN(parseInt(t.attr("width"),10))?t.width():parseInt(t.attr("width"),10),n=r/i;if(!t.attr("name")){var a="fitvid"+e.fn.fitVids._count;t.attr("name",a),e.fn.fitVids._count++}t.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top",100*n+"%"),t.removeAttr("height").removeAttr("width")}})})},e.fn.fitVids._count=0}(window.jQuery||window.Zepto),/*!

 matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license 

*/
window.matchMedia||(window.matchMedia=function(){"use strict";var e=window.styleMedia||window.media;if(!e){var t=document.createElement("style"),r=document.getElementsByTagName("script")[0],o=null;t.type="text/css",t.id="matchmediajs-test",r.parentNode.insertBefore(t,r),o="getComputedStyle"in window&&window.getComputedStyle(t,null)||t.currentStyle,e={matchMedium:function(e){var r="@media "+e+"{ #matchmediajs-test { width: 1px; } }";return t.styleSheet?t.styleSheet.cssText=r:t.textContent=r,"1px"===o.width}}}return function(t){return{matches:e.matchMedium(t||"all"),media:t||"all"}}}()),function(e,t,r){function o(e,t){return typeof e===t}function i(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,r){return t+r.toUpperCase()}).replace(/^-/,"")}function n(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):S?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(){var e=t.body;return e||(e=n(S?"svg":"body"),e.fake=!0),e}function s(e,r,o,i){var s,l,u,c,p="modernizr",d=n("div"),f=a();if(parseInt(o,10))for(;o--;)u=n("div"),u.id=i?i[o]:p+(o+1),d.appendChild(u);return s=n("style"),s.type="text/css",s.id="s"+p,(f.fake?f:d).appendChild(s),f.appendChild(d),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(t.createTextNode(e)),d.id=p,f.fake&&(f.style.background="",f.style.overflow="hidden",c=x.style.overflow,x.style.overflow="hidden",x.appendChild(f)),l=r(d,e),f.fake?(f.parentNode.removeChild(f),x.style.overflow=c,x.offsetHeight):d.parentNode.removeChild(d),!!l}function l(e,t){return!!~(""+e).indexOf(t)}function u(e,t){return function(){return e.apply(t,arguments)}}function c(e,t,r){var i;for(var n in e)if(e[n]in t)return!1===r?e[n]:(i=t[e[n]],o(i,"function")?u(i,r||t):i);return!1}function p(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function d(t,r,o){var i;if("getComputedStyle"in e){i=getComputedStyle.call(e,t,r);var n=e.console;if(null!==i)o&&(i=i.getPropertyValue(o));else if(n){var a=n.error?"error":"log";n[a].call(n,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else i=!r&&t.currentStyle&&t.currentStyle[o];return i}function f(t,o){var i=t.length;if("CSS"in e&&"supports"in e.CSS){for(;i--;)if(e.CSS.supports(p(t[i]),o))return!0;return!1}if("CSSSupportsRule"in e){for(var n=[];i--;)n.push("("+p(t[i])+":"+o+")");return n=n.join(" or "),s("@supports ("+n+") { #modernizr { position: absolute; } }",function(e){return"absolute"==d(e,null,"position")})}return r}function m(e,t,a,s){function u(){p&&(delete $.style,delete $.modElem)}if(s=!o(s,"undefined")&&s,!o(a,"undefined")){var c=f(e,a);if(!o(c,"undefined"))return c}for(var p,d,m,h,g,v=["modernizr","tspan","samp"];!$.style&&v.length;)p=!0,$.modElem=n(v.shift()),$.style=$.modElem.style;for(m=e.length,d=0;m>d;d++)if(h=e[d],g=$.style[h],l(h,"-")&&(h=i(h)),$.style[h]!==r){if(s||o(a,"undefined"))return u(),"pfx"!=t||h;try{$.style[h]=a}catch(e){}if($.style[h]!=g)return u(),"pfx"!=t||h}return u(),!1}function h(e,t,r,i,n){var a=e.charAt(0).toUpperCase()+e.slice(1),s=(e+" "+T.join(a+" ")+a).split(" ");return o(t,"string")||o(t,"undefined")?m(s,t,i,n):(s=(e+" "+V.join(a+" ")+a).split(" "),c(s,t,r))}function g(e,t,o){return h(e,r,r,t,o)}var v=[],y=[],w={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var r=this;setTimeout(function(){t(r[e])},0)},addTest:function(e,t,r){y.push({name:e,fn:t,options:r})},addAsyncTest:function(e){y.push({name:null,fn:e})}},b=function(){};b.prototype=w,b=new b,b.addTest("localstorage",function(){var e="modernizr";try{return localStorage.setItem(e,e),localStorage.removeItem(e),!0}catch(e){return!1}});var x=t.documentElement,S="svg"===x.nodeName.toLowerCase(),P=w._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];w._prefixes=P;var C=w.testStyles=s;b.addTest("touchevents",function(){var r;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)r=!0;else{var o=["@media (",P.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");C(o,function(e){r=9===e.offsetTop})}return r});var I="Moz O ms Webkit",T=w._config.usePrefixes?I.split(" "):[];w._cssomPrefixes=T;var k=function(t){var o,i=P.length,n=e.CSSRule;if(void 0===n)return r;if(!t)return!1;if(t=t.replace(/^@/,""),(o=t.replace(/-/g,"_").toUpperCase()+"_RULE")in n)return"@"+t;for(var a=0;i>a;a++){var s=P[a];if(s.toUpperCase()+"_"+o in n)return"@-"+s.toLowerCase()+"-"+t}return!1};w.atRule=k;var V=w._config.usePrefixes?I.toLowerCase().split(" "):[];w._domPrefixes=V;var A={elem:n("modernizr")};b._q.push(function(){delete A.elem});var $={style:A.elem.style};b._q.unshift(function(){delete $.style}),w.testAllProps=h,w.testAllProps=g,b.addTest("cssgridlegacy",g("grid-columns","10px",!0)),b.addTest("cssgrid",g("grid-template-rows","none",!0));var N=w.prefixed=function(e,t,r){return 0===e.indexOf("@")?k(e):(-1!=e.indexOf("-")&&(e=i(e)),t?h(e,t,r):h(e,"pfx"))};b.addTest("objectfit",!!N("objectFit"),{aliases:["object-fit"]}),function(){var e,t,r,i,n,a,s;for(var l in y)if(y.hasOwnProperty(l)){if(e=[],t=y[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(r=0;r<t.options.aliases.length;r++)e.push(t.options.aliases[r].toLowerCase());for(i=o(t.fn,"function")?t.fn():t.fn,n=0;n<e.length;n++)a=e[n],s=a.split("."),1===s.length?b[s[0]]=i:(!b[s[0]]||b[s[0]]instanceof Boolean||(b[s[0]]=new Boolean(b[s[0]])),b[s[0]][s[1]]=i),v.push((i?"":"no-")+s.join("-"))}}(),function(e){var t=x.className,r=b._config.classPrefix||"";if(S&&(t=t.baseVal),b._config.enableJSClass){var o=new RegExp("(^|\\s)"+r+"no-js(\\s|$)");t=t.replace(o,"$1"+r+"js$2")}b._config.enableClasses&&(t+=" "+r+e.join(" "+r),S?x.className.baseVal=t:x.className=t)}(v),delete w.addTest,delete w.addAsyncTest;for(var E=0;E<b._q.length;E++)b._q[E]();e.Modernizr=b}(window,document),/*!
 *	jQuery OwlCarousel v1.31
 *
 *	Copyright (c) 2013 Bartosz Wojciechowski
 *	http://www.owlgraphic.com/owlcarousel/
 *
 *	Licensed under MIT
 *
 */
"function"!=typeof Object.create&&(Object.create=function(e){function t(){}return t.prototype=e,new t}),function(e,t,r,o){var i={init:function(t,r){var o=this;o.$elem=e(r),o.options=e.extend({},e.fn.owlCarousel.options,o.$elem.data(),t),o.userOptions=t,o.loadContent()},loadContent:function(){function t(e){if("function"==typeof r.options.jsonSuccess)r.options.jsonSuccess.apply(this,[e]);else{var t="";for(var o in e.owl)t+=e.owl[o].item;r.$elem.html(t)}r.logIn()}var r=this;if("function"==typeof r.options.beforeInit&&r.options.beforeInit.apply(this,[r.$elem]),"string"==typeof r.options.jsonPath){var o=r.options.jsonPath;e.getJSON(o,t)}else r.logIn()},logIn:function(e){var t=this;t.$elem.data("owl-originalStyles",t.$elem.attr("style")).data("owl-originalClasses",t.$elem.attr("class")),t.$elem.css({opacity:0}),t.orignalItems=t.options.items,t.checkBrowser(),t.wrapperWidth=0,t.checkVisible,t.setVars()},setVars:function(){var e=this;if(0===e.$elem.children().length)return!1;e.baseClass(),e.eventTypes(),e.$userItems=e.$elem.children(),e.itemsAmount=e.$userItems.length,e.wrapItems(),e.$owlItems=e.$elem.find(".owl-item"),e.$owlWrapper=e.$elem.find(".owl-wrapper"),e.playDirection="next",e.prevItem=0,e.prevArr=[0],e.currentItem=0,e.customEvents(),e.onStartup()},onStartup:function(){var e=this;e.updateItems(),e.calculateAll(),e.buildControls(),e.updateControls(),e.response(),e.moveEvents(),e.stopOnHover(),e.owlStatus(),!1!==e.options.transitionStyle&&e.transitionTypes(e.options.transitionStyle),!0===e.options.autoPlay&&(e.options.autoPlay=5e3),e.play(),e.$elem.find(".owl-wrapper").css("display","block"),e.$elem.is(":visible")?e.$elem.css("opacity",1):e.watchVisibility(),e.onstartup=!1,e.eachMoveUpdate(),"function"==typeof e.options.afterInit&&e.options.afterInit.apply(this,[e.$elem])},eachMoveUpdate:function(){var e=this;!0===e.options.lazyLoad&&e.lazyLoad(),!0===e.options.autoHeight&&e.autoHeight(),e.onVisibleItems(),"function"==typeof e.options.afterAction&&e.options.afterAction.apply(this,[e.$elem])},updateVars:function(){var e=this;"function"==typeof e.options.beforeUpdate&&e.options.beforeUpdate.apply(this,[e.$elem]),e.watchVisibility(),e.updateItems(),e.calculateAll(),e.updatePosition(),e.updateControls(),e.eachMoveUpdate(),"function"==typeof e.options.afterUpdate&&e.options.afterUpdate.apply(this,[e.$elem])},reload:function(e){var t=this;setTimeout(function(){t.updateVars()},0)},watchVisibility:function(){var e=this;if(!1!==e.$elem.is(":visible"))return!1;e.$elem.css({opacity:0}),clearInterval(e.autoPlayInterval),clearInterval(e.checkVisible),e.checkVisible=setInterval(function(){e.$elem.is(":visible")&&(e.reload(),e.$elem.animate({opacity:1},200),clearInterval(e.checkVisible))},500)},wrapItems:function(){var e=this;e.$userItems.wrapAll('<div class="owl-wrapper">').wrap('<div class="owl-item"></div>'),e.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'),e.wrapperOuter=e.$elem.find(".owl-wrapper-outer"),e.$elem.css("display","block")},baseClass:function(){var e=this,t=e.$elem.hasClass(e.options.baseClass),r=e.$elem.hasClass(e.options.theme);t||e.$elem.addClass(e.options.baseClass),r||e.$elem.addClass(e.options.theme)},updateItems:function(){var t=this;if(!1===t.options.responsive)return!1;if(!0===t.options.singleItem)return t.options.items=t.orignalItems=1,t.options.itemsCustom=!1,t.options.itemsDesktop=!1,t.options.itemsDesktopSmall=!1,t.options.itemsTablet=!1,t.options.itemsTabletSmall=!1,t.options.itemsMobile=!1,!1;var r=e(t.options.responsiveBaseWidth).width();if(r>(t.options.itemsDesktop[0]||t.orignalItems)&&(t.options.items=t.orignalItems),void 0!==t.options.itemsCustom&&!1!==t.options.itemsCustom){t.options.itemsCustom.sort(function(e,t){return e[0]-t[0]});for(var o in t.options.itemsCustom)void 0!==t.options.itemsCustom[o]&&t.options.itemsCustom[o][0]<=r&&(t.options.items=t.options.itemsCustom[o][1])}else r<=t.options.itemsDesktop[0]&&!1!==t.options.itemsDesktop&&(t.options.items=t.options.itemsDesktop[1]),r<=t.options.itemsDesktopSmall[0]&&!1!==t.options.itemsDesktopSmall&&(t.options.items=t.options.itemsDesktopSmall[1]),r<=t.options.itemsTablet[0]&&!1!==t.options.itemsTablet&&(t.options.items=t.options.itemsTablet[1]),r<=t.options.itemsTabletSmall[0]&&!1!==t.options.itemsTabletSmall&&(t.options.items=t.options.itemsTabletSmall[1]),r<=t.options.itemsMobile[0]&&!1!==t.options.itemsMobile&&(t.options.items=t.options.itemsMobile[1]);t.options.items>t.itemsAmount&&!0===t.options.itemsScaleUp&&(t.options.items=t.itemsAmount)},response:function(){var r,o=this;if(!0!==o.options.responsive)return!1;var i=e(t).width();o.resizer=function(){e(t).width()!==i&&(!1!==o.options.autoPlay&&clearInterval(o.autoPlayInterval),clearTimeout(r),r=setTimeout(function(){i=e(t).width(),o.updateVars()},o.options.responsiveRefreshRate))},e(t).resize(o.resizer)},updatePosition:function(){var e=this;e.jumpTo(e.currentItem),!1!==e.options.autoPlay&&e.checkAp()},appendItemsSizes:function(){var t=this,r=0,o=t.itemsAmount-t.options.items;t.$owlItems.each(function(i){var n=e(this);n.css({width:t.itemWidth}).data("owl-item",Number(i)),i%t.options.items!=0&&i!==o||i>o||(r+=1),n.data("owl-roundPages",r)})},appendWrapperSizes:function(){var e=this,t=0,t=e.$owlItems.length*e.itemWidth;e.$owlWrapper.css({width:2*t,left:0}),e.appendItemsSizes()},calculateAll:function(){var e=this;e.calculateWidth(),e.appendWrapperSizes(),e.loops(),e.max()},calculateWidth:function(){var e=this;e.itemWidth=Math.floor(e.$elem.width()/e.options.items)},max:function(){var e=this,t=-1*(e.itemsAmount*e.itemWidth-e.options.items*e.itemWidth);return e.options.items>e.itemsAmount?(e.maximumItem=0,t=0,e.maximumPixels=0):(e.maximumItem=e.itemsAmount-e.options.items,e.maximumPixels=t),t},min:function(){return 0},loops:function(){var t=this;t.positionsInArray=[0],t.pagesInArray=[];for(var r=0,o=0,i=0;i<t.itemsAmount;i++)if(o+=t.itemWidth,t.positionsInArray.push(-o),!0===t.options.scrollPerPage){var n=e(t.$owlItems[i]),a=n.data("owl-roundPages");a!==r&&(t.pagesInArray[r]=t.positionsInArray[i],r=a)}},buildControls:function(){var t=this;!0!==t.options.navigation&&!0!==t.options.pagination||(t.owlControls=e('<div class="owl-controls"/>').toggleClass("clickable",!t.browser.isTouch).appendTo(t.$elem)),!0===t.options.pagination&&t.buildPagination(),!0===t.options.navigation&&t.buildButtons()},buildButtons:function(){var t=this,r=e('<div class="owl-buttons"/>');t.owlControls.append(r),t.buttonPrev=e("<div/>",{class:"owl-prev",html:t.options.navigationText[0]||""}),t.buttonNext=e("<div/>",{class:"owl-next",html:t.options.navigationText[1]||""}),r.append(t.buttonPrev).append(t.buttonNext),r.on("touchstart.owlControls mousedown.owlControls",'div[class^="owl"]',function(e){e.preventDefault()}),r.on("touchend.owlControls mouseup.owlControls",'div[class^="owl"]',function(r){r.preventDefault(),e(this).hasClass("owl-next")?t.next():t.prev()})},buildPagination:function(){var t=this;t.paginationWrapper=e('<div class="owl-pagination"/>'),t.owlControls.append(t.paginationWrapper),t.paginationWrapper.on("touchend.owlControls mouseup.owlControls",".owl-page",function(r){r.preventDefault(),Number(e(this).data("owl-page"))!==t.currentItem&&t.goTo(Number(e(this).data("owl-page")),!0)})},updatePagination:function(){var t=this;if(!1===t.options.pagination)return!1;t.paginationWrapper.html("");for(var r=0,o=t.itemsAmount-t.itemsAmount%t.options.items,i=0;i<t.itemsAmount;i++)if(i%t.options.items==0){if(r+=1,o===i)var n=t.itemsAmount-t.options.items;var a=e("<div/>",{class:"owl-page"}),s=e("<span></span>",{text:!0===t.options.paginationNumbers?r:"",class:!0===t.options.paginationNumbers?"owl-numbers":""});a.append(s),a.data("owl-page",o===i?n:i),a.data("owl-roundPages",r),t.paginationWrapper.append(a)}t.checkPagination()},checkPagination:function(){var t=this;if(!1===t.options.pagination)return!1;t.paginationWrapper.find(".owl-page").each(function(r,o){e(this).data("owl-roundPages")===e(t.$owlItems[t.currentItem]).data("owl-roundPages")&&(t.paginationWrapper.find(".owl-page").removeClass("active"),e(this).addClass("active"))})},checkNavigation:function(){var e=this;if(!1===e.options.navigation)return!1;!1===e.options.rewindNav&&(0===e.currentItem&&0===e.maximumItem?(e.buttonPrev.addClass("disabled"),e.buttonNext.addClass("disabled")):0===e.currentItem&&0!==e.maximumItem?(e.buttonPrev.addClass("disabled"),e.buttonNext.removeClass("disabled")):e.currentItem===e.maximumItem?(e.buttonPrev.removeClass("disabled"),e.buttonNext.addClass("disabled")):0!==e.currentItem&&e.currentItem!==e.maximumItem&&(e.buttonPrev.removeClass("disabled"),e.buttonNext.removeClass("disabled")))},updateControls:function(){var e=this;e.updatePagination(),e.checkNavigation(),e.owlControls&&(e.options.items>=e.itemsAmount?e.owlControls.hide():e.owlControls.show())},destroyControls:function(){var e=this;e.owlControls&&e.owlControls.remove()},next:function(e){var t=this;if(t.isTransition)return!1;if(t.currentItem+=!0===t.options.scrollPerPage?t.options.items:1,t.currentItem>t.maximumItem+(1==t.options.scrollPerPage?t.options.items-1:0)){if(!0!==t.options.rewindNav)return t.currentItem=t.maximumItem,!1;t.currentItem=0,e="rewind"}t.goTo(t.currentItem,e)},prev:function(e){var t=this;if(t.isTransition)return!1;if(!0===t.options.scrollPerPage&&t.currentItem>0&&t.currentItem<t.options.items?t.currentItem=0:t.currentItem-=!0===t.options.scrollPerPage?t.options.items:1,t.currentItem<0){if(!0!==t.options.rewindNav)return t.currentItem=0,!1;t.currentItem=t.maximumItem,e="rewind"}t.goTo(t.currentItem,e)},goTo:function(e,t,r){var o=this;if(o.isTransition)return!1;if("function"==typeof o.options.beforeMove&&o.options.beforeMove.apply(this,[o.$elem]),e>=o.maximumItem?e=o.maximumItem:e<=0&&(e=0),o.currentItem=o.owl.currentItem=e,!1!==o.options.transitionStyle&&"drag"!==r&&1===o.options.items&&!0===o.browser.support3d)return o.swapSpeed(0),!0===o.browser.support3d?o.transition3d(o.positionsInArray[e]):o.css2slide(o.positionsInArray[e],1),o.afterGo(),o.singleItemTransition(),!1;var i=o.positionsInArray[e];!0===o.browser.support3d?(o.isCss3Finish=!1,!0===t?(o.swapSpeed("paginationSpeed"),setTimeout(function(){o.isCss3Finish=!0},o.options.paginationSpeed)):"rewind"===t?(o.swapSpeed(o.options.rewindSpeed),setTimeout(function(){o.isCss3Finish=!0},o.options.rewindSpeed)):(o.swapSpeed("slideSpeed"),setTimeout(function(){o.isCss3Finish=!0},o.options.slideSpeed)),o.transition3d(i)):!0===t?o.css2slide(i,o.options.paginationSpeed):"rewind"===t?o.css2slide(i,o.options.rewindSpeed):o.css2slide(i,o.options.slideSpeed),o.afterGo()},jumpTo:function(e){var t=this;"function"==typeof t.options.beforeMove&&t.options.beforeMove.apply(this,[t.$elem]),e>=t.maximumItem||-1===e?e=t.maximumItem:e<=0&&(e=0),t.swapSpeed(0),!0===t.browser.support3d?t.transition3d(t.positionsInArray[e]):t.css2slide(t.positionsInArray[e],1),t.currentItem=t.owl.currentItem=e,t.afterGo()},afterGo:function(){var e=this;e.prevArr.push(e.currentItem),e.prevItem=e.owl.prevItem=e.prevArr[e.prevArr.length-2],e.prevArr.shift(0),e.prevItem!==e.currentItem&&(e.checkPagination(),e.checkNavigation(),e.eachMoveUpdate(),!1!==e.options.autoPlay&&e.checkAp()),"function"==typeof e.options.afterMove&&e.prevItem!==e.currentItem&&e.options.afterMove.apply(this,[e.$elem])},stop:function(){var e=this;e.apStatus="stop",clearInterval(e.autoPlayInterval)},checkAp:function(){var e=this;"stop"!==e.apStatus&&e.play()},play:function(){var e=this;if(e.apStatus="play",!1===e.options.autoPlay)return!1;clearInterval(e.autoPlayInterval),e.autoPlayInterval=setInterval(function(){e.next(!0)},e.options.autoPlay)},swapSpeed:function(e){var t=this;"slideSpeed"===e?t.$owlWrapper.css(t.addCssSpeed(t.options.slideSpeed)):"paginationSpeed"===e?t.$owlWrapper.css(t.addCssSpeed(t.options.paginationSpeed)):"string"!=typeof e&&t.$owlWrapper.css(t.addCssSpeed(e))},addCssSpeed:function(e){return{"-webkit-transition":"all "+e+"ms ease","-moz-transition":"all "+e+"ms ease","-o-transition":"all "+e+"ms ease",transition:"all "+e+"ms ease"}},removeTransition:function(){return{"-webkit-transition":"","-moz-transition":"","-o-transition":"",transition:""}},doTranslate:function(e){return{"-webkit-transform":"translate3d("+e+"px, 0px, 0px)","-moz-transform":"translate3d("+e+"px, 0px, 0px)","-o-transform":"translate3d("+e+"px, 0px, 0px)","-ms-transform":"translate3d("+e+"px, 0px, 0px)",transform:"translate3d("+e+"px, 0px,0px)"}},transition3d:function(e){var t=this;t.$owlWrapper.css(t.doTranslate(e))},css2move:function(e){this.$owlWrapper.css({left:e})},css2slide:function(e,t){var r=this;r.isCssFinish=!1,r.$owlWrapper.stop(!0,!0).animate({left:e},{duration:t||r.options.slideSpeed,complete:function(){r.isCssFinish=!0}})},checkBrowser:function(){var e=this,o="translate3d(0px, 0px, 0px)",i=r.createElement("div");i.style.cssText="  -moz-transform:"+o+"; -ms-transform:"+o+"; -o-transform:"+o+"; -webkit-transform:"+o+"; transform:"+o;var n=/translate3d\(0px, 0px, 0px\)/g,a=i.style.cssText.match(n),s=null!==a&&1===a.length,l="ontouchstart"in t||navigator.msMaxTouchPoints;e.browser={support3d:s,isTouch:l}},moveEvents:function(){var e=this;!1===e.options.mouseDrag&&!1===e.options.touchDrag||(e.gestures(),e.disabledEvents())},eventTypes:function(){var e=this,t=["s","e","x"];e.ev_types={},!0===e.options.mouseDrag&&!0===e.options.touchDrag?t=["touchstart.owl mousedown.owl","touchmove.owl mousemove.owl","touchend.owl touchcancel.owl mouseup.owl"]:!1===e.options.mouseDrag&&!0===e.options.touchDrag?t=["touchstart.owl","touchmove.owl","touchend.owl touchcancel.owl"]:!0===e.options.mouseDrag&&!1===e.options.touchDrag&&(t=["mousedown.owl","mousemove.owl","mouseup.owl"]),e.ev_types.start=t[0],e.ev_types.move=t[1],e.ev_types.end=t[2]},disabledEvents:function(){var t=this;t.$elem.on("dragstart.owl",function(e){e.preventDefault()}),t.$elem.on("mousedown.disableTextSelect",function(t){return e(t.target).is("input, textarea, select, option")})},gestures:function(){function i(e){return e.touches?{x:e.touches[0].pageX,y:e.touches[0].pageY}:e.pageX!==o?{x:e.pageX,y:e.pageY}:{x:e.clientX,y:e.clientY}}function n(t){"on"===t?(e(r).on(u.ev_types.move,s),e(r).on(u.ev_types.end,l)):"off"===t&&(e(r).off(u.ev_types.move),e(r).off(u.ev_types.end))}function a(r){var r=r.originalEvent||r||t.event;if(3===r.which)return!1;if(!(u.itemsAmount<=u.options.items)){if(!1===u.isCssFinish&&!u.options.dragBeforeAnimFinish)return!1;if(!1===u.isCss3Finish&&!u.options.dragBeforeAnimFinish)return!1;!1!==u.options.autoPlay&&clearInterval(u.autoPlayInterval),!0===u.browser.isTouch||u.$owlWrapper.hasClass("grabbing")||u.$owlWrapper.addClass("grabbing"),u.newPosX=0,u.newRelativeX=0,e(this).css(u.removeTransition());var o=e(this).position();c.relativePos=o.left,c.offsetX=i(r).x-o.left,c.offsetY=i(r).y-o.top,n("on"),c.sliding=!1,c.targetElement=r.target||r.srcElement}}function s(o){var o=o.originalEvent||o||t.event;u.newPosX=i(o).x-c.offsetX,u.newPosY=i(o).y-c.offsetY,u.newRelativeX=u.newPosX-c.relativePos,"function"==typeof u.options.startDragging&&!0!==c.dragging&&0!==u.newRelativeX&&(c.dragging=!0,u.options.startDragging.apply(u,[u.$elem])),(u.newRelativeX>8||u.newRelativeX<-8&&!0===u.browser.isTouch)&&(o.preventDefault?o.preventDefault():o.returnValue=!1,c.sliding=!0),(u.newPosY>10||u.newPosY<-10)&&!1===c.sliding&&e(r).off("touchmove.owl");u.newPosX=Math.max(Math.min(u.newPosX,function(){return u.newRelativeX/5}()),function(){return u.maximumPixels+u.newRelativeX/5}()),!0===u.browser.support3d?u.transition3d(u.newPosX):u.css2move(u.newPosX)}function l(r){var r=r.originalEvent||r||t.event;if(r.target=r.target||r.srcElement,c.dragging=!1,!0!==u.browser.isTouch&&u.$owlWrapper.removeClass("grabbing"),u.newRelativeX<0?u.dragDirection=u.owl.dragDirection="left":u.dragDirection=u.owl.dragDirection="right",0!==u.newRelativeX){var o=u.getNewPosition();if(u.goTo(o,!1,"drag"),c.targetElement===r.target&&!0!==u.browser.isTouch){e(r.target).on("click.disable",function(t){t.stopImmediatePropagation(),t.stopPropagation(),t.preventDefault(),e(r.target).off("click.disable")});var i=e._data(r.target,"events").click,a=i.pop();i.splice(0,0,a)}}n("off")}var u=this,c={offsetX:0,offsetY:0,baseElWidth:0,relativePos:0,position:null,minSwipe:null,maxSwipe:null,sliding:null,dargging:null,targetElement:null};u.isCssFinish=!0,u.$elem.on(u.ev_types.start,".owl-wrapper",a)},getNewPosition:function(){var e,t=this;return e=t.closestItem(),e>t.maximumItem?(t.currentItem=t.maximumItem,e=t.maximumItem):t.newPosX>=0&&(e=0,t.currentItem=0),e},closestItem:function(){var t=this,r=!0===t.options.scrollPerPage?t.pagesInArray:t.positionsInArray,o=t.newPosX,i=null;return e.each(r,function(n,a){o-t.itemWidth/20>r[n+1]&&o-t.itemWidth/20<a&&"left"===t.moveDirection()?(i=a,!0===t.options.scrollPerPage?t.currentItem=e.inArray(i,t.positionsInArray):t.currentItem=n):o+t.itemWidth/20<a&&o+t.itemWidth/20>(r[n+1]||r[n]-t.itemWidth)&&"right"===t.moveDirection()&&(!0===t.options.scrollPerPage?(i=r[n+1]||r[r.length-1],t.currentItem=e.inArray(i,t.positionsInArray)):(i=r[n+1],t.currentItem=n+1))}),t.currentItem},moveDirection:function(){var e,t=this;return t.newRelativeX<0?(e="right",t.playDirection="next"):(e="left",t.playDirection="prev"),e},customEvents:function(){var e=this;e.$elem.on("owl.next",function(){e.next()}),e.$elem.on("owl.prev",function(){e.prev()}),e.$elem.on("owl.play",function(t,r){e.options.autoPlay=r,e.play(),e.hoverStatus="play"}),e.$elem.on("owl.stop",function(){e.stop(),e.hoverStatus="stop"}),e.$elem.on("owl.goTo",function(t,r){e.goTo(r)}),e.$elem.on("owl.jumpTo",function(t,r){e.jumpTo(r)})},stopOnHover:function(){var e=this;!0===e.options.stopOnHover&&!0!==e.browser.isTouch&&!1!==e.options.autoPlay&&(e.$elem.on("mouseover",function(){e.stop()}),e.$elem.on("mouseout",function(){"stop"!==e.hoverStatus&&e.play()}))},lazyLoad:function(){var t=this;if(!1===t.options.lazyLoad)return!1;for(var r=0;r<t.itemsAmount;r++){var i=e(t.$owlItems[r]);if("loaded"!==i.data("owl-loaded")){var n=i.data("owl-item"),a=i.find(".lazyOwl");"string"==typeof a.data("src")?(i.data("owl-loaded")===o&&(a.hide(),i.addClass("loading").data("owl-loaded","checked")),(!0!==t.options.lazyFollow||n>=t.currentItem)&&n<t.currentItem+t.options.items&&a.length&&t.lazyPreload(i,a)):i.data("owl-loaded","loaded")}}},lazyPreload:function(e,t){function r(){n+=1,i.completeImg(t.get(0))||!0===a?o():n<=100?setTimeout(r,100):o()}function o(){e.data("owl-loaded","loaded").removeClass("loading"),t.removeAttr("data-src"),"fade"===i.options.lazyEffect?t.fadeIn(400):t.show(),"function"==typeof i.options.afterLazyLoad&&i.options.afterLazyLoad.apply(this,[i.$elem])}var i=this,n=0;if("DIV"===t.prop("tagName")){t.css("background-image","url("+t.data("src")+")");var a=!0}else t[0].src=t.data("src");r()},autoHeight:function(){function t(){a+=1,i.completeImg(n.get(0))?r():a<=100?setTimeout(t,100):i.wrapperOuter.css("height","")}function r(){var t=e(i.$owlItems[i.currentItem]).height();i.wrapperOuter.css("height",t+"px"),i.wrapperOuter.hasClass("autoHeight")||setTimeout(function(){i.wrapperOuter.addClass("autoHeight")},0)}var i=this,n=e(i.$owlItems[i.currentItem]).find("img");if(n.get(0)!==o){var a=0;t()}else r()},completeImg:function(e){return!!e.complete&&(void 0===e.naturalWidth||0!=e.naturalWidth)},onVisibleItems:function(){var t=this;!0===t.options.addClassActive&&t.$owlItems.removeClass("active"),t.visibleItems=[];for(var r=t.currentItem;r<t.currentItem+t.options.items;r++)t.visibleItems.push(r),!0===t.options.addClassActive&&e(t.$owlItems[r]).addClass("active");t.owl.visibleItems=t.visibleItems},transitionTypes:function(e){var t=this;t.outClass="owl-"+e+"-out",t.inClass="owl-"+e+"-in"},singleItemTransition:function(){var e=this;e.isTransition=!0;var t=e.outClass,r=e.inClass,o=e.$owlItems.eq(e.currentItem),i=e.$owlItems.eq(e.prevItem),n=Math.abs(e.positionsInArray[e.currentItem])+e.positionsInArray[e.prevItem],a=Math.abs(e.positionsInArray[e.currentItem])+e.itemWidth/2;e.$owlWrapper.addClass("owl-origin").css({"-webkit-transform-origin":a+"px","-moz-perspective-origin":a+"px","perspective-origin":a+"px"});var s="webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";i.css(function(e,t){return{position:"relative",left:e+"px"}}(n,10)).addClass(t).on(s,function(){e.endPrev=!0,i.off(s),e.clearTransStyle(i,t)}),o.addClass(r).on(s,function(){e.endCurrent=!0,o.off(s),e.clearTransStyle(o,r)})},clearTransStyle:function(e,t){var r=this;e.css({position:"",left:""}).removeClass(t),r.endPrev&&r.endCurrent&&(r.$owlWrapper.removeClass("owl-origin"),r.endPrev=!1,r.endCurrent=!1,r.isTransition=!1)},owlStatus:function(){var e=this;e.owl={userOptions:e.userOptions,baseElement:e.$elem,userItems:e.$userItems,owlItems:e.$owlItems,currentItem:e.currentItem,prevItem:e.prevItem,visibleItems:e.visibleItems,isTouch:e.browser.isTouch,browser:e.browser,dragDirection:e.dragDirection}},clearEvents:function(){var o=this;o.$elem.off(".owl owl mousedown.disableTextSelect"),e(r).off(".owl owl"),e(t).off("resize",o.resizer)},unWrap:function(){var e=this;0!==e.$elem.children().length&&(e.$owlWrapper.unwrap(),e.$userItems.unwrap().unwrap(),e.owlControls&&e.owlControls.remove()),e.clearEvents(),e.$elem.attr("style",e.$elem.data("owl-originalStyles")||"").attr("class",e.$elem.data("owl-originalClasses"))},destroy:function(){var e=this;e.stop(),clearInterval(e.checkVisible),e.unWrap(),e.$elem.removeData()},reinit:function(t){var r=this,o=e.extend({},r.userOptions,t);r.unWrap(),r.init(o,r.$elem)},addItem:function(e,t){var r,i=this;return!!e&&(0===i.$elem.children().length?(i.$elem.append(e),i.setVars(),!1):(i.unWrap(),r=t===o||-1===t?-1:t,r>=i.$userItems.length||-1===r?i.$userItems.eq(-1).after(e):i.$userItems.eq(r).before(e),void i.setVars()))},removeItem:function(e){var t,r=this;if(0===r.$elem.children().length)return!1;t=e===o||-1===e?-1:e,r.unWrap(),r.$userItems.eq(t).remove(),r.setVars()}};e.fn.owlCarousel=function(t){return this.each(function(){if(!0===e(this).data("owl-init"))return!1;e(this).data("owl-init",!0);var r=Object.create(i);r.init(t,this),e.data(this,"owlCarousel",r)})},e.fn.owlCarousel.options={items:5,itemsCustom:!1,itemsDesktop:[1199,4],itemsDesktopSmall:[979,3],itemsTablet:[768,2],itemsTabletSmall:!1,itemsMobile:[479,1],singleItem:!1,itemsScaleUp:!1,slideSpeed:200,paginationSpeed:800,rewindSpeed:1e3,autoPlay:!1,stopOnHover:!1,navigation:!1,navigationText:["prev","next"],rewindNav:!0,scrollPerPage:!1,pagination:!0,paginationNumbers:!1,responsive:!0,responsiveRefreshRate:200,responsiveBaseWidth:t,baseClass:"owl-carousel",theme:"owl-theme",lazyLoad:!1,lazyFollow:!0,lazyEffect:"fade",autoHeight:!1,jsonPath:!1,jsonSuccess:!1,dragBeforeAnimFinish:!0,mouseDrag:!0,touchDrag:!0,addClassActive:!1,transitionStyle:!1,beforeUpdate:!1,afterUpdate:!1,beforeInit:!1,afterInit:!1,beforeMove:!1,afterMove:!1,afterAction:!1,startDragging:!1,afterLazyLoad:!1}}(jQuery,window,document),/*!
 *
 * Spin.js
 * Copyright (c) 2011-2013 Felix Gnass
 * Licensed under the MIT license
 */
function(e,t){"object"==typeof exports?module.exports=t():"function"==typeof define&&define.amd?define(t):e.Spinner=t()}(this,function(){"use strict";function e(e,t){var r,o=document.createElement(e||"div");for(r in t)o[r]=t[r];return o}function t(e){for(var t=1,r=arguments.length;t<r;t++)e.appendChild(arguments[t]);return e}function r(e,t,r,o){var i=["opacity",t,~~(100*e),r,o].join("-"),n=.01+r/o*100,a=Math.max(1-(1-e)/t*(100-n),e),s=u.substring(0,u.indexOf("Animation")).toLowerCase(),l=s&&"-"+s+"-"||"";return p[i]||(d.insertRule("@"+l+"keyframes "+i+"{0%{opacity:"+a+"}"+n+"%{opacity:"+e+"}"+(n+.01)+"%{opacity:1}"+(n+t)%100+"%{opacity:"+e+"}100%{opacity:"+a+"}}",d.cssRules.length),p[i]=1),i}function o(e,t){var r,o,i=e.style;for(t=t.charAt(0).toUpperCase()+t.slice(1),o=0;o<c.length;o++)if(r=c[o]+t,void 0!==i[r])return r;if(void 0!==i[t])return t}function i(e,t){for(var r in t)e.style[o(e,r)||r]=t[r];return e}function n(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)void 0===e[o]&&(e[o]=r[o])}return e}function a(e){for(var t={x:e.offsetLeft,y:e.offsetTop};e=e.offsetParent;)t.x+=e.offsetLeft,t.y+=e.offsetTop;return t}function s(e,t){return"string"==typeof e?e:e[t%e.length]}function l(e){if(void 0===this)return new l(e);this.opts=n(e||{},l.defaults,f)}var u,c=["webkit","Moz","ms","O"],p={},d=function(){var r=e("style",{type:"text/css"});return t(document.getElementsByTagName("head")[0],r),r.sheet||r.styleSheet}(),f={lines:12,length:7,width:5,radius:10,rotate:0,corners:1,color:"#000",direction:1,speed:1,trail:100,opacity:.25,fps:20,zIndex:2e9,className:"spinner",top:"auto",left:"auto",position:"relative"};l.defaults={},n(l.prototype,{spin:function(t){this.stop();var r,o,n=this,s=n.opts,l=n.el=i(e(0,{className:s.className}),{position:s.position,width:0,zIndex:s.zIndex}),c=s.radius+s.length+s.width;if(t&&(t.insertBefore(l,t.firstChild||null),o=a(t),r=a(l),i(l,{left:("auto"==s.left?o.x-r.x+(t.offsetWidth>>1):parseInt(s.left,10)+c)+"px",top:("auto"==s.top?o.y-r.y+(t.offsetHeight>>1):parseInt(s.top,10)+c)+"px"})),l.setAttribute("role","progressbar"),n.lines(l,n.opts),!u){var p,d=0,f=(s.lines-1)*(1-s.direction)/2,m=s.fps,h=m/s.speed,g=(1-s.opacity)/(h*s.trail/100),v=h/s.lines;!function e(){d++;for(var t=0;t<s.lines;t++)p=Math.max(1-(d+(s.lines-t)*v)%h*g,s.opacity),n.opacity(l,t*s.direction+f,p,s);n.timeout=n.el&&setTimeout(e,~~(1e3/m))}()}return n},stop:function(){var e=this.el;return e&&(clearTimeout(this.timeout),e.parentNode&&e.parentNode.removeChild(e),this.el=void 0),this},lines:function(o,n){function a(t,r){return i(e(),{position:"absolute",width:n.length+n.width+"px",height:n.width+"px",background:t,boxShadow:r,transformOrigin:"left",transform:"rotate("+~~(360/n.lines*c+n.rotate)+"deg) translate("+n.radius+"px,0)",borderRadius:(n.corners*n.width>>1)+"px"})}for(var l,c=0,p=(n.lines-1)*(1-n.direction)/2;c<n.lines;c++)l=i(e(),{position:"absolute",top:1+~(n.width/2)+"px",transform:n.hwaccel?"translate3d(0,0,0)":"",opacity:n.opacity,animation:u&&r(n.opacity,n.trail,p+c*n.direction,n.lines)+" "+1/n.speed+"s linear infinite"}),n.shadow&&t(l,i(a("#000","0 0 4px #000"),{top:"2px"})),t(o,t(l,a(s(n.color,c),"0 0 1px rgba(0,0,0,.1)")));return o},opacity:function(e,t,r){t<e.childNodes.length&&(e.childNodes[t].style.opacity=r)}});var m=i(e("group"),{behavior:"url(#default#VML)"});return!o(m,"transform")&&m.adj?function(){function r(t,r){return e("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',r)}d.addRule(".spin-vml","behavior:url(#default#VML)"),l.prototype.lines=function(e,o){function n(){return i(r("group",{coordsize:c+" "+c,coordorigin:-u+" "+-u}),{width:c,height:c})}function a(e,a,l){t(d,t(i(n(),{rotation:360/o.lines*e+"deg",left:~~a}),t(i(r("roundrect",{arcsize:o.corners}),{width:u,height:o.width,left:o.radius,top:-o.width>>1,filter:l}),r("fill",{color:s(o.color,e),opacity:o.opacity}),r("stroke",{opacity:0}))))}var l,u=o.length+o.width,c=2*u,p=2*-(o.width+o.length)+"px",d=i(n(),{position:"absolute",top:p,left:p});if(o.shadow)for(l=1;l<=o.lines;l++)a(l,-2,"progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");for(l=1;l<=o.lines;l++)a(l);return t(e,d)},l.prototype.opacity=function(e,t,r,o){var i=e.firstChild;o=o.shadow&&o.lines||0,i&&t+o<i.childNodes.length&&(i=i.childNodes[t+o],i=i&&i.firstChild,(i=i&&i.firstChild)&&(i.opacity=r))}}():u=o(m,"animation"),l}),function(e){if("object"==typeof exports)e(require("jquery"),require("spin"));else if("function"==typeof define&&define.amd)define(["jquery","spin"],e);else{if(!window.Spinner)throw new Error("Spin.js not present");e(window.jQuery,window.Spinner)}}(function(e,t){e.fn.spin=function(r,o){return this.each(function(){var i=e(this),n=i.data();n.spinner&&(n.spinner.stop(),delete n.spinner),!1!==r&&(r=e.extend({color:o||i.css("color")},e.fn.spin.presets[r]||r),n.spinner=new t(r).spin(this))})},e.fn.spin.presets={tiny:{lines:8,length:2,width:2,radius:3},small:{lines:8,length:4,width:3,radius:5},large:{lines:10,length:8,width:4,radius:8}}});
(function() {
  var Accordion, Cart, Collection, DOC, Footer, FrameworkAlign, FullscreenSlider, HEADER, HorizontalTabs, MediaQueries, PAGE, Password, Popup, ProductSlider, PromoBar, VerticalTabs, VideoModal, WINDOW, current_window, log, mq_large, mq_medium, mq_small, touchevents_exist,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  FrameworkAlign = (function() {
    function FrameworkAlign(element1, type1) {
      this.element = element1;
      this.type = type1;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.fillYSpace = bind(this.fillYSpace, this);
      this.checkOverlap = bind(this.checkOverlap, this);
      this.createOverlapDetectors = bind(this.createOverlapDetectors, this);
      this.position = bind(this.position, this);
      this.parent = this.element.parent();
      this.left_side_border;
      this.right_element_width = null;
      this.position();
      this.fillYSpace();
      this.createOverlapDetectors();
      this.resizeListeners();
    }

    FrameworkAlign.prototype.position = function() {
      if (this.type === 'center-x') {
        this.element.css({
          'margin-left': -(this.element.outerWidth() / 2)
        });
      }
      if (this.type === 'center-y') {
        return this.element.css({
          'margin-top': -(this.element.outerHeight() / 2)
        });
      }
    };

    FrameworkAlign.prototype.createOverlapDetectors = function() {
      var _this;
      _this = this;
      if (_this.type === 'right') {
        return this.right_element_width = _this.element.outerWidth();
      }
    };

    FrameworkAlign.prototype.checkOverlap = function() {
      var _this, left_element, left_side_border, right_side_border;
      _this = this;
      if (_this.type === 'right') {
        _this.parent.removeClass('overlap');
        left_element = _this.parent.children().eq(_this.element.index() - 1);
        left_side_border = left_element.position().left + left_element.outerWidth();
        right_side_border = _this.parent.outerWidth() - _this.right_element_width;
        if (left_side_border >= right_side_border) {
          return _this.parent.addClass('overlap');
        }
      }
    };

    FrameworkAlign.prototype.fillYSpace = function() {
      var _this, container_height, text_panel_height;
      _this = this;
      if (_this.type === 'fill-y--dynamic') {
        container_height = _this.parent.outerHeight();
        text_panel_height = _this.parent.find('.fw--align--fill-y--fixed').outerHeight();
        return _this.element.outerHeight(container_height - text_panel_height);
      }
    };

    FrameworkAlign.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      $(window).on('resize.FrameworkAlign', function() {
        _this.checkOverlap();
        return _this.fillYSpace();
      });
      return setTimeout(function() {
        return _this.checkOverlap();
      }, 1);
    };

    return FrameworkAlign;

  })();

  theme.classes.FrameworkAnimation = (function() {
    function FrameworkAnimation() {}

    return FrameworkAnimation;

  })();

  theme.classes.FrameworkCart = (function() {
    function FrameworkCart(root) {
      var _this;
      this.root = root;
      this.convertCurrency = bind(this.convertCurrency, this);
      this.openModalListener = bind(this.openModalListener, this);
      this.openOffCanvasListener = bind(this.openOffCanvasListener, this);
      this.removeItem = bind(this.removeItem, this);
      this.removeItemListeners = bind(this.removeItemListeners, this);
      this.updateTotalsComplete = bind(this.updateTotalsComplete, this);
      this.updateTotals = bind(this.updateTotals, this);
      this.plusQuantity = bind(this.plusQuantity, this);
      this.minusQuantity = bind(this.minusQuantity, this);
      this.updateQuantityListeners = bind(this.updateQuantityListeners, this);
      this.addItem = bind(this.addItem, this);
      this.renderOther = bind(this.renderOther, this);
      this.renderListener = bind(this.renderListener, this);
      this.renderCart = bind(this.renderCart, this);
      _this = this;
      _this.adjusting_qty_timer = null;
      _this.table_content = _this.root.find('form > .content');
      _this.render_trigger = $('.fw--cart-modal--trigger-render');
      _this.totals = {};
      _this.add_locked = false;
      _this.render_locked = false;
      if (_this.root.hasClass('off-canvas')) {
        _this.view = 'off canvas';
      }
      if (_this.root.hasClass('modal--content')) {
        _this.view = 'modal';
      }
      _this.temp_quantity = 0;
      _this.renderCart();
      if (_this.view === 'off canvas') {
        _this.openOffCanvasListener();
      }
      _this.openModalListener();
      _this.renderListener();
    }

    FrameworkCart.prototype.renderCart = function(callback) {
      var _this;
      _this = this;
      if (!_this.render_locked) {
        _this.render_locked = true;
        _this.table_content.empty();
        return $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json"
        }).done(function(data, textStatus, jqXHR) {
          var cart, index, item, j, len, ref, row;
          if (textStatus === 'success') {
            cart = data;
            if (cart.items.length) {
              _this.root.removeClass('no-items');
            } else {
              _this.root.addClass('no-items');
            }
            ref = cart.items;
            for (index = j = 0, len = ref.length; j < len; index = ++j) {
              item = ref[index];
              item.image_url = Shopify.resizeImage(item.image, "400x");
              item.price = Currency.formatMoney(item.price, theme.money_format);
              if ((index + 1) === cart.items.length) {
                row = '<div class="variant-id last-variant width--12" data-variant-id=' + item.variant_id + '>';
              } else {
                row = '<div class="variant-id width--12" data-variant-id=' + item.variant_id + '>';
              }
              row += '<div class="width--12 width--medium-4 width--large-6 block">';
              if (item.image_url === null) {
                row += '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"></span>';
              } else {
                row += '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"><a href="' + item.url + '"><img src="' + item.image_url + '" alt="' + item.title + '"></a></span>';
              }
              row += '<span class="title show--small show--large block width--8 spacing--3 font--size-4"><a href="' + item.url + '">' + item.title + '</a></span>';
              row += '</div>';
              row += '<div class="right-column width--12 width--medium-8 width--large-6 block spacing--3y text-align--left text-align--large-right">';
              row += '<span class="title show--medium block width--12 spacing--3 font--size-4"><a href="' + item.url + '">' + item.title + '</a></span>';
              row += '<span class="price font--accent spacing--3 font--size-3 money">' + item.price + '</span>';
              row += '<span class="quantity spacing--3"><div class="input--number">';
              row += '<a tabindex="0" aria-label="' + theme.translations.remove_one_item + '" class="minus">' + theme.utils.addSymbol('minus') + '</a>';
              row += '<input type="text" value="' + item.quantity + '" min="1" pattern="[1-9]*">';
              row += '<a tabindex="0" aria-label="' + theme.translations.add_one_item + '" class="plus">' + theme.utils.addSymbol('plus') + '</a>';
              row += '</div></span>';
              row += '<span class="remove spacing--3">';
              row += '<a aria-label="' + theme.translations.remove_item + '" role="button" href="#" class="cart--remove-button remove">' + theme.utils.addSymbol('cross-circle') + '</a>';
              row += '</span>';
              row += '</div>';
              row += '</div>';
              row += '<div class="spacer spacing--3y"></div>';
              _this.table_content.append(row);
            }
            row = '<div class="totals width--12 text-align--center ">';
            row += '<div class="width--12 width--large-8 block">';
            row += '</div>';
            row += '<div class="block spacing--3y width--12 width--large-4 font--size-3 text-align--large-right text--uppercase">';
            row += '<span class="spacing--3">' + theme.translations.cart_subtotal + '</span>';
            row += '<span class="total spacing--3 money font--accent font--subheading--size">' + _this.totals.price + '</span>';
            row += '</div>';
            row += '</div>';
            row += '<div class="spacer spacing--3y show--small-medium"></div>';
            _this.table_content.append(row);
            _this.updateTotals();
            if (callback) {
              callback();
            }
            $(window).trigger('resize.FrameworkModal');
            _this.render_locked = false;
            _this.removeItemListeners();
            _this.updateQuantityListeners();
            return _this.convertCurrency(_this.root.find('.money'));
          } else {
            return console.log('cart - render item status - ' + textStatus);
          }
        }).fail(function(jqXHR, textStatus) {
          console.log("cart rendering failed");
          return _this.render_locked = false;
        });
      }
    };

    FrameworkCart.prototype.renderListener = function() {
      var _this;
      _this = this;
      return _this.root.on('renderCart', function() {
        return _this.renderCart();
      });
    };

    FrameworkCart.prototype.renderOther = function() {
      var _this;
      _this = this;
      if (theme.utils.mqs.current_window === 'small') {
        return $('.fw--cart.modal--content').trigger('renderCart');
      } else {
        return $('.fw--cart.off-canvas').trigger('renderCart');
      }
    };

    FrameworkCart.prototype.addItem = function(form, callback) {
      var _this;
      _this = this;
      if (!_this.add_locked) {
        _this.add_locked = true;
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: form.serialize()
        }).done(function(data, textStatus, jqXHR) {
          callback(true);
          _this.renderOther();
          return _this.add_locked = false;
        }).fail(function(jqXHR, textStatus) {
          callback(false, $.parseJSON(jqXHR.responseText).description);
          return _this.add_locked = false;
        });
      }
    };

    FrameworkCart.prototype.updateQuantityListeners = function() {
      var _this;
      _this = this;
      _this.table_content.find('.input--number input').attr("autocomplete", "off").on('keyup.LayoutCartModal paste.LayoutCartModal', function() {
        var input, input_wrapper, variant_id;
        input_wrapper = $(this).closest('.input--number');
        input = input_wrapper.find('input');
        if (parseInt(input.val()) > 0) {
          input_wrapper.addClass('updating');
          clearTimeout(_this.adjusting_qty_timer);
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.adjusting_qty_timer = setTimeout(function() {
            input_wrapper.removeClass('updating');
            return _this.updateTotals();
          }, 500);
        } else if (parseInt(input.val()) === 0) {
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.removeItem(variant_id);
          if ($(this).closest('form').find('.variant-id').length === 1) {
            _this.root.addClass('no-items');
          } else {
            $(this).closest('.variant-id').remove();
          }
        }
        return false;
      });
      _this.table_content.find('.input--number .minus').on('keypress.LayoutCartModal click.LayoutCartModal', function(e) {
        var input, input_wrapper, variant_id;
        if (theme.utils.a11yClick(e) === true) {
          input_wrapper = $(this).closest('.input--number');
          input = input_wrapper.find('input');
          if (parseInt(input.val()) > 1) {
            input_wrapper.addClass('updating');
            clearTimeout(_this.adjusting_qty_timer);
            input.val(parseInt(input.val()) - 1);
            variant_id = $(this).closest('.variant-id').data('variant-id');
            _this.adjusting_qty_timer = setTimeout(function() {
              _this.minusQuantity(variant_id, parseInt(input.val()));
              input_wrapper.removeClass('updating');
              return _this.updateTotals();
            }, 500);
          }
          return false;
        }
      });
      return _this.table_content.find('.input--number .plus').on('keypress.LayoutCartModal click.LayoutCartModal', function(e) {
        var input, input_wrapper, variant_id;
        if (theme.utils.a11yClick(e) === true) {
          clearTimeout(_this.adjusting_qty_timer);
          input_wrapper = $(this).closest('.input--number');
          input = input_wrapper.find('input');
          if (_this.temp_quantity === 0) {
            _this.temp_quantity = parseInt(input.val());
          }
          input_wrapper.addClass('updating');
          input.val(1 + parseInt(input.val()));
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.adjusting_qty_timer = setTimeout(function() {
            var add_quantity;
            add_quantity = parseInt(input.val()) - _this.temp_quantity;
            return _this.plusQuantity(variant_id, add_quantity, function(pass, error) {
              if (pass) {
                input_wrapper.removeClass('updating');
                _this.updateTotals();
                return _this.temp_quantity = 0;
              } else {
                input.val(_this.temp_quantity);
                input_wrapper.removeClass('updating');
                _this.updateTotals();
                return _this.temp_quantity = 0;
              }
            });
          }, 500);
          return false;
        }
      });
    };

    FrameworkCart.prototype.minusQuantity = function(variant_id, quantity) {
      var _this;
      _this = this;
      return $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: 'quantity=' + quantity + '&id=' + variant_id
      }).done(function(data, textStatus, jqXHR) {
        if (textStatus === 'success') {
          _this.updateTotals();
          return _this.renderOther();
        } else {
          return console.log('cart - update cart item status - ' + textStatus);
        }
      }).fail(function(jqXHR, textStatus) {
        return console.log("cart - update failed");
      });
    };

    FrameworkCart.prototype.plusQuantity = function(variant_id, quantity, callback) {
      var _this;
      _this = this;
      if (!_this.add_locked) {
        _this.add_locked = true;
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: 'quantity=' + quantity + '&id=' + variant_id
        }).done(function(data, textStatus, jqXHR) {
          callback(true);
          _this.renderOther();
          return _this.add_locked = false;
        }).fail(function(jqXHR, textStatus) {
          callback(false, $.parseJSON(jqXHR.responseText).description);
          return _this.add_locked = false;
        });
      }
    };

    FrameworkCart.prototype.updateTotals = function() {
      var _this;
      _this = this;
      return $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json"
      }).done(function(data, textStatus, jqXHR) {
        var cart, cart_total, item, j, len, ref;
        if (textStatus === 'success') {
          cart = data;
          cart_total = {};
          cart_total.quantity = 0;
          cart_total.price = 0;
          ref = cart.items;
          for (j = 0, len = ref.length; j < len; j++) {
            item = ref[j];
            cart_total.quantity += item.quantity;
            cart_total.price += item.price * item.quantity;
          }
          _this.totals.count = cart_total.quantity;
          _this.totals.price = Currency.formatMoney(cart_total.price, theme.money_format);
          _this.render_trigger.find('.count').html(_this.totals.count);
          _this.render_trigger.find('.total-price').html(_this.totals.price);
          _this.table_content.find('.total').html(_this.totals.price);
          $('.layout--header .layout--off-canvas--open.right').html(_this.totals.count);
          $('.layout--header .cart-link .count').html('(' + _this.totals.count + ')');
          if (_this.totals.count > 0) {
            _this.render_trigger.css('display', 'inline-block');
            $('.layout--header .cart-link .count').css('display', 'inline');
            $('.header--cart-count').css('display', 'inline-block');
          } else {
            _this.render_trigger.hide();
            $('.layout--header .cart-link .count').hide();
          }
          if (theme.currency_switcher_enabled) {
            _this.convertCurrency(_this.render_trigger.find('.total-price'));
            _this.convertCurrency(_this.table_content.find('.total'));
          }
          return _this.updateTotalsComplete();
        } else {
          return console.log('cart - update totals item status - ' + textStatus);
        }
      }).fail(function(jqXHR, textStatus) {
        return console.log("cart - updating totals failed");
      });
    };

    FrameworkCart.prototype.updateTotalsComplete = function() {
      var _this;
      return _this = this;
    };

    FrameworkCart.prototype.removeItemListeners = function() {
      var _this;
      _this = this;
      return _this.table_content.find('a.remove').on('click.LayoutCartModal', function() {
        var variant_id;
        variant_id = $(this).closest('.variant-id').data('variant-id');
        _this.removeItem(variant_id);
        if ($(this).closest('form').find('.variant-id').length === 1) {
          _this.root.addClass('no-items');
          $(window).trigger('resize.FrameworkModal');
        } else {
          $(this).closest('.variant-id').remove();
        }
        _this.updateTotals();
        return false;
      });
    };

    FrameworkCart.prototype.removeItem = function(variant_id) {
      var _this;
      _this = this;
      return _this.minusQuantity(variant_id, 0);
    };

    FrameworkCart.prototype.openOffCanvasListener = function() {
      var _this;
      _this = this;
      return $('.layout--off-canvas--cart--open-trigger').on('click', function() {
        $('.layout--off-canvas--right-sidebar').trigger('open');
        return false;
      });
    };

    FrameworkCart.prototype.openModalListener = function() {
      var _this;
      _this = this;
      return $('.fw--cart-modal--trigger-render').on('click', function() {
        $('.cart-link .modal--link').trigger('click');
        return false;
      });
    };

    FrameworkCart.prototype.convertCurrency = function(elems) {
      var _this;
      _this = this;
      if (theme.currency_switcher_enabled) {
        return Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
      } else {
        return false;
      }
    };

    return FrameworkCart;

  })();

  theme.classes.FrameworkFeaturedBlog = (function() {
    function FrameworkFeaturedBlog(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.item_container = _this.root.find('.featured-blog--body');
      _this.items = _this.root.find('.featured-blog--item');
      _this.matchImageHeights();
      _this.resizeListeners();
    }

    FrameworkFeaturedBlog.prototype.matchImageHeights = function() {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(_this.item_container, _this.items, '.featured-blog--item--image');
    };

    FrameworkFeaturedBlog.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.FeaturedGrid', theme.utils.debounce(100, function() {
        return _this.matchImageHeights();
      }));
    };

    return FrameworkFeaturedBlog;

  })();

  theme.classes.FrameworkFeaturedCollections = (function() {
    function FrameworkFeaturedCollections(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.item_container = _this.root.find('.featured-collections--body');
      _this.items = _this.root.find('.featured-collections--item');
      _this.matchImageHeights();
      _this.resizeListeners();
    }

    FrameworkFeaturedCollections.prototype.matchImageHeights = function() {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(_this.item_container, _this.items, '.featured-collections--image');
    };

    FrameworkFeaturedCollections.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.FeaturedCollections', theme.utils.debounce(100, function() {
        return _this.matchImageHeights();
      }));
    };

    return FrameworkFeaturedCollections;

  })();

  theme.classes.FrameworkFeaturedContent = (function() {
    function FrameworkFeaturedContent(root) {
      var _this;
      this.root = root;
      _this = this;
    }

    return FrameworkFeaturedContent;

  })();

  theme.classes.FrameworkFeaturedGrid = (function() {
    function FrameworkFeaturedGrid(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.item_container = _this.root.find('.featured-grid--body');
      _this.items = _this.root.find('.featured-grid--item');
      _this.text_position = _this.root.data('text-position');
      _this.matchImageHeights();
      _this.resizeListeners();
    }

    FrameworkFeaturedGrid.prototype.matchImageHeights = function() {
      var _this;
      _this = this;
      _this.items.find('.featured-grid--item--image, .placeholder--root').css('height', 'auto');
      if (_this.text_position === 'center' && theme.utils.mqs.current_window !== 'small') {
        return;
      }
      return theme.utils.matchImageHeights(_this.item_container, _this.items, '.featured-grid--item--image');
    };

    FrameworkFeaturedGrid.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.FeaturedGrid', theme.utils.debounce(100, function() {
        return _this.matchImageHeights();
      }));
    };

    return FrameworkFeaturedGrid;

  })();

  theme.classes.FrameworkFeaturedProduct = (function() {
    function FrameworkFeaturedProduct(root) {
      var _this;
      this.root = root;
      this.addProductComplete = bind(this.addProductComplete, this);
      this.renderCart = bind(this.renderCart, this);
      this.addToCartListener = bind(this.addToCartListener, this);
      this.updateVariantImage = bind(this.updateVariantImage, this);
      this.sectionListeners = bind(this.sectionListeners, this);
      this.variantSelected = bind(this.variantSelected, this);
      this.initiateVariants = bind(this.initiateVariants, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.id = _this.root.data('id');
      _this.add_button = _this.root.find('.featured-product--add-to-cart');
      _this.cart_form = _this.root.find('.featured-product--cart-form > form');
      _this.compare_price = _this.root.find('.featured-product--compare-price');
      _this.main_images = _this.root.find('.featured-product--image');
      _this.price = _this.root.find('.featured-product--actual-price');
      _this.price_wrapper = _this.root.find('.featured-product--price-wrapper');
      _this.smart_payment_buttons = _this.root.find('.featured-product--smart-payment-buttons');
      _this.unavailable_variant = _this.root.find('.featured-product--unavailable-variant');
      _this.variant_sold_out = _this.root.find('.featured-product--sold-out--variant');
      _this.cart_form = _this.root.find('.featured-product--cart-form > form');
      _this.json = $.parseJSON(_this.root.find('.featured-product--json').text());
      _this.load();
    }

    FrameworkFeaturedProduct.prototype.load = function() {
      var _this;
      _this = this;
      _this.initiateVariants();
      return _this.addToCartListener();
    };

    FrameworkFeaturedProduct.prototype.initiateVariants = function() {
      var _this, id, options;
      _this = this;
      if (_this.root.find('select').length > 0) {
        id = 'featured-product--select--' + _this.id;
        return options = new Shopify.OptionSelectors(id, {
          product: _this.json,
          onVariantSelected: _this.variantSelected,
          enableHistoryState: false
        });
      }
    };

    FrameworkFeaturedProduct.prototype.variantSelected = function(variant, selector, options) {
      var _this, product_sold_out, variant_compare_price, variant_price;
      _this = this;
      product_sold_out = false;
      if (_this.root.find('.featured-product--sold-out--product').length) {
        product_sold_out = true;
      }
      _this.variant_sold_out.hide();
      _this.unavailable_variant.hide();
      _this.add_button.hide();
      _this.price_wrapper.hide();
      if (!variant) {
        _this.unavailable_variant.show();
        _this.smart_payment_buttons.hide();
        return false;
      } else if (variant && variant.available) {
        _this.price_wrapper.show();
        _this.add_button.show();
        _this.smart_payment_buttons.show();
      } else if (product_sold_out) {
        _this.variant_sold_out.hide();
        _this.add_button.hide();
        _this.smart_payment_buttons.hide();
      } else {
        _this.variant_sold_out.show();
        _this.smart_payment_buttons.hide();
      }
      variant_price = Shopify.formatMoney(variant.price, theme.money_format);
      _this.price.replaceWith('<span class="featured-product--actual-price money">' + variant_price + '</span>');
      _this.price = _this.root.find('.featured-product--actual-price');
      if (variant.compare_at_price > variant.price) {
        variant_compare_price = Shopify.formatMoney(variant.compare_at_price, theme.money_format);
        _this.compare_price.replaceWith('<span class="featured-product--compare-price money">' + variant_compare_price + '</span>');
        _this.compare_price = _this.root.find('.featured-product--compare-price');
        _this.compare_price.show();
      } else {
        _this.compare_price.hide();
      }
      if (theme.settings.currency_switcher_enabled) {
        Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      }
      if (variant.featured_image) {
        return _this.updateVariantImage(variant.featured_image.id);
      }
    };

    FrameworkFeaturedProduct.prototype.sectionListeners = function() {
      var _this;
      _this = this;
      return _this.root.on('theme:section:load', function() {
        return new Shopify.OptionSelectors('featured-product--select', {
          product: theme.product_json,
          onVariantSelected: _this.variantSelected,
          enableHistoryState: true
        });
      });
    };

    FrameworkFeaturedProduct.prototype.updateVariantImage = function(variant_id) {
      var _this, variant_image;
      _this = this;
      _this.main_images.attr('data-active', 'false');
      variant_image = _this.main_images.filter('[data-image-id="' + variant_id + '"]');
      return variant_image.attr('data-active', 'true');
    };

    FrameworkFeaturedProduct.prototype.addToCartListener = function() {
      var _this;
      _this = this;
      if (_this.cart_form.length > 0) {
        return _this.cart_form.submit(function() {
          _this.cart_form.find('.error').remove();
          _this.add_button.attr('data-loading', 'true');
          theme.partials.Cart.addItem($(this), function(pass, error) {
            if (pass) {
              return _this.renderCart();
            } else {
              _this.cart_form.append('<div class="featured-product--error error">' + error + '</div>');
              return _this.add_button.attr('data-loading', 'false');
            }
          });
          return false;
        });
      }
    };

    FrameworkFeaturedProduct.prototype.renderCart = function() {
      var _this;
      _this = this;
      return theme.partials.Cart.renderCart(function() {
        return _this.addProductComplete();
      });
    };

    FrameworkFeaturedProduct.prototype.addProductComplete = function() {
      var _this;
      _this = this;
      _this.add_button.attr('data-loading', 'false');
      return $('.modal.cart-link .modal--link').trigger('click');
    };

    return FrameworkFeaturedProduct;

  })();

  theme.classes.FrameworkFeedbackBar = (function() {
    function FrameworkFeedbackBar(root) {
      var _this;
      this.root = root;
      this.load = bind(this.load, this);
      _this = this;
      _this.messages = _this.root.find('.feedback-bar--message span');
      _this.load();
    }

    FrameworkFeedbackBar.prototype.load = function() {
      var _this, anchor_tag, message, message_elem;
      _this = this;
      _this.messages.hide();
      anchor_tag = window.location.hash.substr(1);
      message = anchor_tag.replace('feedback-bar--', '');
      message_elem = _this.messages.filter('[data-feedback-bar--message="' + message + '"]');
      if (message_elem.length) {
        message_elem.show();
        setTimeout(function() {
          return _this.root.attr('data-feedback-bar--open', 'true');
        }, 200);
        return setTimeout(function() {
          return _this.root.attr('data-feedback-bar--open', 'false');
        }, 3000);
      }
    };

    return FrameworkFeedbackBar;

  })();

  
  theme.classes.FrameworkInstagram = (function() {
    function FrameworkInstagram(container1) {
      var _this;
      this.container = container1;
      this.load = bind(this.load, this);
      _this = this;
      _this.username = _this.container.data('username');
      _this.access_token = _this.container.data('access-token');
      _this.body = _this.container.find('.instagram--body');
      _this.rows = _this.container.data('rows');
      _this.columns = _this.container.data('columns');
      _this.total_items = _this.rows * _this.columns;
      if (theme.utils.mqs.current_window === 'small') {
        _this.total_items = 6;
      }
      _this.load();
    }

    FrameworkInstagram.prototype.load = function() {
      var _this;
      _this = this;
      if (_this.access_token.length < 1) {
        return false;
      }
      return $.ajax({
        dataType: "jsonp",
        url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + _this.access_token + '&count=' + _this.total_items,
        success: function(response) {
          var data, i, img_src, j, ref, results1;
          if (response.meta.code === 200) {
            data = response.data;
            results1 = [];
            for (i = j = 0, ref = _this.total_items - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
              if (data[i]) {
                img_src = data[i].images.standard_resolution.url;
                img_src = img_src.replace("http:", "https:");
                results1.push(_this.body.append('<a class="instagram--item" target="_blank" href="' + data[i].link + '" > <div class="instagram--item-container"> <div class="instagram--image" style="background-image: url(\'' + img_src + '\');" > </div> </div> </a>'));
              } else {
                results1.push(void 0);
              }
            }
            return results1;
          } else {
            return _this.items.append('<h4 class="error">' + response.meta.error_message + '</h4>');
          }
        },
        error: function(jqXHR, textStatus) {
          console.log(jqXHR);
          return console.log(textStatus);
        }
      });
    };

    return FrameworkInstagram;

  })();
  

  theme.classes.FrameworkLoadingAnimation = (function() {
    function FrameworkLoadingAnimation(root) {
      var _this;
      this.root = root;
      _this = this;
      if (_this.root.hasClass('tiny')) {
        _this.root.spin('tiny');
      } else {
        _this.root.spin('small');
      }
    }

    return FrameworkLoadingAnimation;

  })();

  theme.classes.FrameworkMap = (function() {
    function FrameworkMap(root) {
      var _this;
      this.root = root;
      this.buildStyles = bind(this.buildStyles, this);
      this.buildMap = bind(this.buildMap, this);
      this.geolocate = bind(this.geolocate, this);
      this.loadMapsApi = bind(this.loadMapsApi, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.api_status = null;
      _this.map_instance = null;
      _this.key = _this.root.data('api-key');
      _this.address = _this.root.data('address');
      _this.theme = _this.root.data('theme');
      _this.styles = null;
      _this.container = _this.root.find('.map--google-maps');
      _this.center = null;
      _this.load();
    }

    FrameworkMap.prototype.load = function() {
      var _this;
      _this = this;
      if (_this.container.length > 0) {
        return _this.loadMapsApi();
      }
    };

    FrameworkMap.prototype.loadMapsApi = function() {
      var _this, other_map_loading_checker;
      _this = this;
      if (theme.utils.google_map_api_status === 'loading') {
        return other_map_loading_checker = setInterval(function() {
          if (theme.utils.google_map_api_status === 'loaded') {
            _this.geolocate();
            return clearInterval(other_map_loading_checker);
          }
        }, 100);
      } else if (typeof window.google === 'undefined') {
        theme.utils.google_map_api_status = 'loading';
        return $.getScript('https://maps.googleapis.com/maps/api/js?key=' + _this.key).then(function() {
          _this.geolocate();
          return theme.utils.google_map_api_status = 'loaded';
        });
      } else {
        return _this.geolocate();
      }
    };

    FrameworkMap.prototype.geolocate = function() {
      var _this, geocoder;
      _this = this;
      geocoder = new google.maps.Geocoder;
      return geocoder.geocode({
        address: _this.address
      }, function(results, status) {
        if (status === 'OK') {
          _this.center = results[0].geometry.location;
          _this.buildStyles();
          return _this.buildMap();
        } else {
          return console.log('couldn\'t convert address with geocoder');
        }
      });
    };

    FrameworkMap.prototype.buildMap = function() {
      var _this, center, map, mapOptions, marker;
      _this = this;
      mapOptions = {
        zoom: 15,
        center: _this.center,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false,
        styles: _this.styles
      };
      map = new google.maps.Map(_this.container[0], mapOptions);
      center = map.getCenter();
      marker = new google.maps.Marker({
        map: map,
        position: map.getCenter()
      });
      return _this.map_instance = google.maps.event.addDomListener(window, 'resize', theme.utils.debounce(500, function() {
        google.maps.event.trigger(map, 'resize');
        map.setCenter(center);
      }));
    };

    FrameworkMap.prototype.buildStyles = function() {
      var _this;
      _this = this;
      if (_this.theme === 'grayscale') {
        return _this.styles = [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          }, {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }, {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          }, {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          }, {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          }, {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          }, {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }, {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          }, {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          }, {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          }, {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }, {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          }, {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#c9c9c9"
              }
            ]
          }, {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }
        ];
      } else if (_this.theme === 'dark') {
        return _this.styles = [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#212121"
              }
            ]
          }, {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }, {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          }, {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#212121"
              }
            ]
          }, {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          }, {
            "featureType": "administrative.country",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }, {
            "featureType": "administrative.land_parcel",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }, {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          }, {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#181818"
              }
            ]
          }, {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          }, {
            "featureType": "poi.park",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#1b1b1b"
              }
            ]
          }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#2c2c2c"
              }
            ]
          }, {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#8a8a8a"
              }
            ]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#373737"
              }
            ]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#3c3c3c"
              }
            ]
          }, {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#4e4e4e"
              }
            ]
          }, {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          }, {
            "featureType": "transit",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#000000"
              }
            ]
          }, {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#3d3d3d"
              }
            ]
          }
        ];
      }
    };

    return FrameworkMap;

  })();

  theme.classes.FrameworkMediaQueries = (function() {
    function FrameworkMediaQueries() {
      this.screenSizeListener = bind(this.screenSizeListener, this);
      this.getScreenSize = bind(this.getScreenSize, this);
      this.medium_screen = 768;
      this.large_screen = 1024;
      this.current_window = null;
      this.getScreenSize();
      this.screenSizeListener();
    }

    FrameworkMediaQueries.prototype.getScreenSize = function() {
      var _this;
      _this = this;
      if (window.matchMedia('only screen and (min-width: ' + _this.large_screen + 'px)').matches) {
        if (_this.current_window !== 'large') {
          $.event.trigger("largeWindow");
          return _this.current_window = 'large';
        }
      } else if (window.matchMedia('only screen and (min-width: ' + _this.medium_screen + 'px)').matches) {
        if (_this.current_window !== 'medium') {
          $.event.trigger("mediumWindow");
          return _this.current_window = 'medium';
        }
      } else {
        if (_this.current_window !== 'small') {
          $.event.trigger("smallWindow");
          return _this.current_window = 'small';
        }
      }
    };

    FrameworkMediaQueries.prototype.screenSizeListener = function() {
      var _this;
      _this = this;
      return $(window).resize(function() {
        return _this.getScreenSize();
      });
    };

    return FrameworkMediaQueries;

  })();

  theme.classes.FrameworkModal = (function() {
    function FrameworkModal(container1) {
      var _this;
      this.container = container1;
      _this = this;
      _this.fullscreen = _this.container.data('modal--fullscreen') ? true : false;
      if (_this.container.data('modal--custom-close')) {
        _this.custom_close_button = _this.container.data('modal--custom-close');
      } else {
        _this.custom_close_button = '';
      }
      _this.force_view = _this.container.data('force-view');
      _this.view = _this.container.data('modal--view');
      _this.links = _this.container.find('.modal--link');
      _this.content = _this.container.find('.modal--content');
      _this.window = _this.createModalWindow();
      _this.window_container = _this.window.find('.modal--container');
      _this.mask = _this.window.find('.modal--mask');
      _this.close_button = _this.window.find('.modal--close');
      _this.next_button = _this.window.find('.modal--next');
      _this.prev_button = _this.window.find('.modal--prev');
      _this.slider = null;
      _this.slides = null;
      _this.main_content_window = $('.off-canvas--main-content');
      _this.openListeners();
      _this.modal_state = 'closed';
      _this.nav_lock = false;
    }

    FrameworkModal.prototype.createModalWindow = function() {
      var _this, window, window_html;
      _this = this;
      window = null;
      if ($('.modal--window').length) {
        window = $('.modal--window');
      } else {
        window_html = '<div class="modal--window"> <div class="modal--mask"></div> <div class="modal--container"></div> <button class="modal--close">' + theme.utils.addSymbol('cross') + '</button> <button class="modal--prev">' + theme.utils.addSymbol('chevron-left') + '</button> <button class="modal--next">' + theme.utils.addSymbol('chevron-right') + '</button> </div>';
        window = $(window_html).appendTo('body');
      }
      return window;
    };

    FrameworkModal.prototype.openListeners = function() {
      var _this;
      _this = this;
      return _this.links.on('keypress.FrameworkModal, click.FrameworkModal, quick-open', function(e) {
        var clicked_item;
        if (e.type === 'keypress' && theme.utils.a11yClick(e) === false) {
          return false;
        }
        clicked_item = $(this);
        _this.links.each(function(index) {
          if ($(this).is(clicked_item)) {
            if (e.type === 'quick-open') {
              return _this.open(index, true);
            } else {
              return _this.open(index);
            }
          }
        });
        return false;
      });
    };

    FrameworkModal.prototype.open = function(index, quick_open) {
      var _this, scrolled_position;
      if (quick_open == null) {
        quick_open = false;
      }
      _this = this;
      if (_this.modal_state === 'closed') {
        _this.modal_state = 'opened';
        $('html').addClass('modal-open');
        _this.window.attr('data-modal--fullscreen', _this.fullscreen);
        _this.window.attr('data-modal--custom-close', _this.custom_close_button);
        _this.window.attr('data-modal--view', _this.view);
        _this.closeListeners();
        _this.positionListeners();
        scrolled_position = $(window).scrollTop();
        _this.main_content_window.css({
          position: 'fixed',
          top: -scrolled_position
        });
        _this.moveContentToWindow();
        if (_this.slides.length > 1) {
          _this.next_button.show();
          _this.prev_button.show();
          _this.prevListeners();
          _this.nextListeners();
        }
        _this.window.show();
        _this.window_container.show();
        _this.renderVideo(_this.slides.eq(index));
        if (quick_open) {
          _this.slides.eq(index).addClass('active');
          return _this.position();
        } else {
          _this.mask.fadeIn();
          return _this.loadModal(_this.slides.eq(index), function() {
            return setTimeout(function() {
              return _this.window_container.find('input[type="text"]').focus();
            }, 0);
          });
        }
      }
    };

    FrameworkModal.prototype.moveContentToWindow = function(index) {
      var _this, content;
      _this = this;
      content = _this.container.find('.modal--content');
      _this.window_container.append(content);
      return _this.slides = _this.window_container.find('.modal--content');
    };

    FrameworkModal.prototype.detectImageSlide = function(slide) {
      var _this;
      return _this = this;
    };

    FrameworkModal.prototype.renderVideo = function(slide) {
      var _this, id, iframe, src_url, type, video;
      _this = this;
      video = slide.find('.responsive-video').first();
      src_url = video.data('video');
      type = _this.extractVideoType(src_url);
      id = _this.extractVideoId(src_url, type);
      iframe = _this.createIframe(type, id);
      if (type === 'vimeo') {
        video.addClass('vimeo');
      }
      if (type === 'kickstarter') {
        video.addClass('kickstarter');
      }
      return video.append(iframe);
    };

    FrameworkModal.prototype.extractVideoType = function(src_url) {
      var _this, matches, re;
      _this = this;
      re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
      matches = re.exec(src_url);
      if (matches) {
        return 'youtube';
      }
      re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
      matches = re.exec(src_url);
      if (matches) {
        return 'vimeo';
      }
      re = /^.*(kickstarter)\.com/g;
      matches = re.exec(src_url);
      if (matches) {
        return 'kickstarter';
      }
      return false;
    };

    FrameworkModal.prototype.extractVideoId = function(src_url, type) {
      var _this, match, regExp;
      _this = this;
      if (type === 'youtube') {
        regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        match = src_url.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
      } else if (type === "vimeo") {
        regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        match = src_url.match(regExp);
        if (match) {
          return match[2];
        }
      } else if (type === "kickstarter") {
        regExp = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/;
        match = src_url.match(regExp);
        if (match) {
          return match[1];
        }
      }
    };

    FrameworkModal.prototype.createIframe = function(type, id) {
      var _this;
      _this = this;
      if (type === "youtube") {
        return '<iframe  src="//www.youtube.com/embed/' + id + '?autoplay=1" frameborder="0" allowfullwidth></iframe>';
      } else if (type === "vimeo") {
        return '<iframe src="//player.vimeo.com/video/' + id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
      } else if (type === "kickstarter") {
        return '<iframe src="//www.kickstarter.com/projects/' + id + '/widget/video.html" frameborder="0" webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>';
      }
    };

    FrameworkModal.prototype.removeVideos = function() {
      var _this;
      _this = this;
      return _this.slides.find('.responsive-video').each(function() {
        if ($(this).data('video')) {
          return $(this).find('iframe').remove();
        }
      });
    };

    FrameworkModal.prototype.loadModal = function(modal, callback) {
      var _this;
      _this = this;
      modal.addClass('active');
      _this.position();
      if (callback) {
        callback();
      }
      return _this.nav_lock = false;
    };

    FrameworkModal.prototype.position = function() {
      var _this, active_modal, entire_modal_height, modal_height, modal_width;
      _this = this;
      if (_this.window_container != null) {
        active_modal = _this.content.filter('.active');
        _this.window_container.attr('style', '');
        _this.positionVideoColumns(active_modal);
        _this.detectImageSlide(active_modal);
        _this.window.removeClass('fixed');
        modal_height = active_modal.outerHeight();
        modal_width = active_modal.outerWidth();
        entire_modal_height = modal_height + parseInt(_this.window.css('padding-top')) + parseInt(_this.window.css('padding-bottom'));
        if (_this.fullscreen) {
          return;
        }
        if (active_modal.hasClass('type--image')) {
          entire_modal_height = modal_height;
        }
        if ($(window).height() >= entire_modal_height && _this.force_view !== 'absolute') {
          return _this.window.addClass('fixed');
        } else {
          $("html, body").animate({
            scrollTop: 0
          }, '0');
          $('body,html').on('DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal', function(e) {
            if (e.which > 0 || e.type === "mousewheel" || e.type === "touchmove") {
              return $("html,body").stop();
            }
          });
          return _this.window.removeClass('fixed');
        }
      }
    };

    FrameworkModal.prototype.positionVideoColumns = function(modal) {
      var _this, column_one, column_two, height_one, height_two;
      _this = this;
      if (modal.find('.responsive-video').length > 0) {
        column_one = modal.find('.fw--blocks > div').eq(0);
        column_two = modal.find('.fw--blocks > div').eq(1);
        column_one.css({
          width: ''
        });
        column_two.css({
          width: ''
        });
        height_one = column_one.outerHeight();
        height_two = column_two.outerHeight();
        if (height_one < height_two) {
          column_one.css({
            width: '100%'
          });
          return column_two.css({
            width: '100%'
          });
        }
      }
    };

    FrameworkModal.prototype.positionListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.FrameworkModal', function() {
        return _this.position();
      });
    };

    FrameworkModal.prototype.nextListeners = function() {
      var _this;
      _this = this;
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 39) {
          return _this.next();
        }
      });
      return _this.next_button.on('click.FrameworkModal', function() {
        return _this.next();
      });
    };

    FrameworkModal.prototype.next = function() {
      var _this, active_slide, index;
      _this = this;
      if (!_this.nav_lock) {
        _this.nav_lock = true;
        index = _this.slides.filter('.active').index();
        _this.slides.removeClass('active');
        _this.removeVideos();
        if ((index + 1) === _this.slides.length) {
          active_slide = _this.slides.eq(0);
        } else {
          active_slide = _this.slides.eq(index + 1);
        }
        _this.renderVideo(active_slide);
        return _this.loadModal(active_slide);
      }
    };

    FrameworkModal.prototype.prevListeners = function() {
      var _this;
      _this = this;
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 37) {
          return _this.prev();
        }
      });
      return _this.prev_button.on('click.FrameworkModal', function() {
        return _this.prev();
      });
    };

    FrameworkModal.prototype.prev = function() {
      var _this, active_slide, index;
      _this = this;
      if (!_this.nav_lock) {
        _this.nav_lock = true;
        index = _this.slides.filter('.active').index();
        _this.slides.removeClass('active');
        _this.removeVideos();
        if (index === 0) {
          active_slide = _this.slides.eq(_this.slides.length - 1);
        } else {
          active_slide = _this.slides.eq(index - 1);
        }
        _this.renderVideo(active_slide);
        return _this.loadModal(active_slide);
      }
    };

    FrameworkModal.prototype.closeListeners = function() {
      var _this;
      _this = this;
      _this.container.on('quick-close', function() {
        return _this.close(true);
      });
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 27) {
          return _this.close();
        }
      });
      _this.mask.on('click.FrameworkModal', function() {
        return _this.close();
      });
      _this.window_container.on('click.FrameworkModal', function() {
        return _this.close();
      });
      _this.content.on('click.FrameworkModal', function(e) {
        return e.stopPropagation();
      });
      return _this.close_button.on('click.FrameworkModal', function() {
        return _this.close();
      });
    };

    FrameworkModal.prototype.close = function(quick_close) {
      var _this, scrolled_position;
      if (quick_close == null) {
        quick_close = false;
      }
      _this = this;
      scrolled_position = parseInt(_this.main_content_window.css('top')) * -1;
      _this.container.trigger('modalClosed');
      _this.main_content_window.css({
        top: '0',
        position: 'relative'
      });
      $(window).scrollTop(scrolled_position);
      _this.putBackContent();
      _this.next_button.hide();
      _this.prev_button.hide();
      _this.window.hide();
      if (quick_close) {
        _this.mask.hide();
        this.window_container.empty();
        _this.modal_state = 'closed';
      } else {
        _this.mask.fadeOut(function() {
          _this.window_container.empty();
          return _this.modal_state = 'closed';
        });
      }
      $('html').removeClass('modal-open');
      _this.removeListeners();
      return $(window).trigger('FrameworkModal.afterClose');
    };

    FrameworkModal.prototype.putBackContent = function() {
      var _this;
      _this = this;
      _this.removeVideos();
      return _this.slides.removeClass('active').appendTo(_this.container);
    };

    FrameworkModal.prototype.removeListeners = function() {
      var _this;
      _this = this;
      $(document).off('keydown.FrameworkModal');
      $(window).off('resize.FrameworkModal');
      $('body,html').off('DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal');
      _this.next_button.off('click.FrameworkModal');
      _this.prev_button.off('click.FrameworkModal');
      _this.close_button.off('click.FrameworkModal');
      _this.mask.off('click.FrameworkModal');
      return _this.window_container.off('click.FrameworkModal');
    };

    return FrameworkModal;

  })();

  theme.classes.FrameworkOffCanvas = (function() {
    function FrameworkOffCanvas(root) {
      var _this;
      this.root = root;
      this.touchListener = bind(this.touchListener, this);
      this.closeRight = bind(this.closeRight, this);
      this.closeLeft = bind(this.closeLeft, this);
      this.fadeInOverlay = bind(this.fadeInOverlay, this);
      this.openRight = bind(this.openRight, this);
      this.openLeft = bind(this.openLeft, this);
      this.toggle = bind(this.toggle, this);
      this.toggleListeners = bind(this.toggleListeners, this);
      this.viewPortHeightListener = bind(this.viewPortHeightListener, this);
      this.setViewPortHeight = bind(this.setViewPortHeight, this);
      this.setState = bind(this.setState, this);
      this.unload = bind(this.unload, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.viewport = $('.off-canvas--viewport');
      _this.left_sidebar = $('.off-canvas--left-sidebar');
      _this.right_sidebar = $('.off-canvas--right-sidebar');
      _this.main_content = $('.off-canvas--main-content');
      _this.overlay = $('.off-canvas--overlay');
      _this.state = 'closed';
      _this.load();
    }

    FrameworkOffCanvas.prototype.load = function() {
      var _this;
      _this = this;
      _this.close = $('.off-canvas--close');
      _this.triggers = $('.off-canvas--open');
      _this.setViewPortHeight();
      _this.viewPortHeightListener();
      _this.toggleListeners();
      return _this.touchListener();
    };

    FrameworkOffCanvas.prototype.unload = function() {
      var _this;
      _this = this;
      _this.triggers.off('click');
      _this.overlay.add(_this.close).off('click');
      $(document).off('touchstart.FrameworkOffCanvas');
      return $(document).off('touchend.FrameworkOffCanvas');
    };

    FrameworkOffCanvas.prototype.setState = function(state) {
      var _this;
      _this = this;
      _this.state = state;
      return _this.root.attr('data-off-canvas--state', state);
    };

    FrameworkOffCanvas.prototype.setViewPortHeight = function() {
      var _this;
      _this = this;
      return _this.viewport.css({
        'min-height': $(window).height()
      });
    };

    FrameworkOffCanvas.prototype.viewPortHeightListener = function() {
      var _this;
      _this = this;
      return $(window).resize(function() {
        return _this.setViewPortHeight();
      });
    };

    FrameworkOffCanvas.prototype.toggleListeners = function() {
      var _this;
      _this = this;
      _this.triggers.on('click', function() {
        if ($(this).data('off-canvas--open') === 'left-sidebar') {
          _this.toggle('left-sidebar');
        } else if ($(this).data('off-canvas--open') === 'right-sidebar') {
          _this.toggle('right-sidebar');
        }
        return false;
      });
      return _this.overlay.add(_this.close).on('click', function() {
        if (_this.state === 'left-open') {
          return _this.toggle('left-sidebar');
        } else if (_this.state === 'right-open') {
          return _this.toggle('right-sidebar');
        }
      });
    };

    FrameworkOffCanvas.prototype.toggle = function(element) {
      var _this;
      _this = this;
      if (element === 'left-sidebar' && _this.state === 'closed') {
        return _this.openLeft();
      } else if (element === 'left-sidebar' && _this.state === 'left-open') {
        return _this.closeLeft();
      } else if (element === 'right-sidebar' && _this.state === 'closed') {
        return _this.openRight();
      } else if (element === 'right-sidebar' && _this.state === 'right-open') {
        return _this.closeRight();
      }
    };

    FrameworkOffCanvas.prototype.openLeft = function() {
      var _this;
      _this = this;
      _this.setState('left-open');
      _this.main_content.css({
        position: 'fixed',
        top: -($(window).scrollTop())
      });
      _this.left_sidebar.velocity({
        translateX: [0, '-100%']
      }, {
        complete: function() {
          return _this.left_sidebar.css({
            position: 'relative'
          });
        }
      });
      return _this.fadeInOverlay();
    };

    FrameworkOffCanvas.prototype.openRight = function() {
      var _this;
      _this = this;
      _this.setState('right-open');
      _this.main_content.css({
        position: 'fixed',
        top: -($(window).scrollTop())
      });
      _this.right_sidebar.velocity({
        translateX: ['-100%', 0]
      }, {
        complete: function() {
          return _this.right_sidebar.css({
            position: 'relative'
          });
        }
      });
      return _this.fadeInOverlay();
    };

    FrameworkOffCanvas.prototype.fadeInOverlay = function() {
      var _this;
      _this = this;
      _this.overlay.show();
      return _this.overlay.velocity({
        opacity: '0.3'
      });
    };

    FrameworkOffCanvas.prototype.closeLeft = function() {
      var _this, scrolled_position;
      _this = this;
      if (_this.state !== 'left-open') {
        return false;
      }
      _this.setState('closed');
      scrolled_position = parseInt(_this.main_content.css('top')) * -1;
      _this.left_sidebar.velocity({
        translateX: ['-100%', 0]
      }, {
        complete: function() {
          _this.left_sidebar.css({
            position: 'absolute'
          });
          _this.main_content.css({
            position: 'relative',
            top: 'initial'
          });
          return $(window).scrollTop(scrolled_position);
        }
      });
      return _this.overlay.velocity('fadeOut');
    };

    FrameworkOffCanvas.prototype.closeRight = function() {
      var _this, scrolled_position;
      _this = this;
      if (_this.state !== 'right-open') {
        return false;
      }
      _this.setState('closed');
      scrolled_position = parseInt(_this.main_content.css('top')) * -1;
      _this.right_sidebar.velocity({
        translateX: [0, '-100%']
      }, {
        complete: function() {
          _this.right_sidebar.css({
            position: 'absolute'
          });
          _this.main_content.css({
            position: 'relative',
            top: 'initial'
          });
          return $(window).scrollTop(scrolled_position);
        }
      });
      return _this.overlay.velocity('fadeOut');
    };

    FrameworkOffCanvas.prototype.touchListener = function() {
      var _this, position;
      _this = this;
      if (!Modernizr.touchevents) {
        return false;
      }
      position = {
        start: {},
        end: {}
      };
      $(document).on('touchstart.FrameworkOffCanvas', function(e) {
        position.start.x = e.originalEvent.touches[0].clientX;
        position.start.y = e.originalEvent.touches[0].clientY;
      });
      return $(document).on('touchend.FrameworkOffCanvas', function(e) {
        position.end.x = e.originalEvent.changedTouches[0].clientX;
        position.end.y = e.originalEvent.changedTouches[0].clientY;
        if (Math.abs(position.start.y - position.end.y) > 30) {
          return false;
        }
        if (position.start.x > position.end.x + 5) {
          return _this.closeLeft();
        } else if (position.start.x < position.end.x - 5) {
          return _this.closeRight();
        }
      });
    };

    return FrameworkOffCanvas;

  })();

  theme.classes.FrameworkSearch = (function() {
    function FrameworkSearch(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.getResults = bind(this.getResults, this);
      this.listenForKeyEntered = bind(this.listenForKeyEntered, this);
      this.getSearchUrl = bind(this.getSearchUrl, this);
      this.searchLinks = bind(this.searchLinks, this);
      this.loadSpinners = bind(this.loadSpinners, this);
      this.onOpen = bind(this.onOpen, this);
      _this = this;
      _this.articles = _this.root.find('.search--articles');
      _this.form = _this.root.find('form');
      _this.icon = _this.root.find('.search--icon');
      _this.loading = _this.root.find('.search--loading');
      _this.no_results = _this.root.find('.search--no-results');
      _this.products = _this.root.find('.search--products');
      _this.results = _this.root.find('.search--results');
      _this.text_box = _this.root.find('.search--textbox');
      _this.toggle_link = _this.root.find('.search--toggle');
      _this.show_articles = _this.root.data('show-articles');
      _this.show_pages = _this.root.data('show-pages');
      _this.view = _this.root.data('view');
      _this.ajax_request = null;
      _this.search_term = null;
      _this.search_url = null;
      _this.close_results_timer = null;
      _this.typing_timer = null;
      _this.article_page_combination = "";
      _this.offCanvas = null;
      if (theme.partials.OffCanvas !== void 0) {
        _this.offCanvas = theme.partials.OffCanvas;
      } else {
        _this.offCanvas = theme.partials.FrameworkOffCanvas;
      }
      if (_this.show_articles && _this.show_pages) {
        _this.article_page_combination = 'article,page';
      } else if (_this.show_articles) {
        _this.article_page_combination = 'article';
      } else if (_this.show_pages) {
        _this.article_page_combination = 'page';
      }
      if (_this.view === 'modal') {
        _this.searchLinks();
        _this.getSearchUrl();
        _this.listenForKeyEntered();
        _this.loadSpinners();
      }
      _this.resizeListeners();
      _this.matchImageHeights();
    }

    FrameworkSearch.prototype.onOpen = function() {
      var _this, temp_val;
      _this = this;
      _this.text_box.focus();
      temp_val = _this.text_box.val();
      _this.text_box.val('');
      _this.text_box.val(temp_val);
      return _this.text_box.trigger('keyup');
    };

    FrameworkSearch.prototype.loadSpinners = function() {
      var _this, spinner;
      _this = this;
      spinner = _this.loading.find('.animation');
      if (spinner.hasClass('tiny')) {
        return spinner.spin('tiny');
      } else {
        return spinner.spin('small');
      }
    };

    FrameworkSearch.prototype.searchLinks = function() {
      var _this;
      _this = this;
      $('.off-canvas--main-content a[href="/search"]').on('click', function() {
        $('[data-trigger="search-modal"]').trigger('click');
        _this.onOpen();
        return false;
      });
      $('.off-canvas--right-sidebar a[href="/search"]').on('click', function() {
        _this.offCanvas.closeRight();
        setTimeout(function() {
          $('[data-trigger="search-modal"]').trigger('click');
          return _this.onOpen();
        }, 450);
        return false;
      });
      return $('.off-canvas--left-sidebar a[href="/search"]').on('click', function() {
        _this.offCanvas.closeLeft();
        setTimeout(function() {
          $('[data-trigger="search-modal"]').trigger('click');
          return _this.onOpen();
        }, 450);
        return false;
      });
    };

    FrameworkSearch.prototype.getSearchUrl = function() {
      var _this;
      _this = this;
      _this.search_url = window.location.href;
      _this.search_url = _this.search_url.replace(window.location.hostname + window.location.pathname, window.location.hostname + '/search');
      _this.search_url = _this.search_url.replace('#', '');
      if (_this.search_url.indexOf("?") >= 0) {
        return _this.search_url = _this.search_url + '&';
      } else {
        return _this.search_url = _this.search_url + '?';
      }
    };

    FrameworkSearch.prototype.listenForKeyEntered = function() {
      var _this;
      _this = this;
      return _this.text_box.attr("autocomplete", "off").on("keyup paste", function() {
        var term;
        clearTimeout(_this.typing_timer);
        term = $(this).val();
        if (term.length < 2) {
          _this.products.empty();
          _this.articles.empty();
          _this.loading.hide();
          _this.icon.show();
          return false;
        }
        _this.loading.show();
        _this.icon.hide();
        return _this.typing_timer = setTimeout(function() {
          var url;
          clearTimeout(_this.typing_timer);
          url = _this.search_url + "view=ajax-product&type=product&q=" + term + "*";
          _this.getResults(url, term, 'product');
          if (_this.show_articles || _this.show_pages) {
            url = _this.search_url + "view=ajax-article-page&type=" + _this.article_page_combination + "&q=" + term + "*";
            return _this.getResults(url, term, 'article');
          }
        }, 750);
      });
    };

    FrameworkSearch.prototype.getResults = function(url, term, type) {
      var _this;
      _this = this;
      _this.products.empty();
      _this.articles.empty();
      $.ajax({
        url: url,
        type: "GET",
        dataType: "html",
        success: function(data) {
          _this.loading.hide();
          _this.icon.show();
          if (type === 'product') {
            _this.products.empty();
            _this.products.append(data);
            return _this.matchImageHeights();
          } else if (type === 'article') {
            _this.articles.empty();
            return _this.articles.append(data);
          }
        },
        error: function(jqxhr, textStatus, error) {
          var err;
          err = textStatus + ', ' + error;
          return console.log('search.json Request Failed: ' + err);
        }
      });
    };

    FrameworkSearch.prototype.matchImageHeights = function() {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(_this.products, _this.products.find('.product--root'), '.product--image-wrapper');
    };

    FrameworkSearch.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.Search', theme.utils.debounce(100, function() {
        return _this.matchImageHeights();
      }));
    };

    return FrameworkSearch;

  })();

  theme.classes.Sections = (function() {
    function Sections() {
      this.unload = bind(this.unload, this);
      this.deselectBlock = bind(this.deselectBlock, this);
      this.selectBlock = bind(this.selectBlock, this);
      this.deselectSection = bind(this.deselectSection, this);
      this.selectSection = bind(this.selectSection, this);
      this.load = bind(this.load, this);
      this.getActiveBlock = bind(this.getActiveBlock, this);
      this.getActiveSection = bind(this.getActiveSection, this);
      this.listeners = bind(this.listeners, this);
      var _this;
      _this = this;
      _this.listeners();
    }

    Sections.prototype.listeners = function() {
      var _this;
      _this = this;
      _this.load();
      _this.unload();
      _this.selectSection();
      _this.deselectSection();
      _this.selectBlock();
      return _this.deselectBlock();
    };

    Sections.prototype.getActiveSection = function(evt) {
      var _this, active_section;
      _this = this;
      active_section = $(evt.target).find('[data-section-id]');
      return active_section;
    };

    Sections.prototype.getActiveBlock = function(evt) {
      var _this, active_block;
      _this = this;
      active_block = $(evt.target);
      return active_block;
    };

    Sections.prototype.load = function(evt) {
      var _this;
      _this = this;
      return $(document).on('shopify:section:load', function(evt) {
        var active_section;
        theme.utils.loadJsClasses();
        active_section = _this.getActiveSection(evt);
        active_section.triggerHandler("theme:section:load");
        return active_section.find('[data-js-class]').each(function() {
          return $(this).triggerHandler("theme:section:load");
        });
      });
    };

    Sections.prototype.selectSection = function() {
      var _this;
      _this = this;
      return $(document).on('shopify:section:select', function(evt) {
        var active_section;
        active_section = _this.getActiveSection(evt);
        return active_section.triggerHandler("theme:section:select");
      });
    };

    Sections.prototype.deselectSection = function() {
      var _this;
      _this = this;
      return $(document).on('shopify:section:deselect', function(evt) {
        var active_section;
        active_section = _this.getActiveSection(evt);
        return active_section.triggerHandler('theme:section:deselect');
      });
    };

    Sections.prototype.selectBlock = function() {
      var _this;
      _this = this;
      return $(document).on('shopify:block:select', function(evt) {
        var active_block;
        active_block = _this.getActiveBlock(evt);
        return active_block.triggerHandler('theme:block:select');
      });
    };

    Sections.prototype.deselectBlock = function() {
      var _this;
      _this = this;
      return $(document).on('shopify:block:deselect', function(evt) {
        var active_block;
        active_block = _this.getActiveBlock(evt);
        return active_block.triggerHandler('theme:block:deselect');
      });
    };

    Sections.prototype.unload = function(evt) {
      var _this;
      _this = this;
      return $(document).on('shopify:section:unload', function(evt) {
        var active_section;
        active_section = _this.getActiveSection(evt);
        active_section.triggerHandler("theme:section:unload");
        return active_section.find('[data-js-loaded="true"]').each(function() {
          return $(this).triggerHandler("theme:section:unload");
        });
      });
    };

    return Sections;

  })();

  theme.classes.FrameworkSlider = (function() {
    function FrameworkSlider(container1) {
      this.container = container1;
      this.eventListeners = bind(this.eventListeners, this);
      this.alignPlayButton = bind(this.alignPlayButton, this);
      this.updateContextMenu = bind(this.updateContextMenu, this);
      this.autoplay = bind(this.autoplay, this);
      this.formatPaginationNumbers = bind(this.formatPaginationNumbers, this);
      this.getActiveIndex = bind(this.getActiveIndex, this);
      this.createSlider = bind(this.createSlider, this);
      this.autoplay_enabled = this.container.data('autoplay') ? true : false;
      this.navigation = this.container.data('navigation') ? true : false;
      this.pagination_numbers = this.container.data('pagination-numbers') ? true : false;
      this.autoplay_frequency = 3000;
      this.slide_length = this.container.children().length;
      this.active_index = 0;
      this.news_panel = this.container.data('news-panel') ? true : false;
      this.createSlider();
      this.eventListeners();
      this.owl = this.container.data('owlCarousel');
    }

    FrameworkSlider.prototype.createSlider = function() {
      var _this, slider;
      _this = this;
      slider = this.container.owlCarousel({
        singleItem: true,
        navigation: _this.navigation,
        navigationText: false,
        pagination: _this.container.data('pagination') ? true : false,
        paginationNumbers: _this.pagination_numbers,
        scrollPerPageNav: true,
        slideSpeed: 800,
        autoHeight: false,
        autoPlay: _this.autoplay(),
        afterInit: function() {},
        afterAction: function() {
          _this.alignPlayButton();
          _this.active_index = _this.getActiveIndex();
          _this.updateContextMenu(_this.active_index);
          return _this.formatPaginationNumbers();
        }
      });
      if (_this.navigation) {
        slider.find('.owl-prev').html(theme.utils.addSymbol('chevron-left'));
        slider.find('.owl-next').html(theme.utils.addSymbol('chevron-right'));
      }
      return slider;
    };

    FrameworkSlider.prototype.getActiveIndex = function() {
      return this.container.find('.owl-pagination .owl-page.active').index();
    };

    FrameworkSlider.prototype.formatPaginationNumbers = function() {
      return this.container.find('.owl-page.active .owl-numbers').text((this.active_index + 1) + "/" + this.slide_length);
    };

    FrameworkSlider.prototype.autoplay = function() {
      if (this.autoplay_enabled) {
        return this.autoplay_frequency;
      }
      return false;
    };

    FrameworkSlider.prototype.updateContextMenu = function(index) {
      var context_navigation, type_class;
      if (this.news_panel) {
        type_class = '.' + this.container.find('.slide').eq(index).data('feed-type');
        context_navigation = this.container.closest('.template--index--news').find('.context-navigation');
        context_navigation.find('.item').hide();
        return context_navigation.find(type_class).show();
      }
    };

    FrameworkSlider.prototype.alignPlayButton = function() {
      var play_button, play_button_height, slide, slide_height, video_offset;
      slide = this.container.find('.owl-item').eq(this.active_index);
      play_button = slide.find('.play-button');
      if (play_button.length === 0) {
        return;
      }
      play_button.css('visibility', 'hidden');
      if (PAGE.hasClass('transparent-menu') && $('.main-header').css('position') === 'absolute') {
        slide_height = slide.outerHeight();
        play_button_height = play_button.outerHeight();
        video_offset = (slide_height - play_button_height) / 2;
        play_button.css({
          'margin-top': 0,
          'top': video_offset
        });
      } else {
        play_button.css({
          'margin-top': '-40px',
          'top': '50%'
        });
      }
      return play_button.css('visibility', 'visible');
    };

    FrameworkSlider.prototype.eventListeners = function() {
      var _this;
      _this = this;
      this.container.find(".play-button").on('click', function() {
        var video_modal;
        video_modal = new VideoModal($(this).closest('.video'));
        video_modal.open();
        _this.owl.stop();
        return false;
      });
      return this.container.find('.owl-pagination .owl-page, .skip-to-next').on('click', function() {
        _this.owl.next();
        return false;
      });
    };

    return FrameworkSlider;

  })();

  theme.classes.FrameworkStickyColumn = (function() {
    function FrameworkStickyColumn(container1, column_a, column_b, mq) {
      this.container = container1;
      this.column_a = column_a;
      this.column_b = column_b;
      this.mq = mq;
      this.Listeners = bind(this.Listeners, this);
      this.setColumnPosition = bind(this.setColumnPosition, this);
      this.getAlignment = bind(this.getAlignment, this);
      this.getState = bind(this.getState, this);
      this.resetLargerColumn = bind(this.resetLargerColumn, this);
      this.getSmallerColumn = bind(this.getSmallerColumn, this);
      this.heightsHaveChanged = bind(this.heightsHaveChanged, this);
      this.setHeights = bind(this.setHeights, this);
      this.loadColumns = bind(this.loadColumns, this);
      if (Modernizr.touchevents) {
        return false;
      }
      this.current_state = 'auto';
      this.column_a_height = 0;
      this.column_b_height = 0;
      this.loadColumns();
    }

    FrameworkStickyColumn.prototype.loadColumns = function() {
      var _this;
      _this = this;
      return theme.utils.imagesLoaded(_this.container, function() {
        _this.Listeners();
        return _this.setColumnPosition();
      });
    };

    FrameworkStickyColumn.prototype.setHeights = function() {
      this.column_a_height = this.column_a.outerHeight();
      return this.column_b_height = this.column_b.outerHeight();
    };

    FrameworkStickyColumn.prototype.heightsHaveChanged = function() {
      if (this.column_a.outerHeight() !== this.column_a_height) {
        this.setHeights();
        return true;
      }
      if (this.column_b.outerHeight() !== this.column_b_height) {
        this.setHeights();
        return true;
      }
      return false;
    };

    FrameworkStickyColumn.prototype.getSmallerColumn = function() {
      if (this.column_a_height < this.column_b_height) {
        return this.column_a;
      } else {
        return this.column_b;
      }
    };

    FrameworkStickyColumn.prototype.resetLargerColumn = function() {
      if (this.column_a_height > this.column_b_height) {
        return this.column_a.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      } else {
        return this.column_b.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      }
    };

    FrameworkStickyColumn.prototype.getState = function(scroll_pos, window_height, column) {
      var column_height, height_for_bottom, overflowing_column, state;
      state = 'auto';
      if (this.mq.current_window === 'small') {
        return 'auto';
      }
      column_height = column.outerHeight();
      if (window_height > column_height) {
        overflowing_column = true;
      }
      if (scroll_pos < this.container.offset().top) {
        state = 'auto';
      }
      if (overflowing_column) {
        height_for_bottom = column_height;
      } else {
        height_for_bottom = window_height;
      }
      if ((scroll_pos + height_for_bottom) > (this.container.offset().top + this.container.outerHeight())) {
        state = 'absolute-bottom';
      } else if (scroll_pos > this.container.offset().top && overflowing_column) {
        state = 'fixed-top';
      } else if (window_height < column_height && (scroll_pos + window_height) > (this.container.offset().top + column.outerHeight())) {
        state = 'fixed-bottom';
      }
      return state;
    };

    FrameworkStickyColumn.prototype.getAlignment = function(column) {
      if (column.hasClass('column-a')) {
        return 'left';
      } else if (column.hasClass('column-b')) {
        return 'right';
      }
    };

    FrameworkStickyColumn.prototype.setColumnPosition = function() {
      var _this, align, column, state;
      _this = this;
      _this.setHeights();
      column = _this.getSmallerColumn();
      state = _this.getState($(window).scrollTop(), $(window).height(), column);
      align = _this.getAlignment(column);
      if (state === 'auto' && this.current_state !== 'auto') {
        this.current_state = 'auto';
        column.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      } else if (state === 'fixed-bottom' && this.current_state !== 'fixed-bottom') {
        this.current_state = 'fixed-bottom';
        column.css({
          'position': 'fixed',
          'top': 'auto',
          'bottom': 0
        });
      } else if (state === 'fixed-top' && this.current_state !== 'fixed-top') {
        this.current_state = 'fixed-top';
        column.css({
          'position': 'fixed',
          'top': 0,
          'bottom': 'auto'
        });
      } else if (state === 'absolute-bottom' && this.current_state !== 'absolute-bottom') {
        this.current_state = 'absolute-bottom';
        column.css({
          'position': 'absolute',
          'top': 'auto',
          'bottom': 0
        });
      }
      if (align === 'right') {
        return column.css({
          'right': 0
        });
      }
    };

    FrameworkStickyColumn.prototype.Listeners = function() {
      var _this;
      _this = this;
      $(window).scroll(function() {
        return _this.setColumnPosition();
      });
      setInterval(function() {
        if (_this.heightsHaveChanged()) {
          _this.resetLargerColumn();
          return _this.setColumnPosition();
        }
      }, 250);
      return $(window).resize(function() {
        _this.resetLargerColumn();
        return _this.setColumnPosition();
      });
    };

    return FrameworkStickyColumn;

  })();

  theme.classes.FrameworkUtils = (function() {
    function FrameworkUtils() {
      var _this;
      _this = this;
      _this.google_map_api_status = null;
    }

    FrameworkUtils.prototype.debounce = function(delay, fn) {
      var timeoutId;
      timeoutId = void 0;
      return function() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(fn.bind(this), delay, arguments);
      };
    };

    FrameworkUtils.prototype.imagesLoaded = function(selector, callback) {
      var count, images_length;
      count = 0;
      images_length = selector.find('img[data-sizes="auto"]').length;
      if (images_length < 1) {
        callback();
        return;
      }
      return selector.on('lazybeforeunveil', function(e) {
        return $(e.target).one('load', function() {
          count++;
          if (count === images_length) {
            return callback();
          }
        });
      });
    };

    FrameworkUtils.prototype.a11yClick = function(event) {
      var code;
      if (event.type === 'click') {
        return true;
      } else if (event.type === 'keypress') {
        code = event.charCode || event.keyCode;
        if (code === 32) {
          event.preventDefault();
        }
        if (code === 32 || code === 13) {
          return true;
        }
      }
      return false;
    };

    FrameworkUtils.prototype.matchImageHeights = function(container, items, image_class) {
      var _this, greatest_image_height, items_per_row, row_items;
      _this = this;
      items_per_row = Math.round(container.width() / items.first().outerWidth());
      greatest_image_height = 0;
      row_items = $();
      items.find(image_class).css('height', 'auto');
      items.find('.placeholder--root').css('height', 'auto');
      return items.each(function(index) {
        var this_height;
        if ($(this).find('.image--root').length > 0) {
          this_height = $(this).find(image_class + ' .image--root').outerHeight();
        } else {
          this_height = $(this).find('.placeholder--root').outerHeight();
        }
        row_items = row_items.add($(this));
        if (this_height > greatest_image_height) {
          greatest_image_height = this_height;
        }
        if (index % items_per_row === items_per_row - 1 || index + 1 === items.length) {
          row_items.find(image_class + ', .placeholder--root').height(greatest_image_height);
          greatest_image_height = 0;
          return row_items = $();
        }
      });
    };

    return FrameworkUtils;

  })();

  theme.classes.FrameworkVideo = (function() {
    function FrameworkVideo(root) {
      var _this;
      this.root = root;
      _this = this;
      _this.root.fitVids();
    }

    return FrameworkVideo;

  })();

  theme.classes.FrameworkXMenu = (function() {
    function FrameworkXMenu(root) {
      var _this;
      this.root = root;
      this.slideUp = bind(this.slideUp, this);
      this.slideDown = bind(this.slideDown, this);
      this.arrangeMegaNav = bind(this.arrangeMegaNav, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.checkOverlap = bind(this.checkOverlap, this);
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.debugging = false;
      _this.state = 'closed';
      _this.parent_links = _this.root.find('.x-menu--level-1--link > a');
      _this.sub_menu_links = _this.root.find('.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a');
      _this.sub_menu_items = _this.sub_menu_links.parent().find('ul a');
      _this.parents_with_sub_menu = _this.sub_menu_links.parent();
      _this.overlap_parent = _this.root.data('x-menu--overlap-parent');
      _this.load();
    }

    FrameworkXMenu.prototype.load = function() {
      var _this;
      _this = this;
      _this.arrangeMegaNav();
      _this.listeners();
      _this.checkOverlap();
      return _this.resizeListeners();
    };

    FrameworkXMenu.prototype.listeners = function() {
      var _this;
      _this = this;
      _this.parents_with_sub_menu.on('mouseenter.XMenu', function(e) {
        return _this.slideDown($(this).find('> a'));
      });
      _this.parents_with_sub_menu.on('mouseleave.XMenu', function() {
        return _this.slideUp();
      });
      _this.parent_links.on('focus', function(e) {
        return _this.slideUp();
      });
      _this.sub_menu_links.on('focus', function(e) {
        return _this.slideDown($(this));
      });
      return _this.sub_menu_links.on('touchstart.XMenu', function(e) {
        e.preventDefault();
        if ($(this).parent().attr('data-x-menu--open') === 'true') {
          return _this.slideUp();
        } else {
          return _this.slideDown($(this).find('> a'));
        }
      });
    };

    FrameworkXMenu.prototype.checkOverlap = function() {
      var _this, center_index, center_item, center_item_left_edge, center_item_right_edge, center_item_width, container, container_width, first_center_child, last_center_child, left_break_point, left_item, right_item, right_item_edge;
      _this = this;
      if (Modernizr.touchevents && theme.utils.mqs.current_window !== 'large') {
        _this.root.attr('data-x-menu--overlap', 'true');
        return false;
      }
      _this.root.attr('data-x-menu--overlap', 'false');
      center_item = _this.root;
      if (_this.overlap_parent === 1) {
        center_item = center_item.parent();
      } else if (_this.overlap_parent === 2) {
        center_item = center_item.parent().parent();
      }
      container = center_item.parent();
      center_index = center_item.index();
      left_item = false;
      if (center_index > 1) {
        left_item = container.children().eq(center_index - 1);
      }
      right_item = false;
      if (center_index + 1 < container.children().length) {
        right_item = container.children().eq(center_index + 1);
      }
      container_width = container.width();
      center_item_width = _this.root.outerWidth();
      if (left_item) {
        first_center_child = center_item.find('> :first-child');
        center_item_left_edge = first_center_child.offset().left - 1;
        left_break_point = (container_width - center_item_width) / 2;
        if (left_edge >= center_item_left_edge) {
          _this.root.attr('data-x-menu--overlap', 'true');
        }
      }
      if (right_item) {
        last_center_child = center_item.find('> :last-child');
        center_item_right_edge = last_center_child.outerWidth() + last_center_child.offset().left + 1;
        right_item_edge = right_item.offset().left;
        if (center_item_right_edge >= right_item_edge) {
          return _this.root.attr('data-x-menu--overlap', 'true');
        }
      }
    };

    FrameworkXMenu.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.XMenu', _this.debounce(100, function() {
        return _this.checkOverlap();
      }));
    };

    FrameworkXMenu.prototype.debounce = function(delay, fn) {
      var timeoutId;
      timeoutId = void 0;
      return function() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(fn.bind(this), delay, arguments);
      };
    };

    FrameworkXMenu.prototype.arrangeMegaNav = function() {
      var _this, mega_navs;
      _this = this;
      if (_this.parents_with_sub_menu.length === 0) {
        return false;
      }
      mega_navs = _this.root.find('[data-x-menu--depth="3"] .x-menu--level-2--container');
      return mega_navs.each(function() {
        var container, single_parents, single_parents_container;
        container = $(this);
        single_parents = container.find('[data-x-menu--single-parent="true"]');
        if (single_parents.length > 0) {
          single_parents_container = $('<div class="x-menu--single-parents"></div>').insertAfter(container.find('.x-menu--bg'));
          return single_parents_container.append('<ul>').find('ul').append(single_parents);
        }
      });
    };

    FrameworkXMenu.prototype.slideDown = function(link, delay) {
      var _this, display_type, link_wrapper, menu_height, sub_menu, expand_less, expand_more;
      if (delay == null) {
        delay = false;
      }
      _this = this;
      clearTimeout(_this.timer);
      link_wrapper = link.parent();
      if (link_wrapper.attr('data-x-menu--open') === 'true' || _this.state === 'closing') {
        return false;
      }
      _this.slideUp(false);
      if (delay && delay !== 'complete') {
        _this.timer = setTimeout(function() {
          return _this.slideDown(link, 'complete');
        }, delay);
      } else {
        expand_less = link.closest('.x-menu--level-1--link').find('.fw--icon--expand-less')
        expand_more = link.closest('.x-menu--level-1--link').find('.fw--icon--expand-more')
        expand_more.css({
          'transform': 'rotate(360deg)',
          'transition': 'transform .5s ease',
        })
        _this.state = 'open';
        link_wrapper.attr('data-x-menu--open', 'true');
        link.attr('aria-expanded', 'true');
        sub_menu = link.closest('.x-menu--level-1--link').find('.x-menu--level-2--container');
        display_type = 'block';
        if (link_wrapper.attr('data-x-menu--depth') === "3") {
          display_type = 'flex';
        }
        sub_menu.velocity('stop');
        sub_menu.css({
          height: 'auto',
          display: display_type
        });
        // sub_menu.find('.x-menu--level-2--list').css({
        //   display: display_type,
        //   flexDirection: 'column'
        // });
        menu_height = sub_menu.outerHeight();
        sub_menu.css({
          height: 0,
          opacity: 1
        });
        sub_menu.velocity({
          height: [menu_height, 0]
        }, {
          queue: false,
          duration: 600,
          easing: "easeOutExpo"
        });
      }
    };

    FrameworkXMenu.prototype.slideUp = function(delay) {
      var _this, link, link_wrapper, sub_menu, expand_more, expand_less;
      if (delay == null) {
        delay = 300;
      }
      _this = this;
      if (_this.debugging) {
        return false;
      }
      link_wrapper = _this.parents_with_sub_menu.filter('[data-x-menu--open="true"]');
      link = link_wrapper.find('> a');
      if (link_wrapper.attr('data-x-menu--open') === 'false') {
        return false;
      }
      if (delay) {
        return _this.timer = setTimeout(function() {
          return _this.slideUp(false);
        }, delay);
      } else {
        expand_less = link.closest('.x-menu--level-1--link').find('.fw--icon--expand-less')
        expand_more = link.closest('.x-menu--level-1--link').find('.fw--icon--expand-more')
        // use css to  rotate expand_less use transition to ease
        expand_more.css({
          'transform': 'rotate(270deg)',
          'transition': 'transform .5s ease',
        })
        link.closest('.x-menu--level-1--link').find('.fw--icon--minus').hide();
        link.closest('.x-menu--level-1--link').find('.fw--icon--plus').show();
        sub_menu = link.closest('.x-menu--level-1--link').find('.x-menu--level-2--container');
        link_wrapper.attr('data-x-menu--open', 'false');
        link.attr('aria-expanded', 'false');
        return sub_menu.velocity({
          opacity: 0
        }, {
          begin: function() {
            return _this.state = 'closing';
          },
          complete: function() {
            sub_menu.css({
              'display': 'none'
            });
            return _this.state = 'closed';
          },
          duration: 200
        });
      }
    };

    return FrameworkXMenu;

  })();

  theme.classes.FrameworkYMenu = (function() {
    function FrameworkYMenu(root) {
      var _this;
      this.root = root;
      this.slideRight = bind(this.slideRight, this);
      this.slideLeft = bind(this.slideLeft, this);
      this.adjustHeight = bind(this.adjustHeight, this);
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.state = 'closed';
      
      
      _this.sub_menu_links = _this.root.find('.fw--icon--chevron-right').parent();

      
      
      _this.back_links = _this.root.find('.y-menu--back-link a');
      _this.regular_links = _this.root.find('.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])');
      _this.timer = null;
      _this.load();
    }

    FrameworkYMenu.prototype.load = function() {
      var _this;
      _this = this;
      return _this.listeners();
    };

    FrameworkYMenu.prototype.listeners = function() {
      var _this;
      _this = this;
      _this.regular_links.on('click', function(e) {
        var href;
        href = $(this).attr('href');
        if (href.indexOf('#') !== -1) {
          if (theme.partials.FrameworkOffCanvas.state === 'left-open') {
            theme.partials.FrameworkOffCanvas.closeLeft();
          } else if (theme.partials.FrameworkOffCanvas.state === 'right-open') {
            theme.partials.FrameworkOffCanvas.closeRight();
          }
          setTimeout(function() {
            return window.location.href = href;
          }, 450);
        }
      });
      _this.sub_menu_links.on('click', function(e) {
        _this.slideLeft($(this));
        return false;
      });
      return _this.back_links.on('click', function(e) {
        _this.slideRight($(this));
        return false;
      });
    };

    FrameworkYMenu.prototype.adjustHeight = function(open_list) {
      var _this, current_height, open_list_height;
      _this = this;
      _this.root.css({
        height: 'auto'
      });
      current_height = _this.root.outerHeight();
      open_list_height = open_list.outerHeight();
      if (open_list.css('position') === 'absolute') {
        open_list.css('position', 'relative');
        open_list_height = open_list.outerHeight();
        open_list.css('position', 'absolute');
      }
      return _this.root.velocity({
        height: open_list_height
      });
    };

    FrameworkYMenu.prototype.slideLeft = function(link) {
      var _this, sub_menu;
      _this = this;
      sub_menu = link.closest('li').find('ul').first();
      sub_menu.css({
        display: 'block'
      });
      _this.adjustHeight(sub_menu);
      return sub_menu.velocity({
        translateX: ['-100%', 0]
      });
    };

    FrameworkYMenu.prototype.slideRight = function(link) {
      var _this, container, parent_container;
      _this = this;
      container = link.closest('ul');
      parent_container = container.parent().closest('ul');
      _this.adjustHeight(parent_container);
      return container.velocity({
        translateX: [0, '-100%']
      });
    };

    return FrameworkYMenu;

  })();


  Accordion = (function() {
    function Accordion() {
      $('.accordion.headings').each(function() {
        return $(this).add($(this).next('.accordion.content')).wrapAll("<div class='accordion-wrapper'/>");
      });
      $('.accordion.headings li').wrapInner('<div class="trigger"></div>');
      $('.accordion.headings li .trigger').append('<div class="bg"></div>');
      $('.accordion-wrapper').each(function() {
        var accordion_content, accordion_heading;
        accordion_heading = $(this).find('.accordion.headings > li');
        accordion_content = $(this).find('.accordion.content > li');
        accordion_heading.first().addClass('active');
        accordion_content.each(function(index) {
          var content;
          content = $('<div class="content">' + $(this).html() + '</div>');
          return content.appendTo(accordion_heading.eq(index));
        });
        accordion_content.remove();
        $(this).find('.content').first().show();
        return $(this).find('.trigger').on("click", function() {
          var panels, this_panel;
          panels = $(this).closest(".accordion").find('.content');
          this_panel = $(this).closest("li").find(".content");
          panels.not(this_panel).slideUp(200);
          this_panel.slideDown(200, function() {
            if (general_scroll_to_active_item) {
              return $('html, body').animate({
                scrollTop: this_panel.offset().top - 100
              });
            }
          });
          $(this).closest(".accordion").find("li").removeClass("active");
          return $(this).closest("li").addClass("active");
        });
      });
    }

    return Accordion;

  })();

  theme.classes.FeaturedBlog = (function() {
    function FeaturedBlog(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.item_container = _this.root.find('.featured-blog--body');
      _this.items = _this.root.find('.featured-blog--item');
      _this.matchImageHeights();
      _this.resizeListeners();
    }

    FeaturedBlog.prototype.matchImageHeights = function() {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(_this.item_container, _this.items, '.featured-blog--item--image');
    };

    FeaturedBlog.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.FeaturedGrid', theme.utils.debounce(100, function() {
        return _this.matchImageHeights();
      }));
    };

    return FeaturedBlog;

  })();

  theme.classes.FeaturedProduct = (function(superClass) {
    extend(FeaturedProduct, superClass);

    function FeaturedProduct() {
      this.addToCartListener = bind(this.addToCartListener, this);
      return FeaturedProduct.__super__.constructor.apply(this, arguments);
    }

    FeaturedProduct.prototype.addToCartListener = function() {
      var _this;
      _this = this;
      if (_this.cart_form.length > 0) {
        return _this.cart_form.submit(function() {
          theme.partials.cart.addToCart($(this));
          return false;
        });
      }
    };

    return FeaturedProduct;

  })(theme.classes.FrameworkFeaturedProduct);

  Footer = (function() {
    function Footer(root) {
      var _this;
      this.root = root;
      this.stickyFooter = bind(this.stickyFooter, this);
      this.addListeners = bind(this.addListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.load();
    }

    Footer.prototype.load = function() {
      var _this;
      _this = this;
      _this.addListeners();
      return _this.stickyFooter();
    };

    Footer.prototype.addListeners = function() {
      var _this;
      _this = this;
      return WINDOW.on('resize', function() {
        return _this.stickyFooter();
      });
    };

    Footer.prototype.stickyFooter = function() {
      var total_content_height;
      total_content_height = HEADER.outerHeight() + $('.main-content').outerHeight() + $('.main-footer').outerHeight();
      if (WINDOW.outerHeight() > total_content_height) {
        return $('.main-content').css({
          'min-height': WINDOW.outerHeight() - $('.main-header').outerHeight() - $('.main-footer').outerHeight()
        });
      }
    };

    return Footer;

  })();

  FullscreenSlider = (function() {
    function FullscreenSlider(slider_element) {
      this.eventListeners = bind(this.eventListeners, this);
      this.alignPlayButton = bind(this.alignPlayButton, this);
      this.alignCaption = bind(this.alignCaption, this);
      this.isFirstSlider = bind(this.isFirstSlider, this);
      this.getActiveIndex = bind(this.getActiveIndex, this);
      this.autoplay = bind(this.autoplay, this);
      this.removeDuplicateVideoModals = bind(this.removeDuplicateVideoModals, this);
      this.createSlider = bind(this.createSlider, this);
      var _this, slide_parent;
      _this = this;
      this.el = slider_element;
      slide_parent = this.el.closest('.slider');
      this.autoplay_enabled = slide_parent.data('autoplay');
      if (slide_parent.find('.slide').length < 2) {
        this.autoplay_enabled = false;
      }
      this.autoplay_frequency = slide_parent.data('rotateFrequency');
      this.transition_style = slide_parent.data('transitionStyle');
      _this.removeDuplicateVideoModals();
      this.createSlider();
      this.owl = $(".owl-carousel").data('owlCarousel');
    }

    FullscreenSlider.prototype.createSlider = function() {
      var slider, slider_options;
      slider = this;
      slider_options = {
        singleItem: true,
        navigation: false,
        paginationNumbers: false,
        scrollPerPageNav: true,
        slideSpeed: 800,
        pagination: true,
        autoHeight: true,
        autoPlay: slider.autoplay(),
        afterInit: function() {
          return slider.eventListeners();
        },
        afterAction: function() {
          slider.alignCaption();
          return slider.alignPlayButton();
        }
      };
      if (this.transition_style !== 'default') {
        slider_options['transitionStyle'] = this.transition_style;
      }
      return slider.el.owlCarousel(slider_options);
    };

    FullscreenSlider.prototype.removeDuplicateVideoModals = function() {
      var _this;
      _this = this;
      return $('.modal.video:gt(0)').remove();
    };

    FullscreenSlider.prototype.autoplay = function() {
      if (this.autoplay_enabled) {
        return this.autoplay_frequency;
      }
      return false;
    };

    FullscreenSlider.prototype.getActiveIndex = function() {
      return this.el.find('.owl-pagination .owl-page.active').index();
    };

    FullscreenSlider.prototype.isFirstSlider = function() {
      var current_section_id, first_section, first_section_id;
      first_section = $('.index-sections').children('div:first');
      first_section_id = first_section.find('.slider').data('sectionId');
      current_section_id = this.el.closest('.slider').data('sectionId');
      if (first_section.hasClass('section--slideshow')) {
        return current_section_id === first_section_id;
      }
      return false;
    };

    FullscreenSlider.prototype.alignCaption = function() {
      var caption, caption_height, caption_width, slide, slide_padding, top_offset;
      slide = this.el.find('.owl-item').eq(this.getActiveIndex());
      caption = slide.find('.caption');
      caption.css('visibility', 'hidden');
      caption_height = caption.outerHeight();
      caption_width = caption.outerWidth();
      slide_padding = 30;
      if (theme.utils.transparentMenuIsEnabled() && this.isFirstSlider() === true) {
        top_offset = $('.main-header').outerHeight();
      } else {
        top_offset = 0;
      }
      return theme.utils.imagesLoaded(slide.find('img').first(), function() {
        var left_offset, middle_top, slide_height, slide_width;
        slide_height = slide.outerHeight();
        slide_width = slide.outerWidth();
        if (caption.hasClass('top')) {
          caption.css('top', top_offset + slide_padding);
        } else if (caption.hasClass('middle')) {
          middle_top = top_offset + (slide_height - top_offset - caption_height) / 2;
          caption.css('top', middle_top);
        }
        if (caption.hasClass('center')) {
          left_offset = (slide_width - caption_width) / 2;
          caption.css('left', left_offset);
        }
        return caption.css('visibility', 'visible');
      });
    };

    FullscreenSlider.prototype.alignPlayButton = function() {
      var play_button, slide;
      slide = this.el.find('.owl-item').eq(this.getActiveIndex());
      play_button = slide.find('.play-button');
      play_button.css('visibility', 'hidden');
      if (theme.utils.transparentMenuIsEnabled() && $('.main-header').css('position') === 'absolute') {
        theme.utils.imagesLoaded(slide.find('img').first(), function() {
          var play_button_height, slide_height, video_offset;
          slide_height = slide.outerHeight();
          play_button_height = play_button.outerHeight();
          video_offset = (slide_height - play_button_height) / 2;
          return play_button.css({
            'margin-top': 0,
            'top': video_offset
          });
        });
      } else {
        play_button.css({
          'margin-top': '-40px',
          'top': '50%'
        });
      }
      return play_button.css('visibility', 'visible');
    };

    FullscreenSlider.prototype.eventListeners = function() {
      var slider;
      slider = this;
      this.el.find(".play-button").on('click', function() {
        var video_modal;
        video_modal = new VideoModal($(this).closest('.video'));
        video_modal.open();
        slider.owl.stop();
        return false;
      });
      this.el.find('.owl-pagination .owl-page').on('click', function() {
        return slider.owl.stop();
      });
      return DOC.on('header.transparentMenuIsUpdated', slider.alignCaption);
    };

    return FullscreenSlider;

  })();

  theme.classes.Header = (function() {
    function Header(root) {
      var _this;
      this.root = root;
      this.moveYMenu = bind(this.moveYMenu, this);
      this.sectionListeners = bind(this.sectionListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.load();
    }

    Header.prototype.load = function() {
      var _this;
      _this = this;
      _this.searchAndAccount();
      _this.sectionListeners();
      return _this.moveYMenu();
    };

    Header.prototype.sectionListeners = function() {
      var _this;
      _this = this;
      return _this.root.on('theme:section:load', function() {
        theme.partials.FrameworkOffCanvas.unload();
        return theme.partials.FrameworkOffCanvas.load();
      });
    };

    Header.prototype.moveYMenu = function() {
      var _this;
      _this = this;
      $('.mobile-nav--menu').empty();
      return $('.y-menu').appendTo('.mobile-nav--menu');
    };

    Header.prototype.searchAndAccount = function() {
      var _this;
      _this = this;
      $('.account-open').click(function() {
        $(this).closest('.menu').fadeOut(100, function() {
          return $('.account-container').fadeIn(200);
        });
        return false;
      });
      return $('.account-close').click(function() {
        $('.account-container').fadeOut(100, function() {
          return $('.search-account .menu').fadeIn(200);
        });
        return false;
      });
    };

    return Header;

  })();

  HorizontalTabs = (function() {
    function HorizontalTabs() {
      $('.tabs-horizontal.headings').each(function() {
        return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper horizontal'/>");
      });
      $('.tabs-horizontal.headings li').wrapInner('<div class="trigger"></div>');
      $('.tabs-horizontal.headings li .trigger').append('<div class="bg"></div>');
      $('.tabs-wrapper.horizontal').each(function() {
        var tab_content, tab_headings;
        tab_headings = $(this).find('.headings > li');
        tab_content = $(this).find('.tabs.content > li');
        tab_content.first().addClass('active');
        tab_headings.first().addClass('active');
        return tab_headings.on('click', function() {
          tab_headings.removeClass('active');
          tab_content.removeClass('active');
          $(this).addClass('active');
          return tab_content.eq($(this).index()).addClass('active');
        });
      });
    }

    return HorizontalTabs;

  })();

  MediaQueries = (function() {
    function MediaQueries() {
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      _this.listeners();
      _this.load();
    }

    MediaQueries.prototype.load = function() {
      var _this, current_window;
      _this = this;
      if (window.matchMedia('only screen and (min-width: ' + mq_medium + 'px)').matches) {
        if (current_window !== 'large') {
          $.event.trigger("largeWindow");
          return current_window = 'large';
        }
      } else if (window.matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches) {
        if (current_window !== 'medium') {
          $.event.trigger("mediumWindow");
          return current_window = 'medium';
        }
      } else {
        if (current_window !== 'small') {
          $.event.trigger("smallWindow");
          return current_window = 'small';
        }
      }
    };

    MediaQueries.prototype.listeners = function() {
      var _this;
      _this = this;
      return WINDOW.on('resize.section-' + _this.section_id, _this.load);
    };

    return MediaQueries;

  })();

  // DMC Popup
  Popup = (function() {
    function Popup(clazz) {
      var checkContentOverflow, closeDialog, eventListeners, fillPopupDialog, fillSizeChartDialog, getCustomClasses, getImage, getNewsletter, getPageContent, getSocialIcons, getWrapper, hideMask, ieCenter, isExpired, mask, maskIsActive, modal, modal_clazz, openDialog, passesExpiration, resetExpiration, showMask, storeExpiration;
      this.clazz = clazz;
      modal = null;
      modal_clazz = this.clazz;
      mask = $('.popup-modal-mask');
      storeExpiration = function() {
        var date, e, expires, object, seconds_from_now;
        date = new Date();
        seconds_from_now = 1000 * 60 * 60 * 24 * popup_config.days_until;
        expires = date.setTime(date.getTime() + seconds_from_now);
        object = {
          expires: expires
        };
        try {
          return localStorage[popup_config.storage_key] = JSON.stringify(object);
        } catch (error1) {
          e = error1;
          return false;
        }
      };
      resetExpiration = function() {
        localStorage.removeItem(popup_config.storage_key);
        return storeExpiration();
      };
      isExpired = function() {
        var expires, now, object;
        object = JSON.parse(localStorage[popup_config.storage_key]);
        expires = object.expires;
        now = new Date().getTime();
        if (parseFloat(expires - now) <= 0) {
          resetExpiration();
          return true;
        }
        return false;
      };
      passesExpiration = function() {
        var passed;
        passed = false;
        if (Storage === "undefined" || popup_config.test_mode) {
          passed = true;
        } else if (typeof localStorage[popup_config.storage_key] === "undefined") {
          passed = true;
          storeExpiration();
        } else {
          passed = isExpired();
        }
        return passed;
      };
      maskIsActive = function() {
        return $('.popup-modal').is(':visible') || $('.modal-mask').length > 0 && $('.modal-mask').is(':visible');
      };
      showMask = function() {
        mask.show();
        return PAGE.addClass("modal-on");
      };
      hideMask = function() {
        mask.hide();
        return PAGE.removeClass("modal-on");
      };
      getImage = function() {
        if (popup_config.show_image_enabled === false) {
          return "";
        }
        if (popup_config.image_link.length > 0) {
          return $('<div class="popup-image"> <a href="' + popup_config.image_link + '">' + popup_config.show_image_url + '</a> </div>');
        } else {
          return $('<div class="popup-image">').append(popup_config.show_image_url);
        }
      };
      getNewsletter = function() {
        var subscribe_module;
        if (popup_config.newsletter_enabled === false) {
          return "";
        }
        subscribe_module = $("<div id='subscribe_module'></div>").append($(".popup--root"));
        return subscribe_module;
      };
      getSocialIcons = function() {
        if (popup_config.social_icons_enabled === false) {
          return "";
        }
        return $(".social-follow").clone();
      };
      getCustomClasses = function() {
        var class_list;
        class_list = "";
        class_list += popup_config.show_image_enabled === true ? " has-image" : " has-no-image";
        class_list += popup_config.page_content.length > 0 ? " has-page-content" : " has-no-page-content";
        class_list += popup_config.newsletter_enabled ? " has-newsletter" : " has-no-newsletter";
        class_list += popup_config.social_icons_enabled ? " has-social-icons" : " has-no-social-icons";
        return class_list;
      };
      getWrapper = function() {
        return '<dialog class="' + modal_clazz + ' popup-modal' + getCustomClasses() + '" />';
      };
      getPageContent = function() {
        var page_content;
        page_content = null;
        if (popup_config.page_content.length < 1) {
          return "";
        }
        $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {
          return page_content = "<div class='page-contents'>" + data.page.body_html + "</div>";
        });
        return page_content;
      };
      fillSizeChartDialog = function() {
        var dialog;
        if ($('.popup-modal.size-chart').length < 1) {
          dialog = {
            wrapper: getWrapper()
          };
          PAGE.append($(dialog.wrapper).append($('.size-chart')));
        }
        return openDialog();
      };
      fillPopupDialog = function() {
        var dialog, getInnerContent, render;
        dialog = {
          wrapper: getWrapper(),
          newsletter: getNewsletter(),
          social_icons: getSocialIcons(),
          image: getImage()
        };
        getInnerContent = function() {
          if (popup_config.page_content.length < 1 && popup_config.newsletter_enabled === false && popup_config.social_icons_enabled === false) {
            return "";
          }
          return $("<div class='inner' />").append(dialog.body, dialog.newsletter, dialog.social_icons);
        };
        render = function() {
          var image_src = $( popup_config.show_image_url ).attr('src');
          // PAGE.append( $( dialog.wrapper ).append( dialog.image, getInnerContent() ) );
          PAGE.append( $( dialog.wrapper ).append( $( '<div style="background-image: url(' + image_src + ');" class="dmc-popup-inner" />' ).append( getInnerContent() ) ) );

          return openDialog();
        };
        if (popup_config.page_content.length > 0) {
          return $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {
            dialog['body'] = "<div class='page-contents'>" + data.page.body_html + "</div>";
            return render();
          });
        } else {
          return render();
        }
      };
      checkContentOverflow = function() {
        return setTimeout((function() {
          if (modal.length > 0 && $('.popup-modal-mask').is(':visible')) {
            return theme.utils.imagesLoaded(modal, function() {
              var dialog_height;
              dialog_height = $('dialog[class*="' + modal_clazz + '"]:last-of-type').outerHeight();
              if (dialog_height >= WINDOW.height()) {
                return PAGE.addClass('modal-unfix');
              } else {
                return PAGE.removeClass('modal-unfix');
              }
            });
          }
        }), 0);
      };
      ieCenter = function() {
        return modal.css({
          marginTop: -(modal.outerHeight() * 0.5) + "px",
          marginLeft: -(modal.outerWidth() * 0.5) + "px"
        });
      };
      openDialog = function() {
        modal = $('dialog[class*="' + modal_clazz + '"]');
        eventListeners();
        modal.addClass("opened").removeClass("closed");
        checkContentOverflow();
        return showMask();
      };
      eventListeners = function() {
        var removeAnimation;
        removeAnimation = function(event) {
          if (event.originalEvent.animationName === 'modal-close') {
            if (modal_clazz === 'popup') {
              return modal.remove();
            } else {
              return modal.removeClass('closed, completed');
            }
          } else {
            return modal.addClass('completed').removeClass('opened');
          }
        };
        DOC.on('click', '.popup-modal', function(e) {
          e.stopPropagation();
          if (e.target === this) {
            return closeDialog();
          }
        });
        $('.popup-modal-close').click(closeDialog);
        mask.click(closeDialog);
        modal.on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', removeAnimation);
        WINDOW.resize(checkContentOverflow);
        DOC.keydown(function(e) {
          if (modal.hasClass('completed') && e.keyCode === 27) {
            return closeDialog();
          }
        });
        return $('dialog.popup-modal #contact_form').on('submit', function(event) {
          var form;
          form = this;
          modal = $(this).closest('.popup-modal');
          modal.find('.error, .success').remove();
          event.preventDefault();
          if (modal.find('input[type="email"]').val().length === 0) {
            modal.find('.inner').prepend('<p class="error">' + theme.translation.newsletter_email_blank + '</p>');
            return false;
          } else {
            form.submit();
          }
          return false;
        });
      };
      closeDialog = function() {
        modal.addClass('closed').removeClass('completed').removeClass('opened');
        return hideMask();
      };
      if (modal_clazz !== 'popup') {
        fillSizeChartDialog();
      } else {
        if (popup_config.enabled && passesExpiration() && (popup_config.page_content.length > 0 || popup_config.newsletter_enabled || popup_config.show_image_enabled || popup_config.social_icons_enabled)) {
          setTimeout((function() {
            if (!(maskIsActive() === true || $('.popup-modal-mask').length < 1)) {
              return fillPopupDialog();
            }
          }), popup_config.seconds_until * 1000);
        }
      }
    }

    return Popup;

  })();

  theme.classes.ProductGrid = (function() {
    function ProductGrid(root) {
      var _this;
      this.root = root;
      this.hoverImagesLoaded = bind(this.hoverImagesLoaded, this);
      this.listeners = bind(this.listeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.detectOnboarding = bind(this.detectOnboarding, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.items = _this.root.find('.product--root');
      _this.onboarding = _this.detectOnboarding();
      _this.in_slider = _this.root.data('in-slider');
      _this.load();

      $(".dmc-single-product .product-page--images .product-page--thumbs .product-page--thumbs-container").slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        centerMode: true,
        centerPadding: '15%',
        arrows: false,
        responsive: [
          {
           breakpoint: 749,
           settings: "unslick"
          }
        ]
      });
    }

    ProductGrid.prototype.load = function() {
      var _this;
      _this = this;
      _this.listeners();
      _this.hoverImagesLoaded();
      if (!_this.in_slider) {
        return _this.matchImageHeights();
      }
    };

    ProductGrid.prototype.detectOnboarding = function() {
      var _this;
      _this = this;
      if (_this.items.first().find('.placeholder').length) {
        return true;
      }
      return false;
    };

    ProductGrid.prototype.matchImageHeights = function() {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(_this.root, _this.items, '.product--image-wrapper');
    };

    ProductGrid.prototype.listeners = function() {
      var _this;
      _this = this;
      if (!_this.in_slider) {
        return $(window).on('resize.ProductGrid', theme.utils.debounce(100, function() {
          return _this.matchImageHeights();
        }));
      }
    };

    ProductGrid.prototype.hoverImagesLoaded = function() {
      var _this;
      _this = this;
      return _this.items.filter('[data-hover-image="true"]').each(function() {
        var product;
        product = $(this);
        return theme.utils.imagesLoaded(product, function() {
          return product.attr('data-hover-image', 'loaded');
        });
      });
    };

    return ProductGrid;

  })();

  ProductSlider = (function() {
    function ProductSlider(root) {
      var _this;
      this.root = root;
      this.listeners = bind(this.listeners, this);
      this.afterUpdate = bind(this.afterUpdate, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.product_grid = _this.root.find('.product-grid--root');
      _this.product_item = _this.root.find('.product--root');
      _this.load();
      _this.listeners();
    }

    ProductSlider.prototype.load = function() {
      var _this;
      _this = this;
      _this.product_grid.owlCarousel({
        items: 3,
        navigation: true,
        scrollPerPage: true,
        slideSpeed: 800,
        lazyLoad: false,
        mouseDrag: false,
        pagination: false,
        navigationText: false,
        afterUpdate: _this.afterUpdate()
      });
      return _this.product_item.show();
    };

    ProductSlider.prototype.afterUpdate = function() {
      var _this;
      _this = this;
      return $(window).trigger('ProductSlider.afterUpdate');
    };

    ProductSlider.prototype.listeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.ProductGrid', theme.utils.debounce(100, function() {
        return _this.loadCarousel;
      }));
    };

    return ProductSlider;

  })();

  PromoBar = (function() {
    function PromoBar(root) {
      var _this;
      this.root = root;
      this.load = bind(this.load, this);
      _this = this;
      _this.promo_bar = _this.root;
      _this.close_btn = _this.root.find('button');
      _this.load();
    }

    PromoBar.prototype.load = function() {
      var _this;
      _this = this;
      if ((typeof Storage !== "undefined" && Storage !== null) && sessionStorage['promo-bar-closed']) {
        return _this.promo_bar.hide();
      } else {
        _this.promo_bar.show();
        return _this.close_btn.on('click', function() {
          return _this.close();
        });
      }
    };

    PromoBar.prototype.close = function() {
      var _this;
      _this = this;
      if ((typeof Storage !== "undefined" && Storage !== null) && !sessionStorage['promo-bar-closed']) {
        sessionStorage['promo-bar-closed'] = true;
      }
      return _this.promo_bar.addClass('closed');
    };

    return PromoBar;

  })();

  VerticalTabs = (function() {
    function VerticalTabs() {
      $('.tabs-vertical.headings').each(function() {
        return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper vertical'/>");
      });
      $('.tabs-vertical.headings li').wrapInner('<div class="trigger"></div>');
      $('.tabs-vertical.headings li .trigger').append('<div class="bg"></div>');
      $('.tabs-wrapper.vertical').each(function() {
        var tab_content, tab_headings, tab_wrapper;
        tab_wrapper = $(this);
        tab_headings = $(this).find('.headings > li');
        tab_content = $(this).find('.tabs.content > li');
        tab_content.first().addClass('active');
        tab_headings.first().addClass('active');
        return tab_headings.on('click', function() {
          tab_headings.removeClass('active');
          tab_content.removeClass('active');
          $(this).addClass('active');
          tab_content.eq($(this).index()).addClass('active');
          if (general_scroll_to_active_item) {
            if (matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches) {
              return $('html, body').animate({
                scrollTop: tab_wrapper.offset().top - 50
              }, 'slow');
            } else {
              return $('html, body').animate({
                scrollTop: tab_wrapper.offset().top + tab_wrapper.find('.headings').outerHeight() - 50
              }, 'slow');
            }
          }
        });
      });
    }

    return VerticalTabs;

  })();

  VideoModal = (function() {
    function VideoModal(video) {
      this.createIframe = bind(this.createIframe, this);
      this.extractVideoId = bind(this.extractVideoId, this);
      this.extractVideoType = bind(this.extractVideoType, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.centerPosition = bind(this.centerPosition, this);
      this.close = bind(this.close, this);
      this.open = bind(this.open, this);
      this.opened = false;
      this.video = video;
      this.modal = $('.video.modal');
      this.player_button = video.find('.player-button');
      this.src_url = video.find('.play-button').attr('href');
      this.type = this.extractVideoType();
      this.id = this.extractVideoId();
      this.iframe = this.createIframe();
      this.caption = video.find('.caption');
    }

    VideoModal.prototype.open = function() {
      this.opened = true;
      this.modal.find(".flex-video").append(this.iframe);
      if (this.caption.length > 0) {
        this.modal.find(".caption").append(this.caption.html());
        this.modal.addClass("wide");
      } else {
        this.modal.find(".player").removeClass('large-8');
        this.modal.find('.caption').hide();
        this.modal.removeClass("wide");
      }
      this.player_button.hide();
      $('.modal-mask').show();
      this.modal.find('.close').show();
      this.modal.fadeIn();
      this.centerPosition();
      $(".modal").fadeIn(0);
      return this.eventListeners();
    };

    VideoModal.prototype.close = function() {
      this.opened = false;
      this.modal.find(".flex-video").empty();
      this.modal.find(".caption").empty();
      this.modal.hide();
      $('.modal-mask').fadeOut();
      if (this.caption.length === 0) {
        this.modal.find(".player").addClass('large-8');
        return this.modal.find('.caption').show();
      }
    };

    VideoModal.prototype.centerPosition = function() {
      if (WINDOW.height() < this.modal.outerHeight()) {
        return this.modal.css({
          'position': 'absolute',
          'top': '30px',
          'margin-top': 0,
          'margin-left': -(this.modal.outerWidth() / 2)
        });
      } else {
        return this.modal.css({
          'position': 'fixed',
          'top': '50%',
          'margin-top': -(this.modal.outerHeight() / 2),
          'margin-left': -(this.modal.outerWidth() / 2)
        });
      }
    };

    VideoModal.prototype.eventListeners = function() {
      var modal;
      modal = this;
      this.modal.find('.close').on('click', function() {
        return modal.close();
      });
      WINDOW.resize(function() {
        return modal.centerPosition();
      });
      DOC.keydown(function(e) {
        if (modal.opened) {
          if (e.keyCode === 27) {
            return modal.close();
          }
        }
      });
      $('.modal-mask').on('click', function() {
        return modal.close();
      });
      return this.player_button.on('click', function() {
        return false;
      });
    };

    VideoModal.prototype.extractVideoType = function() {
      var matches, re;
      re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
      matches = re.exec(this.src_url);
      if (matches) {
        return 'youtube';
      } else {
        re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        matches = re.exec(this.src_url);
        if (matches) {
          return 'vimeo';
        }
      }
      return false;
    };

    VideoModal.prototype.extractVideoId = function() {
      var match, regExp;
      if (this.type === 'youtube') {
        regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        match = this.src_url.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
      } else if (this.type === "vimeo") {
        regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        match = this.src_url.match(regExp);
        if (match) {
          return match[2];
        }
      }
    };

    VideoModal.prototype.createIframe = function() {
      if (this.type === "youtube") {
        return '<iframe  src="//www.youtube.com/embed/' + this.id + '?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe>';
      } else if (this.type === "vimeo") {
        return '<iframe src="//player.vimeo.com/video/' + this.id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
      }
    };

    return VideoModal;

  })();

  theme.classes.XMenu = (function(superClass) {
    extend(XMenu, superClass);

    function XMenu(root) {
      var _this;
      this.root = root;
      this.slideDown = bind(this.slideDown, this);
      this.hideHeader = bind(this.hideHeader, this);
      this.showHeader = bind(this.showHeader, this);
      this.headerListeners = bind(this.headerListeners, this);
      this.isHeaderTransparent = bind(this.isHeaderTransparent, this);
      _this = this;
      _this.header = $('.main-header');
      _this.header_bg = _this.header.find('.header--bg');
      _this.header_timer = null;
      _this.transparent_header = _this.isHeaderTransparent();
      XMenu.__super__.constructor.apply(this, arguments);
      _this.headerListeners();
    }

    XMenu.prototype.isHeaderTransparent = function() {
      var _this;
      _this = this;
      if ($('.header').attr('data-header--menu-transparent') === 'true') {
        return true;
      } else {
        return false;
      }
    };

    XMenu.prototype.headerListeners = function() {
      var _this;
      _this = this;
      _this.parents_with_sub_menu.on('mouseenter', function(e) {
        return clearTimeout(_this.header_timer);
      });
      _this.header.on('mouseenter touchstart', function(e) {
        clearTimeout(_this.header_timer);
        return _this.showHeader();
      });
      return _this.header.on('mouseleave', function(e) {
        return _this.header_timer = setTimeout(function() {
          return _this.hideHeader();
        }, 500);
      });
    };

    // XMenu.prototype.showHeader = function() {
    //   var _this;
    //   _this = this;
    //   if (parseInt(_this.header_bg.css('opacity')) !== 0) {
    //     return;
    //   }
    //   return _this.header_bg.velocity({
    //     opacity: [0.95]
    //   }, {
    //     duration: 400,
    //     queue: false
    //   });
    // };

    XMenu.prototype.hideHeader = function() {
      var _this;
      _this = this;
      if (_this.parents_with_sub_menu.filter('[data-main-menu--open="true"]').length > 0) {
        return false;
      }
      _this.header_bg.velocity({
        opacity: 0
      }, {
        duration: 400
      });
      return _this.slideUp();
    };

    XMenu.prototype.slideDown = function(link, delay) {
      var _this, opacity;
      if (delay == null) {
        delay = false;
      }
      _this = this;
      if (delay !== 'complete') {
        opacity = Math.round(parseFloat(_this.header_bg.css('opacity')) * 100);
        if (opacity < 90 && _this.transparent_header) {
          delay = 400;
        }
      }
      return XMenu.__super__.slideDown.call(this, link, delay);
    };

    return XMenu;

  })(theme.classes.FrameworkXMenu);

  Cart = (function() {
    function Cart() {
      this.recentCartItemPopUp = bind(this.recentCartItemPopUp, this);
      this.updateCart = bind(this.updateCart, this);
      this.freeshipping_func = bind(this.freeshipping_func, this);
      this.addToCart = bind(this.addToCart, this);
      this.validateSize = bind(this.validateSize, this);
      this.stopResetTimer = bind(this.stopResetTimer, this);
      this.startTimer = bind(this.startTimer, this);
      this.fadeOutCartDropdown = bind(this.fadeOutCartDropdown, this);
      this.openMobileModal = bind(this.openMobileModal, this);
      this.slideDownCartDropdown = bind(this.slideDownCartDropdown, this);
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      _this.cart_dropdown_timer = null;
      _this.listeners();
    }

    Cart.prototype.load = function() {
      var _this;
      return _this = this;
    };

    Cart.prototype.listeners = function() {
      var _this;
      _this = this;
      $('.product-page--cart-form form').off().on('submit', function() {
        _this.addToCart($(this));
        return false;
      });
      $('.recently-added.mobile .close').off().on('click', function() {
        return _this.fadeOutCartDropdown();
      });
      $('.recently-added-mask').off().on('click', function() {
        return _this.fadeOutCartDropdown();
      });
      $('.main-header .recently-added').mouseenter(function() {
        return _this.stopResetTimer();
      });
      return $('.main-header .recently-added').mouseleave(function() {
        return _this.startTimer();
      });
    };

    Cart.prototype.toggleCartDropdown = function() {
      return $('.main-header .recently-added').slideToggle('fast');
    };

    Cart.prototype.slideDownCartDropdown = function() {
      $('.main-header .recently-added').slideDown('fast');
      return $("html, body").animate({
        scrollTop: 0
      });
    };

    Cart.prototype.openMobileModal = function() {
      $('.main-header .recently-added.mobile').fadeIn();
      return $('.main-header .recently-added-mask').removeClass('hide');
    };

    Cart.prototype.fadeOutCartDropdown = function() {
      var _this;
      _this = this;
      clearTimeout(_this.cart_dropdown_timer);
      $('.main-header .recently-added').fadeOut('fast');
      return $('.main-header .recently-added-mask').addClass('hide');
    };

    Cart.prototype.startTimer = function() {
      var _this;
      _this = this;
      return _this.cart_dropdown_timer = setTimeout((function() {
        return _this.fadeOutCartDropdown();
      }), 4000);
    };

    Cart.prototype.stopResetTimer = function() {
      var _this;
      _this = this;
      return clearTimeout(_this.cart_dropdown_timer);
    };

    Cart.prototype.validateSize = function(cart_form) {
      if (cart_form.find('select option:selected').is(':disabled')) {
        cart_form.find('.dropdown').effect('shake', {
          'times': 2,
          'distance': 5
        }, 400);
        return false;
      }
      return true;
    };

    Cart.prototype.addToCart = function(cart_form) {
      var _this, addToCartFail, addToCartPass;
      _this = this;
      addToCartPass = function(product) {
        _this.updateCart();
        return _this.recentCartItemPopUp();
      };
      addToCartFail = function(obj, status) {
        $('.recently-added .error').show();
        $('.recently-added table').hide();
        $('.recently-added div.row').hide();
        _this.slideDownCartDropdown();
        return _this.startTimer();
      };
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: cart_form.serialize(),
        success: addToCartPass,
        error: addToCartFail
      });
    };

    Cart.prototype.recentCartItemPopUp = function() {
      var _this, cart_item, cart_total;
      _this = this;
      cart_item = {};
      cart_total = {};
      return $.getJSON("/cart.js", function(cart, textStatus) {
        var item_trans, new_cart_row, new_mobile_item;
        cart_item.image_url = Shopify.resizeImage(cart.items[0].image, "160x");
        cart_item.url = cart.items[0].url;
        cart_item.title = cart.items[0].title;
        cart_item.price = Shopify.formatMoney(cart.items[0].price, shop_money_format);
        cart_total.price = Shopify.formatMoney(cart.total_price, shop_money_format);
        cart_total.quantity = cart.item_count;
        $('.cart-link .number, .header--mobile--cart-link .number').html(cart_total.quantity);
        $('.cart-link .number-wrapper, .header--mobile--cart-link .number-wrapper').removeClass('hide');
        new_cart_row = '<tr>';
        new_cart_row += '<td class="cart-item">';
        new_cart_row += '<a href="' + cart_item.url + '">';
        new_cart_row += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
        new_cart_row += '</a>';
        new_cart_row += '</td>';
        new_cart_row += '<td class="cart-detail">';
        new_cart_row += '<h2><a href="' + cart_item.url + '">' + cart_item.title + '</a></h2>';
        new_cart_row += '</td>';
        new_cart_row += '<td class="cart-price"><span class="money">' + cart_item.price + '</span></td>';
        new_cart_row += '</tr>';
        new_mobile_item = '<a href="' + cart_item.url + '">';
        new_mobile_item += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
        new_mobile_item += '</a>';
        $('.recently-added tbody').html(new_cart_row);
        $('.recently-added .mobile-item').html(new_mobile_item);
        if (cart_total.quantity > 1) {
          item_trans = theme.translations.cart_items;
        } else {
          item_trans = theme.translations.cart_item;
        }
        $('.recently-added .items-count').html('<a href="/cart"> <span class="number">' + cart_total.quantity + '</span> ' + item_trans + '</a>');
        $('.recently-added .total-price').html(cart_total.price);
        if (currency_switcher_enabled) {
          $.each($('.recently-added .total-price').get(0).attributes, function(i, attrib) {
            if (attrib.name.match("^data-currency")) {
              return $('.recently-added .total-price').attr(attrib.name, "");
            }
          });
          Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
        }
        $('.recently-added .error').hide();
        $('.recently-added table, .recently-added div.row').show();
        if (theme.utils.mqs.current_window === 'small') {
          _this.openMobileModal();
        } else {
          _this.slideDownCartDropdown();
        }
        return _this.startTimer();
      });
    };

    Cart.prototype.updateCart = function() {
      var _this;
      _this = this;
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json"
      }).done(function(data, textStatus, jqXHR) {
        if (data.items.length == 0) {
          $("#shopify-section-cart .cart > div").css('display', 'none');
          $("#shopify-section-cart .cart > form").css('display', 'none');
          $("#shopify-section-cart .cart > section").css('display', 'block');
          $(".header--mobile--cart-link .number-wrapper").css("display", "none");
        }
        else {
          var cart, ref, item, cartData;
          if (textStatus === 'success') {
            cart = data;
            ref = cart.items;
            for (let i = 0; i < ref.length; i++) {
              item = ref[i];
              j = i + 1;
              cartData += '<tr class="cart__row" data-cart-item="" data-cart-item-key="' + item.key + '"';
              cartData += '  data-cart-item-url="' + item.url + '" data-cart-item-title="' + item.title + '"';
              cartData += '  data-cart-item-index="' + j + '" data-cart-item-quantity="' + item.quantity + '">';
              cartData += '  <td class="image">';
              cartData += '    <a href="' + item.url + '">';
              cartData += '      <div class="image--root" data-aspectratio="' + item.featured_image.aspect_ratio + '" style="width: ' + item.featured_image.height * item.featured_image.aspect_ratio + 'px;">';
              cartData += '        <div class="image--container" style="padding-top:' + 100 / item.featured_image.aspect_ratio + '%;">';
              cartData += '          <img';
              cartData += '            class="lazyload lazypreload"';
              cartData += '            data-src="' + item.image + '"';
              cartData += '            data-sizes="auto"';
              cartData += '            data-widths="[295,394,590,700,800,1000,1200,1500,1800,2000,2400]"';
              cartData += '            data-aspectratio="' + item.featured_image.aspect_ratio + '"';
              cartData += '            alt="' + item.featured_image.alt + '"';
              cartData += '          >';
              cartData += '        </div>';
              cartData += '        <noscript>';
              cartData += '          <img';
              cartData += '            src="' + item.image + '"';
              cartData += '            alt="' + item.title + '">';
              cartData += '        </noscript>';
              cartData += '      </div>';
              cartData += '    </a>';
              cartData += '    <p class="mobile-title">';
              cartData += '      <a href="' + item.url + '">' + item.title + '</a>';
              cartData += '      <span class="remove">';
              cartData += '        <a title="Remove" href="/cart/change?line=' + j + '&quantity=0" class="cross" tabindex="0">';
              cartData += '          Remove';
              cartData += '        </a>';
              cartData += '      </span>';
              cartData += '    </p>';
              cartData += '  </td>';
              cartData += '  <td class="title">';
              cartData += '    <p><a href="' + item.url + '">' + item.title + '</a></p>';
              cartData += '  </td>';
              cartData += '  <td class="quantity"><input type="text" class="field styled-input" name="updates[]" value="' + item.quantity + '"></td>';
              cartData += '  <td class="total">';
              cartData += '    <span class="money">' + Shopify.formatMoney(item.line_price, theme.money_format) + '</span>';
              cartData += '    <span class="quantity">';
              cartData += '      <label for="Quantity">Qty</label>';
              cartData += '      <input type="text" class="field styled-input" name="updates[]" value="' + item.quantity + '">';
              cartData += '    </span>';
              cartData += '  </td>';
              cartData += '  <td class="remove">';
              cartData += '    <a title="Remove" href="/cart/change?line=' + j + '&quantity=0" class="cross" tabindex="0">';
              cartData += '      <svg class="fw--icon fw--icon--cross">';
              cartData += '        <use xlink:href="#fw--icon--cross"></use>';
              cartData += '      </svg>';
              cartData += '    </a>';
              cartData += '  </td>';
              cartData += '</tr>';
            }
            $(".drawer-cart .cart-table tbody").html(cartData);

            $(".totals span.money").html(Shopify.formatMoney(cart.total_price, theme.money_format));
            $(".header--mobile--cart-link .number-wrapper .number").html(cart.item_count);
  
            _this.freeshipping_func();
            if (ref.length > 0) {
              $('.drawer-cart .empty-cart').hide();
              $('.drawer-cart form').show();
            } else {

            }
          } else {
            console.log('cart - update totals item status - ' + textStatus);
          }
        }
      }).fail(function(jqXHR, textStatus) {
        console.log("cart - updating totals failed");
      });
    }

    Cart.prototype.freeshipping_func = function() {
      var message_block = $("#shopify-section-cart .free-shipping-message p");
      var sum = 0;
      
      $("#shopify-section-cart.shopify-section .cart-table tbody tr").each(function() {
        money = $(this).find(".total .money").text();
        sum += Number(money.substr(1));
      });
      var subtotal = 100 - sum;
      
      if (subtotal <= 0) {
        if (message_block.hasClass('hide-message')) {
          message_block.removeClass('hide-message');
        }
        $("#shopify-section-cart .free-shipping-message .skin-bar").css("width", "100%");
        var text = "You are qualified for free shipping";
      } else {
        if (message_block.hasClass('hide-message')) {
          message_block.removeClass('hide-message');
        }
        var rest_amount = subtotal.toFixed(2);
        var text = "only $"+rest_amount+" away from free shipping";
        $("#shopify-section-cart .free-shipping-message .skin-bar").css("width", (sum / 100 * 100)+"%");
      }
      $("#shopify-section-cart .free-shipping-message p").text(text);
    }  

    return Cart;

  })();

  Collection = (function() {
    function Collection() {
      DOC.on('change', '.tags-listbox', function() {
        var collFilters, newTags, query;
        newTags = [];
        collFilters = $(this);
        collFilters.each(function(index, element) {
          if ($(this).val()) {
            return newTags.push($(this).val());
          }
        });
        if (newTags.length) {
          query = newTags.join('+');
          return window.location.href = $(theme.collection.tag).attr('href').replace('tag', query);
        } else {
          if (theme.collection.handle) {
            return window.location.href = '/collections/' + theme.collection.handle;
          } else if (theme.collection.products.first_type === theme.collection.title) {
            return window.location.href = theme.collection.url_for_type;
          } else if (theme.collection.products.first_vendor === theme.collection.title) {
            return window.location.href = theme.collection.url_for_vendor;
          }
        }
      });
    }

    return Collection;

  })();

  Password = (function() {
    function Password() {
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      _this.listeners();
      _this.load();
    }

    Password.prototype.load = function() {
      var _this;
      _this = this;
      if ($('.login-form .errors').size()) {
        return $('.login-link').click();
      }
    };

    Password.prototype.listeners = function() {
      var _this;
      _this = this;
      DOC.on('click', '.login-link', function() {
        $(this).css('visibility', 'hidden');
        $(".wrapper").hide();
        $('.login-form').css('visibility', 'visible').find($('[name=password]').focus());
        return false;
      });
      return DOC.on('click', '.login-form .cancel', function() {
        $(".login-link").css('visibility', 'visible');
        $(".wrapper").fadeIn();
        $('.login-form').css('visibility', 'hidden');
        return false;
      });
    };

    return Password;

  })();

  theme.classes.ProductPage = (function() {
    function ProductPage(root) {
      var _this;
      this.root = root;
      this.cssGridFallback = bind(this.cssGridFallback, this);
      this.modalCloseListener = bind(this.modalCloseListener, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.imageZoom = bind(this.imageZoom, this);
      this.getActiveImageId = bind(this.getActiveImageId, this);
      this.updateVariantImage = bind(this.updateVariantImage, this);
      this.thumbListener = bind(this.thumbListener, this);
      this.variantSelected = bind(this.variantSelected, this);
      this.sizeChart = bind(this.sizeChart, this);
      this.updateLowInStock = bind(this.updateLowInStock, this);
      this.getVariantQuantity = bind(this.getVariantQuantity, this);
      this.getLowInStockAmount = bind(this.getLowInStockAmount, this);
      this.getLowInStockMessage = bind(this.getLowInStockMessage, this);
      this.mobileModalHandler = bind(this.mobileModalHandler, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.thumbs = _this.root.find('.product-page--thumb');
      _this.main_images = _this.root.find('.product-page--image');
      _this.zoom_images = _this.root.find('.product-page--zoom-image');
      _this.image_container = _this.root.find('.product-page--images-container');
      _this.magnify = parseFloat(_this.root.data('magnify'));
      _this.size_chart_enabled = _this.root.data('size-chart-enabled');
      _this.size_chart_option = _this.root.data('size-chart-option').toLowerCase();
      _this.load();
    }

    ProductPage.prototype.load = function() {
      var _this, photos;
      _this = this;
      _this.cssGridFallback();
      _this.thumbListener();
      _this.imageZoom();
      _this.resizeListeners();
      _this.modalCloseListener();
      _this.mobileModalHandler();
      _this.root.on('theme:section:load', function() {
        new Cart();
        new Accordion();
        new HorizontalTabs();
        new VerticalTabs();
        return new Shopify.OptionSelectors('variant-listbox', {
          product: product_json,
          onVariantSelected: _this.variantSelected,
          enableHistoryState: true
        });
      });
      photos = $('article .photos');
      DOC.on('click', '.size-chart-trigger', function(e) {
        e.preventDefault();
        return new Popup('size-chart-container');
      });
      photos.on('click', function() {
        return false;
      });
      $("article .custom.dropdown").hide();
      if (product_options_size === 1 && product_options_first !== "Title") {
        return $(".selector-wrapper:eq(0)").prepend("<label>" + product_options_first + "</label>");
      }
    };

    ProductPage.prototype.mobileModalHandler = function() {
      var _this, modal_links;
      _this = this;
      modal_links = _this.image_container.find('.modal--link');
      return modal_links.on('click', function(e) {
        if (theme.utils.mqs.current_window === 'small') {
          return e.stopImmediatePropagation();
        }
      });
    };

    ProductPage.prototype.getLowInStockMessage = function(quantity) {
      var _this, message;
      _this = this;
      message = quantity === 1 ? theme.products.low_in_stock.one : theme.products.low_in_stock.other;
      if (quantity > 1) {
        message = message.replace(/\d+/, quantity);
      }
      return message;
    };

    ProductPage.prototype.getLowInStockAmount = function() {
      var _this;
      _this = this;
      return _this.root.data('product-low-in-stock-amount');
    };

    ProductPage.prototype.getVariantQuantity = function(variant) {
      var option;
      option = $('#variant-listbox').find('[value="' + variant.id + '"]');
      if (option.length > 0) {
        return parseInt(option.data('inventory-quantity'));
      } else {
        return 'not available';
      }
    };

    ProductPage.prototype.updateLowInStock = function(variant) {
      var _this, quantity, threshold;
      _this = this;
      quantity = _this.getVariantQuantity(variant);
      threshold = _this.getLowInStockAmount();
      if (threshold === 'undefined') {
        return false;
      }
      if (quantity > 0 && quantity <= threshold) {
        $('.product-low-in-stock').html('<p>Low Inventory</p>').show();
      } else {
        $('.product-low-in-stock').hide();
      }
      return DOC.on('.shopify-section section--products shopify:section:select', function() {
        return _this.updateLowInStock(variant);
      });
    };

    ProductPage.prototype.sizeChart = function(product_options) {
      var _this;
      _this = this;
      if (!_this.size_chart_enabled) {
        return;
      }
      return $('.selector-wrapper').each(function(index, element) {
        if (product_options[index].toLowerCase() === _this.size_chart_option && $(element).find('.size-chart-trigger').length === 0) {
          return $(element).append('<a class="size-chart-trigger" href="#">' + theme.products.size_chart.label + '</a>');
        }
      });
    };

    ProductPage.prototype.variantSelected = function(variant, selector, options) {
      var _this, actual_price, compare_price, show_low_in_stock;
      _this = this;
      $(".compare-price").html("");
      $('.product-unavailable [type="submit"]').prop("disabled", true);
      if (variant && variant.available) {
        $(".quanity-cart-row, .product-page--smart-payment-buttons").show();
        $('.product-unavailable').hide();
      } else {
        $(".quanity-cart-row, .product-page--smart-payment-buttons").hide();
        $('.product-unavailable').show();
        $('.product-low-in-stock').hide();
        $('.product-unavailable [type="submit"]').prop("disabled", false);
        if (product_variant_size > 1 && variant) {
          $('.product-unavailable form .email-body').attr('value', 'Please notify me when this is back in stock: ' + product_title + ' - ' + variant.title);
        }
      }
      if (variant) {
        actual_price = Shopify.formatMoney(variant.price, shop_money_format);
        $(".actual-price").replaceWith('<span class="actual-price money" itemprop="price">' + actual_price + '</span>');
        if (variant.compare_at_price > variant.price) {
          compare_price = Shopify.formatMoney(variant.compare_at_price, shop_money_format);
          $(".compare-price").html(product_language_was + ' <span class="money">' + compare_price + '</span>');
        }
        if (currency_switcher_enabled) {
          Currency.convertAll(shopCurrency, $('[name=currencies]').val());
        }
        if (variant.featured_image) {
          _this.updateVariantImage(variant.featured_image.id);
        }
      }
      if (variant && variant.available) {
        $('#BIS_trigger').hide(); // hide the button
      } else {
        $('#BIS_trigger').show().attr('data-variant-id', variant.id).css( "display", "block" ); // show the button and set the default variant
      }
      show_low_in_stock = _this.getLowInStockAmount() === false ? false : true;
      if (show_low_in_stock === true) {
        _this.updateLowInStock(variant);
      }
      _this.sizeChart(selector.product.options);
    };

    ProductPage.prototype.thumbListener = function() {
      var _this;
      _this = this;
      return _this.thumbs.on('keypress click', function(e) {
        var variant_id;
        if (theme.utils.a11yClick(e)) {
          variant_id = $(this).data('id');
          _this.updateVariantImage(variant_id);
        }
        return _this.imageZoom();
      });
    };

    ProductPage.prototype.updateVariantImage = function(variant_id) {
      var _this, variant_image, variant_thumb;
      _this = this;
      _this.main_images.attr('data-active', 'false');
      variant_image = _this.main_images.filter('[data-id="' + variant_id + '"]');
      variant_image.attr('data-active', 'true');
      _this.thumbs.attr('data-active', 'false');
      variant_thumb = _this.thumbs.filter('[data-id="' + variant_id + '"]');
      variant_thumb.attr('data-active', 'true');
      return _this.imageZoom();
    };

    ProductPage.prototype.getActiveImageId = function() {
      var _this, active_image, active_image_id;
      _this = this;
      active_image = _this.main_images.filter('[data-active="true"]');
      active_image_id = active_image.data('id');
      return active_image_id;
    };

    ProductPage.prototype.imageZoom = function() {
      var _this, active_zoom_image, aspect_ratio, left_position, top_position, wrapper_height, wrapper_width, x_ratio, y_ratio;
      _this = this;
      if (_this.root.data('zoom-enabled') === false) {
        return;
      }
      _this.image_container.off('mouseenter.ProductPage.imageZoom');
      _this.image_container.off('mouseleave.ProductPage.imageZoom');
      _this.zoom_images.css('display', 'none');
      active_zoom_image = _this.zoom_images.filter('[data-id="' + _this.getActiveImageId() + '"]');
      aspect_ratio = active_zoom_image.data('aspect-ratio');
      wrapper_width = _this.image_container.width();
      wrapper_height = _this.image_container.height();
      active_zoom_image.find('.image--root').css('width', wrapper_width * _this.magnify);
      top_position = _this.image_container.offset().top;
      left_position = _this.image_container.offset().left;
      x_ratio = (wrapper_width * _this.magnify - wrapper_width) / wrapper_width;
      y_ratio = (wrapper_height * _this.magnify - wrapper_height) / wrapper_height;
      _this.image_container.on('mouseenter.ProductPage.imageZoom', function() {
        return active_zoom_image.css('display', 'block');
      });
      _this.image_container.on('mouseleave.ProductPage.imageZoom', function() {
        return active_zoom_image.css('display', 'none');
      });
      return _this.image_container.on('mousemove', function(e) {
        var relative_left, relative_top;
        relative_left = e.pageX - left_position;
        relative_top = e.pageY - top_position;
        return active_zoom_image.css({
          'left': relative_left * -x_ratio,
          'top': relative_top * -y_ratio
        });
      });
    };

    ProductPage.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.ProductPage', theme.utils.debounce(100, function() {
        return _this.imageZoom();
      }));
    };

    ProductPage.prototype.modalCloseListener = function() {
      var _this;
      _this = this;
      return $(window).on('FrameworkModal.afterClose', function() {
        return _this.imageZoom();
      });
    };

    ProductPage.prototype.cssGridFallback = function() {
      var _this;
      _this = this;
      if (!Modernizr.cssgrid) {
        $('.product-page--title-n-vendor, .product-page--cart-form-block, .product-page--description').wrapAll('<div class="product-page--no-grid--left-column"></div>');
        return $('.product-page--images').wrapAll('<div class="product-page--no-grid--right-column"></div>');
      }
    };

    return ProductPage;

  })();

  theme.classes.Utils = (function(superClass) {
    extend(Utils, superClass);

    function Utils() {
      var _this;
      _this = this;
      _this.sections = new theme.classes.Sections();
      _this.mqs = new theme.classes.FrameworkMediaQueries();
    }

    Utils.prototype.transparentMenuIsEnabled = function() {
      return PAGE.find("[data-header--menu-transparent=true]").length > 0;
    };

    Utils.prototype.loadJsClasses = function() {
      return $('[data-js-class]').each(function() {
        var js_class, partial_class;
        js_class = $(this).attr('data-js-class');
        if ($(this).attr('data-js-loaded') !== 'true') {
          partial_class = theme.classes[js_class];
          if (typeof partial_class !== "undefined") {
            theme.partials[js_class] = new partial_class($(this));
            return $(this).attr('data-js-loaded', 'true');
          }
        }
      });
    };

    Utils.prototype.addSymbol = function(icon_name) {
      return '<svg class="fw--icon fw--icon--' + icon_name + '"> <use xlink:href="#fw--icon--' + icon_name + '" /> </svg>';
    };

    Utils.prototype.isIE11 = function() {
      if (!!window.MSInputMethodContext && !!document.documentMode) {
        return true;
      }
      return false;
    };

    return Utils;

  })(theme.classes.FrameworkUtils);

  PAGE = null;

  DOC = null;

  WINDOW = null;

  HEADER = null;

  touchevents_exist = null;

  mq_small = null;

  mq_medium = null;

  mq_large = null;

  log = null;

  current_window = '';

  jQuery(function($) {
    var first_article_img, isFirefox, page_content, pinterest_button;
    PAGE = $('body');
    DOC = $(document);
    WINDOW = $(window);
    HEADER = $('.main-header');
    touchevents_exist = Modernizr.touchevents;
    mq_small = 768;
    mq_medium = 1280;
    mq_large = 1440;
    theme.utils = new theme.classes.Utils();
    if (general_external_links_enabled) {
      $('a[href^="http"]').not('a[href^="' + shop_url + '"]').attr('target', '_blank');
    }
    new Popup('popup');
    new Footer($('.footer'));
    new Accordion();
    new HorizontalTabs();
    new VerticalTabs();
    theme.partials.cart = new Cart();
    new PromoBar($('.promo-bar'));
    if (PAGE.hasClass('template-page')) {
      page_content = $('.page-content .rte-content');
      if (page_content.find('.left-side-column').length || page_content.find('.right-side-column').length) {
        if (page_content.find('.left-side-column').length && page_content.find('.right-side-column').length) {
          page_content.wrapInner("<div class='main-column with-2-sidebars'></div>");
          $('.left-side-column').addClass('with-2-sidebars');
          $('.right-side-column').addClass('with-2-sidebars');
        } else {
          page_content.wrapInner("<div class='main-column'></div>");
        }
        $('.left-side-column').prependTo(page_content);
        $('.right-side-column').appendTo(page_content);
      }
    }
    if (PAGE.hasClass('template-index')) {
      $('.slider').each(function() {
        return new FullscreenSlider($(this).find('.slides'));
      });
      $('.product-slider').each(function() {
        return new ProductSlider($(this));
      });
    }
    if (PAGE.hasClass('template-collection')) {
      new Collection();
    }
    if (PAGE.hasClass('template-article')) {
      pinterest_button = $('.social-share .pinterest');
      first_article_img = $('.article img').first().attr('src');
      pinterest_button.attr('href', pinterest_button.attr('href') + '&media=' + first_article_img);
    }
    if ($('.section--password').length > 0) {
      new Password();
    }
    isFirefox = typeof InstallTrigger !== "undefined";
    if (isFirefox) {
      $('img').addClass('image-scale-hack');
    }
    if (touchevents_exist) {
      $("form.custom .hidden-field").removeClass('hidden-field');
    }
    current_window = '';
    new MediaQueries();
    $('.hide-until-js').show();
    DOC.on('shopify:section:load', function(e) {
      var section_wrapper;
      section_wrapper = $(e.target).closest('.shopify-section');
      section_wrapper.css('min-height', '2000px');
      if (section_wrapper.hasClass('section--slideshow')) {
        new FullscreenSlider($(e.target).find('.slides'));
      } else if (section_wrapper.hasClass('section--featured-collection')) {
        new ProductSlider($(e.target).find('.product-slider'));
      } else if (section_wrapper.hasClass('section--header')) {
        setTimeout(function() {
          if ($('.slider').length > 0) {
            return DOC.trigger('header.transparentMenuIsUpdated');
          }
        }, 0);
        new PromoBar($('.promo-bar'));
      } else if (section_wrapper.hasClass('section--products')) {
        DOC.trigger('set-option-selectors');
      }
      return section_wrapper.css('min-height', 'auto');
    });
    DOC.on('shopify:section:unload', function(e) {
      var mask, section_wrapper;
      section_wrapper = $(e.target).closest('.shopify-section');
      if (section_wrapper.hasClass('section--featured-collection')) {
        return setTimeout((function() {
          if ($('.section--featured-collection').length === 0) {
            return WINDOW.off("resize.ProductSlider");
          }
        }), 0);
      } else if (section_wrapper.hasClass('section--products')) {
        mask = $(".popup-modal-mask");
        $(".size-chart").remove();
        if (mask.is(":visible")) {
          return mask.trigger("click");
        }
      } else if (section_wrapper.hasClass('section--slideshow')) {
        return setTimeout(function() {
          if ($('.slider').length === 0) {
            return DOC.off('header.transparentMenuIsUpdated');
          }
        }, 0);
      }
    });
    DOC.on('shopify:block:select', function(e) {
      var section_wrapper, slide_selected;
      section_wrapper = $(e.target).closest('.shopify-section');
      if (section_wrapper.hasClass('section--slideshow')) {
        slide_selected = section_wrapper.find('.slide').index(e.target);
        return $(e.target).closest('.owl-carousel').trigger('owl.jumpTo', slide_selected).trigger('owl.stop');
      }
    });
    DOC.on('shopify:section:deselect', function(e) {
      var section_wrapper, should_autoplay, slider;
      section_wrapper = $(e.target).closest('.shopify-section');
      if (section_wrapper.hasClass('section--slideshow')) {
        should_autoplay = section_wrapper.find('.slider').data('autoplay');
        if (should_autoplay === true) {
          slider = section_wrapper.find('.slides');
          return slider.trigger('owl.play', section_wrapper.find('.slider').data('rotateFrequency'));
        }
      }
    });
    theme.utils.loadJsClasses();
    return false;
  });

}).call(this);

/**
 * DMC SEO - Headings checker
 *
 * @since 1 Mar 2020
 * @version 1.1
 */
function dmc_seo_headings_checker() {
    console.log('====================================');
    console.log('|| DMC SEO Headings Checker version 1.3 START ||');
    console.log('====================================');
    var h1 = jQuery('h1');
    var h2 = jQuery('h2');
    var h3 = jQuery('h3');
    var h4 = jQuery('h4');
    var h5 = jQuery('h5');
    var h6 = jQuery('h6');

    if(!h1.length) {
        console.log('ERROR: H1 was not found. That\'s pretty bad. Fix it!');
    } else if(h1.length > 1){
        console.log('ERROR: H1 was found multiple times. That\'s not the way to do it. Leave only 1 alive!');
    } else {
        console.log('WARNING: H1 text is empty.');
        var h1_logo = h1.find('img');
        if ( h1_logo.length ) {
            if ( h1_logo.attr('alt') !== '' ) {
                console.log('GOOD THING: H1 has an image. It has the followig ALT text: ' + h1_logo.attr('alt') );
            } else {
                console.log('ERROR: H1 image des not have an ALT text.');
            }
        } else {
            console.log('ERROR: H1 text is empty and does not hve an image');
        }
    }
    if(!h2.length) {
        console.log('WARNING: H2 was not found. You should add one if you feel like it.');
    }
    if(!h3.length) {
        console.log('WARNING: H3 was not found. I mean, who needs them anyway, right?');
    }
    if(h2.length) {
        h2.each(function() {
            if(jQuery(this).text() === '') {
                console.log('WARNING: There is an empty H2.');
            }
        });
    }
    if(h3.length) {
        h3.each(function() {
            if(jQuery(this).text() === '') {
                console.log('WARNING: There is an empty H3.');
            }
        });
    }
    if(h4.length) {
        h4.each(function() {
            if(jQuery(this).text() === '') {
                console.log('WARNING: There is an empty H4.');
            }
        });
    }
    if(h5.length) {
        h5.each(function() {
            if(jQuery(this).text() === '') {
                console.log('WARNING: There is an empty H5.');
            }
        });
    }
    if(h6.length) {
        h6.each(function() {
            if(jQuery(this).text() === '') {
                console.log('WARNING: There is an empty H6.');
            }
        });
    }


    var latestMissing = 0;
    var latestFound;

    for(var i = 1; i <= 6; i++) {
        var headings = jQuery('h'+i);
        if(headings.length) {
            latestFound = i;
        } else if(latestMissing === 0){
            latestMissing = i;
        }
    }

    if(latestFound > latestMissing) {
        console.log('WARNING: Hierarchy broken. I found H'+latestFound+', but H'+latestMissing+' is missing!');
    }

    console.log('------------------------------------');
    console.log('|          Found Headings          |');
    console.log('------------------------------------');

    if(h1.length) {
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
        console.log('                 H1                 ');
        h1.each(function() {
            console.log('H1['+jQuery(this).text()+']');
        });
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    }
    if(h2.length) {
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
        console.log('                 H2                 ');
        h2.each(function() {
            console.log('H2['+jQuery(this).text()+']');
        });
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    }
    if(h3.length) {
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
        console.log('                 H3                 ');
        h3.each(function() {
            console.log('H3['+jQuery(this).text()+']');
        });
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    }
    if(h4.length) {
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
        console.log('                 H4                 ');
        h4.each(function() {
            console.log('H4['+jQuery(this).text()+']');
        });
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    }
    if(h5.length) {
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
        console.log('                 H5                 ');
        h5.each(function() {
            console.log('H5['+jQuery(this).text()+']');
        });
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    }
    if(h6.length) {
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
        console.log('                 H6                 ');
        h6.each(function() {
            console.log('H6['+jQuery(this).text()+']');
        });
        console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    }
    console.log('====================================');
    console.log('||  DMC SEO Headings Checker END  ||');
    console.log('====================================');
}

function check_partial_unavailable_products() {
  var button = jQuery('#BIS_trigger');
  var outcome = '';
  if ( button.length ) {
    if ( ! button.is(':visible') ) {
      button.show();
      outcome = 'good now';
    } else {
      outcome = 'good';
    }
  } else {
    outcome = 'not found';
  }
  return outcome;
}

var ava_timer = 0;
function re_check_unavailable_sizes() {
  var result = check_partial_unavailable_products();
  if ( result === 'not found' && ava_timer <= 20 ) {
    ava_timer++;
    setTimeout( function() {
      re_check_unavailable_sizes();
    }, 500 );
  }
}

jQuery( window ).on( 'load', function() {
  // Check if is a product page
  if ( jQuery('.dmc-single-product').length ) {
    re_check_unavailable_sizes();
  }
  
  setTimeout( function() {
    var single_product_variants = jQuery('.dmc-single-product .variants');

    if ( single_product_variants.size() ) {
      var variants_radios = single_product_variants.find('input[type="radio"]');
      var current_variant = single_product_variants.find('.bcpo-label .bcpo-value').text();
      if ( dmc_single_product_low_inventory[ current_variant ] === 0 ) {
        jQuery('.dmc-low-inventory-tag').show();
      } else {
        jQuery('.dmc-low-inventory-tag').hide();
      }
      variants_radios.on( 'change', function() {
        var this_input = jQuery(this);
        if ( dmc_single_product_low_inventory[ this_input.val() ] === 0 ) {
          jQuery('.dmc-low-inventory-tag').show();
        } else {
          jQuery('.dmc-low-inventory-tag').hide();
        }
      });
    }
  }, 1000 );
  
  
  
  
  /**
   * DMC - Get URL parameters
   *
   * @since 7 July 2020
   * @version 1.0
   */
  function dmc_core_get_url_params() {
      return new URLSearchParams( window.location.search );
  }

  /**
   * DMC - Add preview class to Body
   *
   * @param i
   *
   * @since 7 July 2020
   * @version 1.0
   */
  function dmc_core_body_preview_class( i ) {
      const params = dmc_core_get_url_params();
      const dmc_preview = params.get('dmc-preview');
      if ( dmc_preview == i ) {
          jQuery('body').addClass('dmc-preview-' + i);
      }
  }
  // dmc_core_body_preview_class( 1 );
  
  function dmc_register_expandable_things() {
    var sections = jQuery('.dmc-expandable-holder');
    sections.each( function() {
      var section = jQuery(this);
      var trigger = section.find('.dmc-expandable-trigger');
      var content = section.find('.dmc-expandable-content');
      trigger.click( function() {
        if ( section.hasClass('dmc-expanded') ) {
          content.slideUp();
          section.removeClass('dmc-expanded');
        } else {
          content.slideDown();
          section.addClass('dmc-expanded');
        }
      });
    });
  }
  dmc_register_expandable_things();

  $(".similar-products .product-grid--root").slick({
    dots: false,
    infinite: true,
    speed: 300,
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    responsive: [
      {
       breakpoint: 749,
       settings: "unslick"
      }
    ]
  });

  function updateAjaxCart(that, value, index) {
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: 'quantity=' + value + '&line=' + index
    }).done(function(data, textStatus, jqXHR) {
      if (value == 0) {
        $(that).parents("tr.cart__row").remove();
      }
      if (textStatus === 'success') {
        theme.partials.cart.updateCart();
      } else {
        console.log('cart - update cart item status - ' + textStatus);
      }
    }).fail(function(jqXHR, textStatus) {
      console.log("cart - update failed");
    });
  }

  theme.partials.cart.freeshipping_func();

  $("#shopify-section-cart").on("change", ".quantity input", function() {
    var value = $(this).val();
    var index = $(this).parents("tr.cart__row").data("cart-item-index");
    var isValidValue = !(value < 0 || isNaN(value));
    if(isValidValue) {
      updateAjaxCart($(this), value, index);
    }
  });

  $("#shopify-section-cart").on("click", ".cart-table .remove a", function(e) {
    e.preventDefault();
    e.stopPropagation();
    var index = $(this).parents("tr.cart__row").data("cart-item-index");
    updateAjaxCart($(this), 0, index);
  });
  // Setup listeners to add/subtract from the input
  $('.js-qty__adjust').off().on('click', function() {
    var el = $(this),
        qtySelector = el.siblings('.js-qty__num'),
        qty = parseInt(qtySelector.val().replace(/\D/g, ''));

        // Make sure we have a valid integer
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
  // Add or subtract from the current quantity
    if (el.hasClass('js-qty__adjust--plus')) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 1) qty = 1;
    }
    // Update the input's number
    qtySelector.val(qty).trigger('change');
  });
// 3. 10


  $(document).on('click', ".dmc-product-size:not(.not-available)", function (e) {

    e.preventDefault();
    e.stopPropagation();
    
    if ($(this).hasClass("active")) {
      $(".dmc-product-size").removeClass("active");
    }
    else {
      $(".dmc-product-size").removeClass("active");
      $(this).addClass('active');  
    }
    $('.add-to-cart.on-collection').removeClass('active');
    if ($(".dmc-product-size").hasClass("active")) {
      $(this).parents('.dmc-link-wrapper').find('.add-to-cart.on-collection').addClass('active');      
    }
    else {
      $(this).parents('.dmc-link-wrapper').find('.add-to-cart.on-collection').removeClass('active');
    }
  });

  // $(".add-to-cart.on-collection .button--secondary").on('click', function (e) {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   var $cart_btn = $(this);
  //   id = $(".dmc-product-size.active").data('id');

  //   $.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     dataType: "json",
  //     data: 'quantity=1&id=' + id
  //   }).done(function(data, textStatus, jqXHR) {
  //     if (textStatus === 'success') {
  //       theme.partials.cart.recentCartItemPopUp();
  //       theme.partials.cart.updateCart();
  //       if ($cart_btn.hasClass('cart-page-button')) {
  //         location = '/cart'
  //       }
  //     } else {
  //       console.log('cart - add cart item status - ' + textStatus);
  //     }
  //   }).fail(function(jqXHR, textStatus) {
  //     console.log("cart - add failed");
  //   });
  // });

  // $(".header--mobile--cart-link").on("click", function(e) {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   $(".drawer-cart.template-cart").css("display", "block");
  //   $(".off-canvas--main-content").css("display", "none");
  // });

  $(".close-drawer-cart span").on("click", function() {
    $(".drawer-cart.template-cart").css("display", "none");
    $(".off-canvas--main-content").css("display", "block");
  });
  console.log(window.top.location.href)
  var url = window.top.location.href.split('?')[0];
  if (url.indexOf('collections') > -1) {
    var params = url.split("/");
    var handle = params[params.length-1];
    var collections = $('.security_popup--container').data('collections');
    var key = $('.security_popup--container').data('key');
    var login_status = $.session.get('security_collection_login');
    if (collections.indexOf(handle) > -1) {
      if (login_status != 'true') {
        $('.security_popup--container .popup').addClass('active');
        $('html').addClass('stop-scroll');
      }
    } else {
      $.session.remove('security_collection_login');
    }

    $('.security_popup--container .popup #password_form .form-group .submit').on('click', function (e) {
      e.preventDefault();
      var val = $('.security_popup--container .popup #password_form .form-group .password').val();
      if (val != null) {
        var hash = md5(val);
        if (hash == key) {
          $.session.set('security_collection_login', 'true');
          $('.security_popup--container .popup #password_form .alert').text("you're in!");
          $('.security_popup--container .popup #password_form .alert').addClass('success');
          setTimeout(() => {
            $('.security_popup--container .popup').removeClass('active');
            $('html').removeClass('stop-scroll');
          }, 1000);
        } else {
          $('.security_popup--container .popup #password_form .alert').text('The password is wrong!');
          $('.security_popup--container .popup #password_form .alert').addClass('error');
        }
      }
    })
    $('.security_popup--container .popup #password_form a[href="#signup_form"]').on('click', function (e) {
      e.preventDefault();
      $('.security_popup--container .popup #signup_form').addClass('active');
    });
    $('.security_popup--container .popup #signup_form a[href="#password_form"]').on('click', function (e) {
      e.preventDefault();
      $('.security_popup--container .popup #signup_form').removeClass('active');
    })
  } else {
    $.session.remove('security_collection_login');
  }
  
});
